var items = {
  "block.minecraft.acacia_button": "uoʇʇnᗺ ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_door": "ɹooᗡ ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_fence": "ǝɔuǝℲ ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_leaves": "sǝʌɐǝꞀ ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_log": "ᵷoꞀ ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_planks": "sʞuɐꞁԀ ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_sapling": "ᵷuᴉꞁdɐS ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_shelf": "ɟlǝɥS ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_sign": "uᵷᴉS ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_slab": "qɐꞁS ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_stairs": "sɹᴉɐʇS ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_trapdoor": "ɹoopdɐɹ⟘ ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_wall_sign": "uᵷᴉS ꞁꞁɐM ɐᴉɔɐɔⱯ",
  "block.minecraft.acacia_wood": "pooM ɐᴉɔɐɔⱯ",
  "block.minecraft.activator_rail": "ꞁᴉɐᴚ ɹoʇɐʌᴉʇɔⱯ",
  "block.minecraft.air": "ɹᴉⱯ",
  "block.minecraft.allium": "ɯnᴉꞁꞁⱯ",
  "block.minecraft.amethyst_block": "ʇsʎɥʇǝɯⱯ ɟo ʞɔoꞁᗺ",
  "block.minecraft.amethyst_cluster": "ɹǝʇsnꞁƆ ʇsʎɥʇǝɯⱯ",
  "block.minecraft.ancient_debris": "sᴉɹqǝᗡ ʇuǝᴉɔuⱯ",
  "block.minecraft.andesite": "ǝʇᴉsǝpuⱯ",
  "block.minecraft.andesite_slab": "qɐꞁS ǝʇᴉsǝpuⱯ",
  "block.minecraft.andesite_stairs": "sɹᴉɐʇS ǝʇᴉsǝpuⱯ",
  "block.minecraft.andesite_wall": "ꞁꞁɐM ǝʇᴉsǝpuⱯ",
  "block.minecraft.anvil": "ꞁᴉʌuⱯ",
  "block.minecraft.attached_melon_stem": "ɯǝʇS uoꞁǝW pǝɥɔɐʇʇⱯ",
  "block.minecraft.attached_pumpkin_stem": "ɯǝʇS uᴉʞdɯnԀ pǝɥɔɐʇʇⱯ",
  "block.minecraft.azalea": "ɐǝꞁɐzⱯ",
  "block.minecraft.azalea_leaves": "sǝʌɐǝꞀ ɐǝꞁɐzⱯ",
  "block.minecraft.azure_bluet": "ʇǝnꞁᗺ ǝɹnzⱯ",
  "block.minecraft.bamboo": "ooqɯɐᗺ",
  "block.minecraft.bamboo_block": "ooqɯɐᗺ ɟo ʞɔoꞁᗺ",
  "block.minecraft.bamboo_button": "uoʇʇnᗺ ooqɯɐᗺ",
  "block.minecraft.bamboo_door": "ɹooᗡ ooqɯɐᗺ",
  "block.minecraft.bamboo_fence": "ǝɔuǝℲ ooqɯɐᗺ",
  "block.minecraft.bamboo_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ ooqɯɐᗺ",
  "block.minecraft.bamboo_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ooqɯɐᗺ",
  "block.minecraft.bamboo_mosaic": "ɔᴉɐsoW ooqɯɐᗺ",
  "block.minecraft.bamboo_mosaic_slab": "qɐꞁS ɔᴉɐsoW ooqɯɐᗺ",
  "block.minecraft.bamboo_mosaic_stairs": "sɹᴉɐʇS ɔᴉɐsoW ooqɯɐᗺ",
  "block.minecraft.bamboo_planks": "sʞuɐꞁԀ ooqɯɐᗺ",
  "block.minecraft.bamboo_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ooqɯɐᗺ",
  "block.minecraft.bamboo_sapling": "ʇooɥS ooqɯɐᗺ",
  "block.minecraft.bamboo_shelf": "ɟlǝɥS ooqɯɐᗺ",
  "block.minecraft.bamboo_sign": "uᵷᴉS ooqɯɐᗺ",
  "block.minecraft.bamboo_slab": "qɐꞁS ooqɯɐᗺ",
  "block.minecraft.bamboo_stairs": "sɹᴉɐʇS ooqɯɐᗺ",
  "block.minecraft.bamboo_trapdoor": "ɹoopdɐɹ⟘ ooqɯɐᗺ",
  "block.minecraft.bamboo_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM ooqɯɐᗺ",
  "block.minecraft.bamboo_wall_sign": "uᵷᴉS ꞁꞁɐM ooqɯɐᗺ",
  "block.minecraft.banner.base.black": "pꞁǝᴉℲ ʞɔɐꞁᗺ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.blue": "pꞁǝᴉℲ ǝnꞁᗺ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.brown": "pꞁǝᴉℲ uʍoɹᗺ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.cyan": "pꞁǝᴉℲ uɐʎƆ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.gray": "pꞁǝᴉℲ ʎǝɹ⅁ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.green": "pꞁǝᴉℲ uǝǝɹ⅁ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.light_blue": "pꞁǝᴉℲ ǝnꞁᗺ ʇɥᵷᴉꞀ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.light_gray": "pꞁǝᴉℲ ʎǝɹ⅁ ʇɥᵷᴉꞀ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.lime": "pꞁǝᴉℲ ǝɯᴉꞀ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.magenta": "pꞁǝᴉℲ ɐʇuǝᵷɐW ʎꞁꞁnℲ",
  "block.minecraft.banner.base.orange": "pꞁǝᴉℲ ǝᵷuɐɹO ʎꞁꞁnℲ",
  "block.minecraft.banner.base.pink": "pꞁǝᴉℲ ʞuᴉԀ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.purple": "pꞁǝᴉℲ ǝꞁdɹnԀ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.red": "pꞁǝᴉℲ pǝᴚ ʎꞁꞁnℲ",
  "block.minecraft.banner.base.white": "pꞁǝᴉℲ ǝʇᴉɥM ʎꞁꞁnℲ",
  "block.minecraft.banner.base.yellow": "pꞁǝᴉℲ ʍoꞁꞁǝ⅄ ʎꞁꞁnℲ",
  "block.minecraft.banner.border.black": "ǝɹnpɹoᗺ ʞɔɐꞁq",
  "block.minecraft.banner.border.blue": "ǝɹnpɹoᗺ ǝnꞁᗺ",
  "block.minecraft.banner.border.brown": "ǝɹnpɹoᗺ uʍoɹᗺ",
  "block.minecraft.banner.border.cyan": "ǝɹnpɹoᗺ uɐʎƆ",
  "block.minecraft.banner.border.gray": "ǝɹnpɹoᗺ ʎǝɹ⅁",
  "block.minecraft.banner.border.green": "ǝɹnpɹoᗺ uǝǝɹ⅁",
  "block.minecraft.banner.border.light_blue": "ǝɹnpɹoᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.border.light_gray": "ǝɹnpɹoᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.border.lime": "ǝɹnpɹoᗺ ǝɯᴉꞀ",
  "block.minecraft.banner.border.magenta": "ǝɹnpɹoᗺ ɐʇuǝᵷɐW",
  "block.minecraft.banner.border.orange": "ǝɹnpɹoᗺ ǝᵷuɐɹO",
  "block.minecraft.banner.border.pink": "ǝɹnpɹoᗺ ʞuᴉԀ",
  "block.minecraft.banner.border.purple": "ǝɹnpɹoᗺ ǝꞁdɹnԀ",
  "block.minecraft.banner.border.red": "ǝɹnpɹoᗺ pǝᴚ",
  "block.minecraft.banner.border.white": "ǝɹnpɹoᗺ ǝʇᴉɥM",
  "block.minecraft.banner.border.yellow": "ǝɹnpɹoᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.bricks.black": "pǝuosɐW pꞁǝᴉℲ ʞɔɐꞁᗺ",
  "block.minecraft.banner.bricks.blue": "pǝuosɐW pꞁǝᴉℲ ǝnꞁᗺ",
  "block.minecraft.banner.bricks.brown": "pǝuosɐW pꞁǝᴉℲ uʍoɹᗺ",
  "block.minecraft.banner.bricks.cyan": "pǝuosɐW pꞁǝᴉℲ uɐʎƆ",
  "block.minecraft.banner.bricks.gray": "pǝuosɐW pꞁǝᴉℲ ʎǝɹ⅁",
  "block.minecraft.banner.bricks.green": "pǝuosɐW pꞁǝᴉℲ uǝǝɹ⅁",
  "block.minecraft.banner.bricks.light_blue": "pǝuosɐW pꞁǝᴉℲ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.bricks.light_gray": "pǝuosɐW pꞁǝᴉℲ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.bricks.lime": "pǝuosɐW pꞁǝᴉℲ ǝɯᴉꞀ",
  "block.minecraft.banner.bricks.magenta": "pǝuosɐW pꞁǝᴉℲ ɐʇuǝᵷɐW",
  "block.minecraft.banner.bricks.orange": "pǝuosɐW pꞁǝᴉℲ ǝᵷuɐɹO",
  "block.minecraft.banner.bricks.pink": "pǝuosɐW pꞁǝᴉℲ ʞuᴉԀ",
  "block.minecraft.banner.bricks.purple": "pǝuosɐW pꞁǝᴉℲ ǝꞁdɹnԀ",
  "block.minecraft.banner.bricks.red": "pǝuosɐW pꞁǝᴉℲ pǝᴚ",
  "block.minecraft.banner.bricks.white": "pǝuosɐW pꞁǝᴉℲ ǝʇᴉɥM",
  "block.minecraft.banner.bricks.yellow": "pǝuosɐW pꞁǝᴉℲ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.circle.black": "ꞁǝpunoᴚ ʞɔɐꞁᗺ",
  "block.minecraft.banner.circle.blue": "ꞁǝpunoᴚ ǝnꞁᗺ",
  "block.minecraft.banner.circle.brown": "ꞁǝpunoᴚ uʍoɹᗺ",
  "block.minecraft.banner.circle.cyan": "ꞁǝpunoᴚ uɐʎƆ",
  "block.minecraft.banner.circle.gray": "ꞁǝpunoᴚ ʎǝɹ⅁",
  "block.minecraft.banner.circle.green": "ꞁǝpunoᴚ uǝǝɹ⅁",
  "block.minecraft.banner.circle.light_blue": "ꞁǝpunoᴚ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.circle.light_gray": "ꞁǝpunoᴚ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.circle.lime": "ꞁǝpunoᴚ ǝɯᴉꞀ",
  "block.minecraft.banner.circle.magenta": "ꞁǝpunoᴚ ɐʇuǝᵷɐW",
  "block.minecraft.banner.circle.orange": "ꞁǝpunoᴚ ǝᵷuɐɹO",
  "block.minecraft.banner.circle.pink": "ꞁǝpunoᴚ ʞuᴉԀ",
  "block.minecraft.banner.circle.purple": "ꞁǝpunoᴚ ǝꞁdɹnԀ",
  "block.minecraft.banner.circle.red": "ꞁǝpunoᴚ pǝᴚ",
  "block.minecraft.banner.circle.white": "ꞁǝpunoᴚ ǝʇᴉɥM",
  "block.minecraft.banner.circle.yellow": "ꞁǝpunoᴚ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.creeper.black": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ʞɔɐꞁᗺ",
  "block.minecraft.banner.creeper.blue": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ǝnꞁᗺ",
  "block.minecraft.banner.creeper.brown": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ uʍoɹᗺ",
  "block.minecraft.banner.creeper.cyan": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ uɐʎƆ",
  "block.minecraft.banner.creeper.gray": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ʎǝɹ⅁",
  "block.minecraft.banner.creeper.green": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ uǝǝɹ⅁",
  "block.minecraft.banner.creeper.light_blue": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.creeper.light_gray": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.creeper.lime": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ǝɯᴉꞀ",
  "block.minecraft.banner.creeper.magenta": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ɐʇuǝᵷɐW",
  "block.minecraft.banner.creeper.orange": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ǝᵷuɐɹO",
  "block.minecraft.banner.creeper.pink": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ʞuᴉԀ",
  "block.minecraft.banner.creeper.purple": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ǝꞁdɹnԀ",
  "block.minecraft.banner.creeper.red": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ pǝᴚ",
  "block.minecraft.banner.creeper.white": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ǝʇᴉɥM",
  "block.minecraft.banner.creeper.yellow": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.cross.black": "ǝɹᴉʇꞁɐS ʞɔɐꞁᗺ",
  "block.minecraft.banner.cross.blue": "ǝɹᴉʇꞁɐS ǝnꞁᗺ",
  "block.minecraft.banner.cross.brown": "ǝɹᴉʇꞁɐS uʍoɹᗺ",
  "block.minecraft.banner.cross.cyan": "ǝɹᴉʇꞁɐS uɐʎƆ",
  "block.minecraft.banner.cross.gray": "ǝɹᴉʇꞁɐS ʎǝɹ⅁",
  "block.minecraft.banner.cross.green": "ǝɹᴉʇꞁɐS uǝǝɹ⅁",
  "block.minecraft.banner.cross.light_blue": "ǝɹᴉʇꞁɐS ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.cross.light_gray": "ǝɹᴉʇꞁɐS ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.cross.lime": "ǝɹᴉʇꞁɐS ǝɯᴉꞀ",
  "block.minecraft.banner.cross.magenta": "ǝɹᴉʇꞁɐS ɐʇuǝᵷɐW",
  "block.minecraft.banner.cross.orange": "ǝɹᴉʇꞁɐS ǝᵷuɐɹO",
  "block.minecraft.banner.cross.pink": "ǝɹᴉʇꞁɐS ʞuᴉԀ",
  "block.minecraft.banner.cross.purple": "ǝɹᴉʇꞁɐS ǝꞁdɹnԀ",
  "block.minecraft.banner.cross.red": "ǝɹᴉʇꞁɐS pǝᴚ",
  "block.minecraft.banner.cross.white": "ǝɹᴉʇꞁɐS ǝʇᴉɥM",
  "block.minecraft.banner.cross.yellow": "ǝɹᴉʇꞁɐS ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.curly_border.black": "pǝʇuǝpuI ǝɹnpɹoᗺ ʞɔɐꞁᗺ",
  "block.minecraft.banner.curly_border.blue": "pǝʇuǝpuI ǝɹnpɹoᗺ ǝnꞁᗺ",
  "block.minecraft.banner.curly_border.brown": "pǝʇuǝpuI ǝɹnpɹoᗺ uʍoɹᗺ",
  "block.minecraft.banner.curly_border.cyan": "pǝʇuǝpuI ǝɹnpɹoᗺ uɐʎƆ",
  "block.minecraft.banner.curly_border.gray": "pǝʇuǝpuI ǝɹnpɹoᗺ ʎǝɹ⅁",
  "block.minecraft.banner.curly_border.green": "pǝʇuǝpuI ǝɹnpɹoᗺ uǝǝɹ⅁",
  "block.minecraft.banner.curly_border.light_blue": "pǝʇuǝpuI ǝɹnpɹoᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.curly_border.light_gray": "pǝʇuǝpuI ǝɹnpɹoᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.curly_border.lime": "pǝʇuǝpuI ǝɹnpɹoᗺ ǝɯᴉꞀ",
  "block.minecraft.banner.curly_border.magenta": "pǝʇuǝpuI ǝɹnpɹoᗺ ɐʇuǝᵷɐW",
  "block.minecraft.banner.curly_border.orange": "pǝʇuǝpuI ǝɹnpɹoᗺ ǝᵷuɐɹO",
  "block.minecraft.banner.curly_border.pink": "pǝʇuǝpuI ǝɹnpɹoᗺ ʞuᴉԀ",
  "block.minecraft.banner.curly_border.purple": "pǝʇuǝpuI ǝɹnpɹoᗺ ǝꞁdɹnԀ",
  "block.minecraft.banner.curly_border.red": "pǝʇuǝpuI ǝɹnpɹoᗺ pǝᴚ",
  "block.minecraft.banner.curly_border.white": "pǝʇuǝpuI ǝɹnpɹoᗺ ǝʇᴉɥM",
  "block.minecraft.banner.curly_border.yellow": "pǝʇuǝpuI ǝɹnpɹoᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.diagonal_left.black": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.diagonal_left.blue": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝnꞁᗺ",
  "block.minecraft.banner.diagonal_left.brown": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ uʍoɹᗺ",
  "block.minecraft.banner.diagonal_left.cyan": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ uɐʎƆ",
  "block.minecraft.banner.diagonal_left.gray": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ʎǝɹ⅁",
  "block.minecraft.banner.diagonal_left.green": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ uǝǝɹ⅁",
  "block.minecraft.banner.diagonal_left.light_blue": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.diagonal_left.light_gray": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.diagonal_left.lime": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝɯᴉꞀ",
  "block.minecraft.banner.diagonal_left.magenta": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.diagonal_left.orange": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝᵷuɐɹO",
  "block.minecraft.banner.diagonal_left.pink": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ʞuᴉԀ",
  "block.minecraft.banner.diagonal_left.purple": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.diagonal_left.red": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ pǝᴚ",
  "block.minecraft.banner.diagonal_left.white": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝʇᴉɥM",
  "block.minecraft.banner.diagonal_left.yellow": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.diagonal_right.black": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.diagonal_right.blue": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ǝnꞁᗺ",
  "block.minecraft.banner.diagonal_right.brown": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ uʍoɹᗺ",
  "block.minecraft.banner.diagonal_right.cyan": "puǝᗺ ɹǝԀ uɐʎƆ",
  "block.minecraft.banner.diagonal_right.gray": "puǝᗺ ɹǝԀ ʎǝɹ⅁",
  "block.minecraft.banner.diagonal_right.green": "puǝᗺ ɹǝԀ uǝǝɹ⅁",
  "block.minecraft.banner.diagonal_right.light_blue": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.diagonal_right.light_gray": "puǝᗺ ɹǝԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.diagonal_right.lime": "puǝᗺ ɹǝԀ ǝɯᴉꞀ",
  "block.minecraft.banner.diagonal_right.magenta": "puǝᗺ ɹǝԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.diagonal_right.orange": "puǝᗺ ɹǝԀ ǝᵷuɐɹO",
  "block.minecraft.banner.diagonal_right.pink": "puǝᗺ ɹǝԀ ʞuᴉԀ",
  "block.minecraft.banner.diagonal_right.purple": "puǝᗺ ɹǝԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.diagonal_right.red": "puǝᗺ ɹǝԀ pǝᴚ",
  "block.minecraft.banner.diagonal_right.white": "puǝᗺ ɹǝԀ ǝʇᴉɥM",
  "block.minecraft.banner.diagonal_right.yellow": "puǝᗺ ɹǝԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.diagonal_up_left.black": "puǝᗺ ɹǝԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.diagonal_up_left.blue": "puǝᗺ ɹǝԀ ǝnꞁᗺ",
  "block.minecraft.banner.diagonal_up_left.brown": "puǝᗺ ɹǝԀ uʍoɹᗺ",
  "block.minecraft.banner.diagonal_up_left.cyan": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ uɐʎƆ",
  "block.minecraft.banner.diagonal_up_left.gray": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ʎǝɹ⅁",
  "block.minecraft.banner.diagonal_up_left.green": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ uǝǝɹ⅁",
  "block.minecraft.banner.diagonal_up_left.light_blue": "puǝᗺ ɹǝԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.diagonal_up_left.light_gray": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.diagonal_up_left.lime": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ǝɯᴉꞀ",
  "block.minecraft.banner.diagonal_up_left.magenta": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.diagonal_up_left.orange": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ǝᵷuɐɹO",
  "block.minecraft.banner.diagonal_up_left.pink": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ʞuᴉԀ",
  "block.minecraft.banner.diagonal_up_left.purple": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.diagonal_up_left.red": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ pǝᴚ",
  "block.minecraft.banner.diagonal_up_left.white": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ǝʇᴉɥM",
  "block.minecraft.banner.diagonal_up_left.yellow": "pǝʇɹǝʌuI puǝᗺ ɹǝԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.diagonal_up_right.black": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.diagonal_up_right.blue": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝnꞁᗺ",
  "block.minecraft.banner.diagonal_up_right.brown": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ uʍoɹᗺ",
  "block.minecraft.banner.diagonal_up_right.cyan": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ uɐʎƆ",
  "block.minecraft.banner.diagonal_up_right.gray": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ʎǝɹ⅁",
  "block.minecraft.banner.diagonal_up_right.green": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ uǝǝɹ⅁",
  "block.minecraft.banner.diagonal_up_right.light_blue": "ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.diagonal_up_right.light_gray": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.diagonal_up_right.lime": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝɯᴉꞀ",
  "block.minecraft.banner.diagonal_up_right.magenta": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.diagonal_up_right.orange": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝᵷuɐɹO",
  "block.minecraft.banner.diagonal_up_right.pink": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ʞuᴉԀ",
  "block.minecraft.banner.diagonal_up_right.purple": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.diagonal_up_right.red": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ pǝᴚ",
  "block.minecraft.banner.diagonal_up_right.white": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ǝʇᴉɥM",
  "block.minecraft.banner.diagonal_up_right.yellow": "pǝʇɹǝʌuI ɹǝʇsᴉuᴉS puǝᗺ ɹǝԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.flow.black": "ʍoꞁℲ ʞɔɐꞁᗺ",
  "block.minecraft.banner.flow.blue": "ʍoꞁℲ ǝnꞁᗺ",
  "block.minecraft.banner.flow.brown": "ʍoꞁℲ uʍoɹᗺ",
  "block.minecraft.banner.flow.cyan": "ʍoꞁℲ uɐʎƆ",
  "block.minecraft.banner.flow.gray": "ʍoꞁℲ ʎǝɹ⅁",
  "block.minecraft.banner.flow.green": "ʍoꞁℲ uǝǝɹ⅁",
  "block.minecraft.banner.flow.light_blue": "ʍoꞁℲ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.flow.light_gray": "ʍoꞁℲ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.flow.lime": "ʍoꞁℲ ǝɯᴉꞀ",
  "block.minecraft.banner.flow.magenta": "ʍoꞁℲ ɐʇuǝᵷɐW",
  "block.minecraft.banner.flow.orange": "ʍoꞁℲ ǝᵷuɐɹO",
  "block.minecraft.banner.flow.pink": "ʍoꞁℲ ʞuᴉԀ",
  "block.minecraft.banner.flow.purple": "ʍoꞁℲ ǝꞁdɹnԀ",
  "block.minecraft.banner.flow.red": "ʍoꞁℲ pǝᴚ",
  "block.minecraft.banner.flow.white": "ʍoꞁℲ ǝʇᴉɥM",
  "block.minecraft.banner.flow.yellow": "ʍoꞁℲ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.flower.black": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ʞɔɐꞁᗺ",
  "block.minecraft.banner.flower.blue": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ǝnꞁᗺ",
  "block.minecraft.banner.flower.brown": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ uʍoɹᗺ",
  "block.minecraft.banner.flower.cyan": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ uɐʎƆ",
  "block.minecraft.banner.flower.gray": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ʎǝɹ⅁",
  "block.minecraft.banner.flower.green": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ uǝǝɹ⅁",
  "block.minecraft.banner.flower.light_blue": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.flower.light_gray": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.flower.lime": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ǝɯᴉꞀ",
  "block.minecraft.banner.flower.magenta": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ɐʇuǝᵷɐW",
  "block.minecraft.banner.flower.orange": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ǝᵷuɐɹO",
  "block.minecraft.banner.flower.pink": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ʞuᴉԀ",
  "block.minecraft.banner.flower.purple": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ǝꞁdɹnԀ",
  "block.minecraft.banner.flower.red": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ pǝᴚ",
  "block.minecraft.banner.flower.white": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ǝʇᴉɥM",
  "block.minecraft.banner.flower.yellow": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.globe.black": "ǝqoꞁ⅁ ʞɔɐꞁᗺ",
  "block.minecraft.banner.globe.blue": "ǝqoꞁ⅁ ǝnꞁᗺ",
  "block.minecraft.banner.globe.brown": "ǝqoꞁ⅁ uʍoɹᗺ",
  "block.minecraft.banner.globe.cyan": "ǝqoꞁ⅁ uɐʎƆ",
  "block.minecraft.banner.globe.gray": "ǝqoꞁ⅁ ʎǝɹ⅁",
  "block.minecraft.banner.globe.green": "ǝqoꞁ⅁ uǝǝɹ⅁",
  "block.minecraft.banner.globe.light_blue": "ǝqoꞁ⅁ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.globe.light_gray": "ǝqoꞁ⅁ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.globe.lime": "ǝqoꞁ⅁ ǝɯᴉꞀ",
  "block.minecraft.banner.globe.magenta": "ǝqoꞁ⅁ ɐʇuǝᵷɐW",
  "block.minecraft.banner.globe.orange": "ǝqoꞁ⅁ ǝƃuɐɹO",
  "block.minecraft.banner.globe.pink": "ǝqoꞁ⅁ ʞuᴉԀ",
  "block.minecraft.banner.globe.purple": "ǝqoꞁ⅁ ǝꞁdɹnԀ",
  "block.minecraft.banner.globe.red": "ǝqoꞁ⅁ pǝᴚ",
  "block.minecraft.banner.globe.white": "ǝqoꞁ⅁ ǝʇᴉɥM",
  "block.minecraft.banner.globe.yellow": "ǝqoꞁ⅁ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.gradient.black": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ʞɔɐꞁᗺ",
  "block.minecraft.banner.gradient.blue": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ǝnꞁᗺ",
  "block.minecraft.banner.gradient.brown": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ uʍoɹᗺ",
  "block.minecraft.banner.gradient.cyan": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ uɐʎƆ",
  "block.minecraft.banner.gradient.gray": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ʎǝɹ⅁",
  "block.minecraft.banner.gradient.green": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ uǝǝɹ⅁",
  "block.minecraft.banner.gradient.light_blue": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.gradient.light_gray": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.gradient.lime": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ǝɯᴉꞀ",
  "block.minecraft.banner.gradient.magenta": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ɐʇuǝᵷɐW",
  "block.minecraft.banner.gradient.orange": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ǝᵷuɐɹO",
  "block.minecraft.banner.gradient.pink": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ʞuᴉԀ",
  "block.minecraft.banner.gradient.purple": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ǝꞁdɹnԀ",
  "block.minecraft.banner.gradient.red": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ pǝᴚ",
  "block.minecraft.banner.gradient.white": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ǝʇᴉɥM",
  "block.minecraft.banner.gradient.yellow": "ʇuǝᴉpɐɹ⅁ ǝsɐᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.gradient_up.black": "ʇuǝᴉpɐɹ⅁ ʞɔɐꞁᗺ",
  "block.minecraft.banner.gradient_up.blue": "ʇuǝᴉpɐɹ⅁ ǝnꞁᗺ",
  "block.minecraft.banner.gradient_up.brown": "ʇuǝᴉpɐɹ⅁ uʍoɹᗺ",
  "block.minecraft.banner.gradient_up.cyan": "ʇuǝᴉpɐɹ⅁ uɐʎƆ",
  "block.minecraft.banner.gradient_up.gray": "ʇuǝᴉpɐɹ⅁ ʎǝɹ⅁",
  "block.minecraft.banner.gradient_up.green": "ʇuǝᴉpɐɹ⅁ uǝǝɹ⅁",
  "block.minecraft.banner.gradient_up.light_blue": "ʇuǝᴉpɐɹ⅁ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.gradient_up.light_gray": "ʇuǝᴉpɐɹ⅁ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.gradient_up.lime": "ʇuǝᴉpɐɹ⅁ ǝɯᴉꞀ",
  "block.minecraft.banner.gradient_up.magenta": "ʇuǝᴉpɐɹ⅁ ɐʇuǝᵷɐW",
  "block.minecraft.banner.gradient_up.orange": "ʇuǝᴉpɐɹ⅁ ǝᵷuɐɹO",
  "block.minecraft.banner.gradient_up.pink": "ʇuǝᴉpɐɹ⅁ ʞuᴉԀ",
  "block.minecraft.banner.gradient_up.purple": "ʇuǝᴉpɐɹ⅁ ǝꞁdɹnԀ",
  "block.minecraft.banner.gradient_up.red": "ʇuǝᴉpɐɹ⅁ pǝᴚ",
  "block.minecraft.banner.gradient_up.white": "ʇuǝᴉpɐɹ⅁ ǝʇᴉɥM",
  "block.minecraft.banner.gradient_up.yellow": "ʇuǝᴉpɐɹ⅁ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.guster.black": "ɹǝʇsn⅁ ʞɔɐꞁᗺ",
  "block.minecraft.banner.guster.blue": "ɹǝʇsn⅁ ǝnꞁᗺ",
  "block.minecraft.banner.guster.brown": "ɹǝʇsn⅁ uʍoɹᗺ",
  "block.minecraft.banner.guster.cyan": "ɹǝʇsn⅁ uɐʎƆ",
  "block.minecraft.banner.guster.gray": "ɹǝʇsn⅁ ʎǝɹ⅁",
  "block.minecraft.banner.guster.green": "ɹǝʇsn⅁ uǝǝɹ⅁",
  "block.minecraft.banner.guster.light_blue": "ɹǝʇsn⅁ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.guster.light_gray": "ɹǝʇsn⅁ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.guster.lime": "ɹǝʇsn⅁ ǝɯᴉꞀ",
  "block.minecraft.banner.guster.magenta": "ɹǝʇsn⅁ ɐʇuǝᵷɐW",
  "block.minecraft.banner.guster.orange": "ɹǝʇsn⅁ ǝᵷuɐɹO",
  "block.minecraft.banner.guster.pink": "ɹǝʇsn⅁ ʞuᴉԀ",
  "block.minecraft.banner.guster.purple": "ɹǝʇsn⅁ ǝꞁdɹnԀ",
  "block.minecraft.banner.guster.red": "ɹǝʇsn⅁ pǝᴚ",
  "block.minecraft.banner.guster.white": "ɹǝʇsn⅁ ǝʇᴉɥM",
  "block.minecraft.banner.guster.yellow": "ɹǝʇsn⅁ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.half_horizontal.black": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.half_horizontal.blue": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ǝnꞁᗺ",
  "block.minecraft.banner.half_horizontal.brown": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ uʍoɹᗺ",
  "block.minecraft.banner.half_horizontal.cyan": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ uɐʎƆ",
  "block.minecraft.banner.half_horizontal.gray": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ʎǝɹ⅁",
  "block.minecraft.banner.half_horizontal.green": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ uǝǝɹ⅁",
  "block.minecraft.banner.half_horizontal.light_blue": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.half_horizontal.light_gray": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.half_horizontal.lime": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ǝɯᴉꞀ",
  "block.minecraft.banner.half_horizontal.magenta": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.half_horizontal.orange": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ǝᵷuɐɹO",
  "block.minecraft.banner.half_horizontal.pink": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ʞuᴉԀ",
  "block.minecraft.banner.half_horizontal.purple": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.half_horizontal.red": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ pǝᴚ",
  "block.minecraft.banner.half_horizontal.white": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ǝʇᴉɥM",
  "block.minecraft.banner.half_horizontal.yellow": "pǝʇɹǝʌuI ssǝℲ ɹǝԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.half_horizontal_bottom.black": "ssǝℲ ɹǝԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.half_horizontal_bottom.blue": "ssǝℲ ɹǝԀ ǝnꞁᗺ",
  "block.minecraft.banner.half_horizontal_bottom.brown": "ssǝℲ ɹǝԀ uʍoɹᗺ",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "ssǝℲ ɹǝԀ uɐʎƆ",
  "block.minecraft.banner.half_horizontal_bottom.gray": "ssǝℲ ɹǝԀ ʎǝɹ⅁",
  "block.minecraft.banner.half_horizontal_bottom.green": "ssǝℲ ɹǝԀ uǝǝɹ⅁",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "ssǝℲ ɹǝԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "ssǝℲ ɹǝԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.half_horizontal_bottom.lime": "ssǝℲ ɹǝԀ ǝɯᴉꞀ",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "ssǝℲ ɹǝԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.half_horizontal_bottom.orange": "ssǝℲ ɹǝԀ ǝᵷuɐɹO",
  "block.minecraft.banner.half_horizontal_bottom.pink": "ssǝℲ ɹǝԀ ʞuᴉԀ",
  "block.minecraft.banner.half_horizontal_bottom.purple": "ssǝℲ ɹǝԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.half_horizontal_bottom.red": "ssǝℲ ɹǝԀ pǝᴚ",
  "block.minecraft.banner.half_horizontal_bottom.white": "ssǝℲ ɹǝԀ ǝʇᴉɥM",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "ssǝℲ ɹǝԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.half_vertical.black": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.half_vertical.blue": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ǝnꞁᗺ",
  "block.minecraft.banner.half_vertical.brown": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ uʍoɹᗺ",
  "block.minecraft.banner.half_vertical.cyan": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ uɐʎƆ",
  "block.minecraft.banner.half_vertical.gray": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ʎǝɹ⅁",
  "block.minecraft.banner.half_vertical.green": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ uǝǝɹ⅁",
  "block.minecraft.banner.half_vertical.light_blue": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.half_vertical.light_gray": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.half_vertical.lime": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ǝɯᴉꞀ",
  "block.minecraft.banner.half_vertical.magenta": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.half_vertical.orange": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ǝᵷuɐɹO",
  "block.minecraft.banner.half_vertical.pink": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ʞuᴉԀ",
  "block.minecraft.banner.half_vertical.purple": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.half_vertical.red": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ pǝᴚ",
  "block.minecraft.banner.half_vertical.white": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ǝʇᴉɥM",
  "block.minecraft.banner.half_vertical.yellow": "pǝʇɹǝʌuI ǝꞁɐԀ ɹǝԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.half_vertical_right.black": "ǝꞁɐԀ ɹǝԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.half_vertical_right.blue": "ǝꞁɐԀ ɹǝԀ ǝnꞁᗺ",
  "block.minecraft.banner.half_vertical_right.brown": "ǝꞁɐԀ ɹǝԀ uʍoɹᗺ",
  "block.minecraft.banner.half_vertical_right.cyan": "ǝꞁɐԀ ɹǝԀ uɐʎƆ",
  "block.minecraft.banner.half_vertical_right.gray": "ǝꞁɐԀ ɹǝԀ ʎǝɹ⅁",
  "block.minecraft.banner.half_vertical_right.green": "ǝꞁɐԀ ɹǝԀ uǝǝɹ⅁",
  "block.minecraft.banner.half_vertical_right.light_blue": "ǝꞁɐԀ ɹǝԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.half_vertical_right.light_gray": "ǝꞁɐԀ ɹǝԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.half_vertical_right.lime": "ǝꞁɐԀ ɹǝԀ ǝɯᴉꞀ",
  "block.minecraft.banner.half_vertical_right.magenta": "ǝꞁɐԀ ɹǝԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.half_vertical_right.orange": "ǝꞁɐԀ ɹǝԀ ǝᵷuɐɹO",
  "block.minecraft.banner.half_vertical_right.pink": "ǝꞁɐԀ ɹǝԀ ʞuᴉԀ",
  "block.minecraft.banner.half_vertical_right.purple": "ǝꞁɐԀ ɹǝԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.half_vertical_right.red": "ǝꞁɐԀ ɹǝԀ pǝᴚ",
  "block.minecraft.banner.half_vertical_right.white": "ǝꞁɐԀ ɹǝԀ ǝʇᴉɥM",
  "block.minecraft.banner.half_vertical_right.yellow": "ǝꞁɐԀ ɹǝԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.mojang.black": "ᵷuᴉɥ⟘ ʞɔɐꞁᗺ",
  "block.minecraft.banner.mojang.blue": "ᵷuᴉɥ⟘ ǝnꞁᗺ",
  "block.minecraft.banner.mojang.brown": "ᵷuᴉɥ⟘ uʍoɹᗺ",
  "block.minecraft.banner.mojang.cyan": "ᵷuᴉɥ⟘ uɐʎƆ",
  "block.minecraft.banner.mojang.gray": "ᵷuᴉɥ⟘ ʎǝɹ⅁",
  "block.minecraft.banner.mojang.green": "ᵷuᴉɥ⟘ uǝǝɹ⅁",
  "block.minecraft.banner.mojang.light_blue": "ᵷuᴉɥ⟘ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.mojang.light_gray": "ᵷuᴉɥ⟘ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.mojang.lime": "ᵷuᴉɥ⟘ ǝɯᴉꞀ",
  "block.minecraft.banner.mojang.magenta": "ᵷuᴉɥ⟘ ɐʇuǝᵷɐW",
  "block.minecraft.banner.mojang.orange": "ᵷuᴉɥ⟘ ǝᵷuɐɹO",
  "block.minecraft.banner.mojang.pink": "ᵷuᴉɥ⟘ ʞuᴉԀ",
  "block.minecraft.banner.mojang.purple": "ᵷuᴉɥ⟘ ǝꞁdɹnԀ",
  "block.minecraft.banner.mojang.red": "ᵷuᴉɥ⟘ pǝᴚ",
  "block.minecraft.banner.mojang.white": "ᵷuᴉɥ⟘ ǝʇᴉɥM",
  "block.minecraft.banner.mojang.yellow": "ᵷuᴉɥ⟘ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.piglin.black": "ʇnouS ʞɔɐꞁᗺ",
  "block.minecraft.banner.piglin.blue": "ʇnouS ǝnꞁᗺ",
  "block.minecraft.banner.piglin.brown": "ʇnouS umoɹᗺ",
  "block.minecraft.banner.piglin.cyan": "ʇnouS uɐʎƆ",
  "block.minecraft.banner.piglin.gray": "ʇnouS ʎǝɹ⅁",
  "block.minecraft.banner.piglin.green": "ʇnouS uǝǝɹ⅁",
  "block.minecraft.banner.piglin.light_blue": "ʇnouS ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.piglin.light_gray": "ʇnouS ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.piglin.lime": "ʇnouS ǝɯᴉꞀ",
  "block.minecraft.banner.piglin.magenta": "ʇnouS ɐʇuǝᵷɐW",
  "block.minecraft.banner.piglin.orange": "ʇnouS ǝᵷuɐɹO",
  "block.minecraft.banner.piglin.pink": "ʇnouS ʞuᴉԀ",
  "block.minecraft.banner.piglin.purple": "ʇnouS ǝꞁdɹnԀ",
  "block.minecraft.banner.piglin.red": "ʇnouS pǝᴚ",
  "block.minecraft.banner.piglin.white": "ʇnouS ǝʇᴉɥM",
  "block.minecraft.banner.piglin.yellow": "ʇnouS ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.rhombus.black": "ǝᵷuǝzoꞀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.rhombus.blue": "ǝᵷuǝzoꞀ ǝnꞁᗺ",
  "block.minecraft.banner.rhombus.brown": "ǝᵷuǝzoꞀ uʍoɹᗺ",
  "block.minecraft.banner.rhombus.cyan": "ǝᵷuǝzoꞀ uɐʎƆ",
  "block.minecraft.banner.rhombus.gray": "ǝᵷuǝzoꞀ ʎǝɹ⅁",
  "block.minecraft.banner.rhombus.green": "ǝᵷuǝzoꞀ uǝǝɹ⅁",
  "block.minecraft.banner.rhombus.light_blue": "ǝᵷuǝzoꞀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.rhombus.light_gray": "ǝᵷuǝzoꞀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.rhombus.lime": "ǝᵷuǝzoꞀ ǝɯᴉꞀ",
  "block.minecraft.banner.rhombus.magenta": "ǝᵷuǝzoꞀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.rhombus.orange": "ǝᵷuǝzoꞀ ǝᵷuɐɹO",
  "block.minecraft.banner.rhombus.pink": "ǝᵷuǝzoꞀ ʞuᴉԀ",
  "block.minecraft.banner.rhombus.purple": "ǝᵷuǝzoꞀ ǝꞁdɹnԀ",
  "block.minecraft.banner.rhombus.red": "ǝᵷuǝzoꞀ pǝᴚ",
  "block.minecraft.banner.rhombus.white": "ǝᵷuǝzoꞀ ǝʇᴉɥM",
  "block.minecraft.banner.rhombus.yellow": "ǝᵷuǝzoꞀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.skull.black": "ǝᵷɹɐɥƆ ꞁꞁnʞS ʞɔɐꞁᗺ",
  "block.minecraft.banner.skull.blue": "ǝᵷɹɐɥƆ ꞁꞁnʞS ǝnꞁᗺ",
  "block.minecraft.banner.skull.brown": "ǝᵷɹɐɥƆ ꞁꞁnʞS uʍoɹᗺ",
  "block.minecraft.banner.skull.cyan": "ǝᵷɹɐɥƆ ꞁꞁnʞS uɐʎƆ",
  "block.minecraft.banner.skull.gray": "ǝᵷɹɐɥƆ ꞁꞁnʞS ʎǝɹ⅁",
  "block.minecraft.banner.skull.green": "ǝᵷɹɐɥƆ ꞁꞁnʞS uǝǝɹ⅁",
  "block.minecraft.banner.skull.light_blue": "ǝᵷɹɐɥƆ ꞁꞁnʞS ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.skull.light_gray": "ǝᵷɹɐɥƆ ꞁꞁnʞS ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.skull.lime": "ǝᵷɹɐɥƆ ꞁꞁnʞS ǝɯᴉꞀ",
  "block.minecraft.banner.skull.magenta": "ǝᵷɹɐɥƆ ꞁꞁnʞS ɐʇuǝᵷɐW",
  "block.minecraft.banner.skull.orange": "ǝᵷɹɐɥƆ ꞁꞁnʞS ǝᵷuɐɹO",
  "block.minecraft.banner.skull.pink": "ǝᵷɹɐɥƆ ꞁꞁnʞS ʞuᴉԀ",
  "block.minecraft.banner.skull.purple": "ǝᵷɹɐɥƆ ꞁꞁnʞS ǝꞁdɹnԀ",
  "block.minecraft.banner.skull.red": "ǝᵷɹɐɥƆ ꞁꞁnʞS pǝᴚ",
  "block.minecraft.banner.skull.white": "ǝᵷɹɐɥƆ ꞁꞁnʞS ǝʇᴉɥM",
  "block.minecraft.banner.skull.yellow": "ǝᵷɹɐɥƆ ꞁꞁnʞS ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.small_stripes.black": "ʎꞁɐԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.small_stripes.blue": "ʎꞁɐԀ ǝnꞁᗺ",
  "block.minecraft.banner.small_stripes.brown": "ʎꞁɐԀ uʍoɹᗺ",
  "block.minecraft.banner.small_stripes.cyan": "ʎꞁɐԀ uɐʎƆ",
  "block.minecraft.banner.small_stripes.gray": "ʎꞁɐԀ ʎǝɹ⅁",
  "block.minecraft.banner.small_stripes.green": "ʎꞁɐԀ uǝǝɹ⅁",
  "block.minecraft.banner.small_stripes.light_blue": "ʎꞁɐԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.small_stripes.light_gray": "ʎꞁɐԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.small_stripes.lime": "ʎꞁɐԀ ǝɯᴉꞀ",
  "block.minecraft.banner.small_stripes.magenta": "ʎꞁɐԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.small_stripes.orange": "ʎꞁɐԀ ǝᵷuɐɹO",
  "block.minecraft.banner.small_stripes.pink": "ʎꞁɐԀ ʞuᴉԀ",
  "block.minecraft.banner.small_stripes.purple": "ʎꞁɐԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.small_stripes.red": "ʎꞁɐԀ pǝᴚ",
  "block.minecraft.banner.small_stripes.white": "ʎꞁɐԀ ǝʇᴉɥM",
  "block.minecraft.banner.small_stripes.yellow": "ʎꞁɐԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.square_bottom_left.black": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ʞɔɐꞁᗺ",
  "block.minecraft.banner.square_bottom_left.blue": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ǝnꞁᗺ",
  "block.minecraft.banner.square_bottom_left.brown": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ uʍoɹᗺ",
  "block.minecraft.banner.square_bottom_left.cyan": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ uɐʎƆ",
  "block.minecraft.banner.square_bottom_left.gray": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ʎǝɹ⅁",
  "block.minecraft.banner.square_bottom_left.green": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ uǝǝɹ⅁",
  "block.minecraft.banner.square_bottom_left.light_blue": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.square_bottom_left.light_gray": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.square_bottom_left.lime": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ǝɯᴉꞀ",
  "block.minecraft.banner.square_bottom_left.magenta": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ɐʇuǝᵷɐW",
  "block.minecraft.banner.square_bottom_left.orange": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ǝᵷuɐɹO",
  "block.minecraft.banner.square_bottom_left.pink": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ʞuᴉԀ",
  "block.minecraft.banner.square_bottom_left.purple": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ǝꞁdɹnԀ",
  "block.minecraft.banner.square_bottom_left.red": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ pǝᴚ",
  "block.minecraft.banner.square_bottom_left.white": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ǝʇᴉɥM",
  "block.minecraft.banner.square_bottom_left.yellow": "uoʇuɐƆ ɹǝʇsᴉuᴉS ɟǝᴉɥƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.square_bottom_right.black": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ʞɔɐꞁᗺ",
  "block.minecraft.banner.square_bottom_right.blue": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ǝnꞁᗺ",
  "block.minecraft.banner.square_bottom_right.brown": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ uʍoɹᗺ",
  "block.minecraft.banner.square_bottom_right.cyan": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ uɐʎƆ",
  "block.minecraft.banner.square_bottom_right.gray": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ʎǝɹ⅁",
  "block.minecraft.banner.square_bottom_right.green": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ uǝǝɹ⅁",
  "block.minecraft.banner.square_bottom_right.light_blue": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.square_bottom_right.light_gray": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.square_bottom_right.lime": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ǝɯᴉꞀ",
  "block.minecraft.banner.square_bottom_right.magenta": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ɐʇuǝᵷɐW",
  "block.minecraft.banner.square_bottom_right.orange": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ǝᵷuɐɹO",
  "block.minecraft.banner.square_bottom_right.pink": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ʞuᴉԀ",
  "block.minecraft.banner.square_bottom_right.purple": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ǝꞁdɹnԀ",
  "block.minecraft.banner.square_bottom_right.red": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ pǝᴚ",
  "block.minecraft.banner.square_bottom_right.white": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ǝʇᴉɥM",
  "block.minecraft.banner.square_bottom_right.yellow": "uoʇuɐƆ ɹǝʇxǝᗡ ɟǝᴉɥƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.square_top_left.black": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐqᗺ ʞɔɐꞁᗺ",
  "block.minecraft.banner.square_top_left.blue": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ǝnꞁᗺ",
  "block.minecraft.banner.square_top_left.brown": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ uʍoɹᗺ",
  "block.minecraft.banner.square_top_left.cyan": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ uɐʎƆ",
  "block.minecraft.banner.square_top_left.gray": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ʎǝɹ⅁",
  "block.minecraft.banner.square_top_left.green": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ uǝǝɹ⅁",
  "block.minecraft.banner.square_top_left.light_blue": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.square_top_left.light_gray": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.square_top_left.lime": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ǝɯᴉꞀ",
  "block.minecraft.banner.square_top_left.magenta": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ɐʇuǝᵷɐW",
  "block.minecraft.banner.square_top_left.orange": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ǝᵷuɐɹO",
  "block.minecraft.banner.square_top_left.pink": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ʞuᴉԀ",
  "block.minecraft.banner.square_top_left.purple": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ǝꞁdɹnԀ",
  "block.minecraft.banner.square_top_left.red": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ pǝᴚ",
  "block.minecraft.banner.square_top_left.white": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ǝʇᴉɥM",
  "block.minecraft.banner.square_top_left.yellow": "uoʇuɐƆ ɹǝʇsᴉuᴉS ǝsɐᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.square_top_right.black": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ʞɔɐꞁᗺ",
  "block.minecraft.banner.square_top_right.blue": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ǝnꞁᗺ",
  "block.minecraft.banner.square_top_right.brown": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ uʍoɹᗺ",
  "block.minecraft.banner.square_top_right.cyan": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ uɐʎƆ",
  "block.minecraft.banner.square_top_right.gray": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ʎǝɹ⅁",
  "block.minecraft.banner.square_top_right.green": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ uǝǝɹ⅁",
  "block.minecraft.banner.square_top_right.light_blue": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.square_top_right.light_gray": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.square_top_right.lime": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ǝɯᴉꞀ",
  "block.minecraft.banner.square_top_right.magenta": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ɐʇuǝᵷɐW",
  "block.minecraft.banner.square_top_right.orange": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ǝᵷuɐɹO",
  "block.minecraft.banner.square_top_right.pink": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ʞuᴉԀ",
  "block.minecraft.banner.square_top_right.purple": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ǝꞁdɹnԀ",
  "block.minecraft.banner.square_top_right.red": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ pǝᴚ",
  "block.minecraft.banner.square_top_right.white": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ǝʇᴉɥM",
  "block.minecraft.banner.square_top_right.yellow": "uoʇuɐƆ ɹǝʇxǝᗡ ǝsɐᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.straight_cross.black": "ssoɹƆ ʞɔɐꞁᗺ",
  "block.minecraft.banner.straight_cross.blue": "ssoɹƆ ǝnꞁᗺ",
  "block.minecraft.banner.straight_cross.brown": "ssoɹƆ uʍoɹᗺ",
  "block.minecraft.banner.straight_cross.cyan": "ssoɹƆ uɐʎƆ",
  "block.minecraft.banner.straight_cross.gray": "ssoɹƆ ʎǝɹ⅁",
  "block.minecraft.banner.straight_cross.green": "ssoɹƆ uǝǝɹ⅁",
  "block.minecraft.banner.straight_cross.light_blue": "ssoɹƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.straight_cross.light_gray": "ssoɹƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.straight_cross.lime": "ssoɹƆ ǝɯᴉꞀ",
  "block.minecraft.banner.straight_cross.magenta": "ssoɹƆ ɐʇuǝᵷɐW",
  "block.minecraft.banner.straight_cross.orange": "ssoɹƆ ǝᵷuɐɹO",
  "block.minecraft.banner.straight_cross.pink": "ssoɹƆ ʞuᴉԀ",
  "block.minecraft.banner.straight_cross.purple": "ssoɹƆ ǝꞁdɹnԀ",
  "block.minecraft.banner.straight_cross.red": "ssoɹƆ pǝᴚ",
  "block.minecraft.banner.straight_cross.white": "ssoɹƆ ǝʇᴉɥM",
  "block.minecraft.banner.straight_cross.yellow": "ssoɹƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.stripe_bottom.black": "ǝsɐᗺ ʞɔɐꞁᗺ",
  "block.minecraft.banner.stripe_bottom.blue": "ǝsɐᗺ ǝnꞁᗺ",
  "block.minecraft.banner.stripe_bottom.brown": "ǝsɐᗺ uʍoɹᗺ",
  "block.minecraft.banner.stripe_bottom.cyan": "ǝsɐᗺ uɐʎƆ",
  "block.minecraft.banner.stripe_bottom.gray": "ǝsɐᗺ ʎǝɹ⅁",
  "block.minecraft.banner.stripe_bottom.green": "ǝsɐᗺ uǝǝɹ⅁",
  "block.minecraft.banner.stripe_bottom.light_blue": "ǝsɐᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_bottom.light_gray": "ǝsɐᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_bottom.lime": "ǝsɐᗺ ǝɯᴉꞀ",
  "block.minecraft.banner.stripe_bottom.magenta": "ǝsɐᗺ ɐʇuǝᵷɐW",
  "block.minecraft.banner.stripe_bottom.orange": "ǝsɐᗺ ǝᵷuɐɹO",
  "block.minecraft.banner.stripe_bottom.pink": "ǝsɐᗺ ʞuᴉԀ",
  "block.minecraft.banner.stripe_bottom.purple": "ǝsɐᗺ ǝꞁdɹnԀ",
  "block.minecraft.banner.stripe_bottom.red": "ǝsɐᗺ pǝᴚ",
  "block.minecraft.banner.stripe_bottom.white": "ǝsɐᗺ ǝʇᴉɥM",
  "block.minecraft.banner.stripe_bottom.yellow": "ǝsɐᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.stripe_center.black": "ǝꞁɐԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.stripe_center.blue": "ǝꞁɐԀ ǝnꞁᗺ",
  "block.minecraft.banner.stripe_center.brown": "ǝꞁɐԀ uʍoɹᗺ",
  "block.minecraft.banner.stripe_center.cyan": "ǝꞁɐԀ uɐʎƆ",
  "block.minecraft.banner.stripe_center.gray": "ǝꞁɐԀ ʎǝɹ⅁",
  "block.minecraft.banner.stripe_center.green": "ǝꞁɐԀ uǝǝɹ⅁",
  "block.minecraft.banner.stripe_center.light_blue": "ǝꞁɐԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_center.light_gray": "ǝꞁɐԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_center.lime": "ǝꞁɐԀ ǝɯᴉꞀ",
  "block.minecraft.banner.stripe_center.magenta": "ǝꞁɐԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.stripe_center.orange": "ǝꞁɐԀ ǝᵷuɐɹO",
  "block.minecraft.banner.stripe_center.pink": "ǝꞁɐԀ ʞuᴉԀ",
  "block.minecraft.banner.stripe_center.purple": "ǝꞁɐԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.stripe_center.red": "ǝꞁɐԀ pǝᴚ",
  "block.minecraft.banner.stripe_center.white": "ǝꞁɐԀ ǝʇᴉɥM",
  "block.minecraft.banner.stripe_center.yellow": "ǝꞁɐԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.stripe_downleft.black": "ɹǝʇsᴉuᴉS puǝᗺ ʞɔɐꞁᗺ",
  "block.minecraft.banner.stripe_downleft.blue": "ɹǝʇsᴉuᴉS puǝᗺ ǝnꞁᗺ",
  "block.minecraft.banner.stripe_downleft.brown": "ɹǝʇsᴉuᴉS puǝᗺ uʍoɹᗺ",
  "block.minecraft.banner.stripe_downleft.cyan": "ɹǝʇsᴉuᴉS puǝᗺ uɐʎƆ",
  "block.minecraft.banner.stripe_downleft.gray": "ɹǝʇsᴉuᴉS puǝᗺ ʎǝɹ⅁",
  "block.minecraft.banner.stripe_downleft.green": "ɹǝʇsᴉuᴉS puǝᗺ uǝǝɹ⅁",
  "block.minecraft.banner.stripe_downleft.light_blue": "ɹǝʇsᴉuᴉS puǝᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_downleft.light_gray": "ɹǝʇsᴉuᴉS puǝᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_downleft.lime": "ɹǝʇsᴉuᴉS puǝᗺ ǝɯᴉꞀ",
  "block.minecraft.banner.stripe_downleft.magenta": "ɹǝʇsᴉuᴉS puǝᗺ ɐʇuǝᵷɐW",
  "block.minecraft.banner.stripe_downleft.orange": "ɹǝʇsᴉuᴉS puǝᗺ ǝᵷuɐɹO",
  "block.minecraft.banner.stripe_downleft.pink": "ɹǝʇsᴉuᴉS puǝᗺ ʞuᴉԀ",
  "block.minecraft.banner.stripe_downleft.purple": "ɹǝʇsᴉuᴉS puǝᗺ ǝꞁdɹnԀ",
  "block.minecraft.banner.stripe_downleft.red": "ɹǝʇsᴉuᴉS puǝᗺ pǝᴚ",
  "block.minecraft.banner.stripe_downleft.white": "ɹǝʇsᴉuᴉS puǝᗺ ǝʇᴉɥM",
  "block.minecraft.banner.stripe_downleft.yellow": "ɹǝʇsᴉuᴉS puǝᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.stripe_downright.black": "puǝᗺ ʞɔɐꞁq",
  "block.minecraft.banner.stripe_downright.blue": "puǝᗺ ǝnꞁᗺ",
  "block.minecraft.banner.stripe_downright.brown": "puǝᗺ uʍoɹᗺ",
  "block.minecraft.banner.stripe_downright.cyan": "puǝᗺ uɐʎƆ",
  "block.minecraft.banner.stripe_downright.gray": "puǝᗺ ʎǝɹ⅁",
  "block.minecraft.banner.stripe_downright.green": "puǝᗺ uǝǝɹ⅁",
  "block.minecraft.banner.stripe_downright.light_blue": "puǝᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_downright.light_gray": "puǝᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_downright.lime": "puǝᗺ ǝɯᴉꞀ",
  "block.minecraft.banner.stripe_downright.magenta": "puǝᗺ ɐʇuǝᵷɐW",
  "block.minecraft.banner.stripe_downright.orange": "puǝᗺ ǝᵷuɐɹO",
  "block.minecraft.banner.stripe_downright.pink": "puǝᗺ ʞuᴉԀ",
  "block.minecraft.banner.stripe_downright.purple": "puǝᗺ ǝꞁdɹnԀ",
  "block.minecraft.banner.stripe_downright.red": "puǝᗺ pǝᴚ",
  "block.minecraft.banner.stripe_downright.white": "puǝᗺ ǝʇᴉɥM",
  "block.minecraft.banner.stripe_downright.yellow": "puǝᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.stripe_left.black": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.stripe_left.blue": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ǝnꞁᗺ",
  "block.minecraft.banner.stripe_left.brown": "ɹǝʇsᴉuᴉS ǝꞁɐԀ uʍoɹᗺ",
  "block.minecraft.banner.stripe_left.cyan": "ɹǝʇsᴉuᴉS ǝꞁɐԀ uɐʎƆ",
  "block.minecraft.banner.stripe_left.gray": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ʎǝɹ⅁",
  "block.minecraft.banner.stripe_left.green": "ɹǝʇsᴉuᴉS ǝꞁɐԀ uǝǝɹ⅁",
  "block.minecraft.banner.stripe_left.light_blue": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_left.light_gray": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_left.lime": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ǝɯᴉꞀ",
  "block.minecraft.banner.stripe_left.magenta": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.stripe_left.orange": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ǝᵷuɐɹO",
  "block.minecraft.banner.stripe_left.pink": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ʞuᴉԀ",
  "block.minecraft.banner.stripe_left.purple": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.stripe_left.red": "ɹǝʇsᴉuᴉS ǝꞁɐԀ pǝᴚ",
  "block.minecraft.banner.stripe_left.white": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ǝʇᴉɥM",
  "block.minecraft.banner.stripe_left.yellow": "ɹǝʇsᴉuᴉS ǝꞁɐԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.stripe_middle.black": "ssǝℲ ʞɔɐꞁᗺ",
  "block.minecraft.banner.stripe_middle.blue": "ssǝℲ ǝnꞁᗺ",
  "block.minecraft.banner.stripe_middle.brown": "ssǝℲ uʍoɹᗺ",
  "block.minecraft.banner.stripe_middle.cyan": "ssǝℲ uɐʎƆ",
  "block.minecraft.banner.stripe_middle.gray": "ssǝℲ ʎǝɹ⅁",
  "block.minecraft.banner.stripe_middle.green": "ssǝℲ uǝǝɹ⅁",
  "block.minecraft.banner.stripe_middle.light_blue": "ssǝℲ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_middle.light_gray": "ssǝℲ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_middle.lime": "ssǝℲ ǝɯᴉꞀ",
  "block.minecraft.banner.stripe_middle.magenta": "ssǝℲ ɐʇuǝᵷɐW",
  "block.minecraft.banner.stripe_middle.orange": "ssǝℲ ǝᵷuɐɹO",
  "block.minecraft.banner.stripe_middle.pink": "ssǝℲ ʞuᴉԀ",
  "block.minecraft.banner.stripe_middle.purple": "ssǝℲ ǝꞁdɹnԀ",
  "block.minecraft.banner.stripe_middle.red": "ssǝℲ pǝᴚ",
  "block.minecraft.banner.stripe_middle.white": "ssǝℲ ǝʇᴉɥM",
  "block.minecraft.banner.stripe_middle.yellow": "ssǝℲ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.stripe_right.black": "ɹǝʇxǝᗡ ǝꞁɐԀ ʞɔɐꞁᗺ",
  "block.minecraft.banner.stripe_right.blue": "ɹǝʇxǝᗡ ǝꞁɐԀ ǝnꞁᗺ",
  "block.minecraft.banner.stripe_right.brown": "ɹǝʇxǝᗡ ǝꞁɐԀ uʍoɹᗺ",
  "block.minecraft.banner.stripe_right.cyan": "ɹǝʇxǝᗡ ǝꞁɐԀ uɐʎƆ",
  "block.minecraft.banner.stripe_right.gray": "ɹǝʇxǝᗡ ǝꞁɐԀ ʎǝɹ⅁",
  "block.minecraft.banner.stripe_right.green": "ɹǝʇxǝᗡ ǝꞁɐԀ uǝǝɹ⅁",
  "block.minecraft.banner.stripe_right.light_blue": "ɹǝʇxǝᗡ ǝꞁɐԀ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_right.light_gray": "ɹǝʇxǝᗡ ǝꞁɐԀ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_right.lime": "ɹǝʇxǝᗡ ǝꞁɐԀ ǝɯᴉꞀ",
  "block.minecraft.banner.stripe_right.magenta": "ɹǝʇxǝᗡ ǝꞁɐԀ ɐʇuǝᵷɐW",
  "block.minecraft.banner.stripe_right.orange": "ɹǝʇxǝᗡ ǝꞁɐԀ ǝᵷuɐɹO",
  "block.minecraft.banner.stripe_right.pink": "ɹǝʇxǝᗡ ǝꞁɐԀ ʞuᴉԀ",
  "block.minecraft.banner.stripe_right.purple": "ɹǝʇxǝᗡ ǝꞁɐԀ ǝꞁdɹnԀ",
  "block.minecraft.banner.stripe_right.red": "ɹǝʇxǝᗡ ǝꞁɐԀ pǝᴚ",
  "block.minecraft.banner.stripe_right.white": "ɹǝʇxǝᗡ ǝꞁɐԀ ǝʇᴉɥM",
  "block.minecraft.banner.stripe_right.yellow": "ɹǝʇxǝᗡ ǝꞁɐԀ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.stripe_top.black": "ɟǝᴉɥƆ ʞɔɐꞁᗺ",
  "block.minecraft.banner.stripe_top.blue": "ɟǝᴉɥƆ ǝnꞁᗺ",
  "block.minecraft.banner.stripe_top.brown": "ɟǝᴉɥƆ uʍoɹᗺ",
  "block.minecraft.banner.stripe_top.cyan": "ɟǝᴉɥƆ uɐʎƆ",
  "block.minecraft.banner.stripe_top.gray": "ɟǝᴉɥƆ ʎǝɹ⅁",
  "block.minecraft.banner.stripe_top.green": "ɟǝᴉɥƆ uǝǝɹ⅁",
  "block.minecraft.banner.stripe_top.light_blue": "ɟǝᴉɥƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_top.light_gray": "ɟǝᴉɥƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.stripe_top.lime": "ɟǝᴉɥƆ ǝɯᴉꞀ",
  "block.minecraft.banner.stripe_top.magenta": "ɟǝᴉɥƆ ɐʇuǝᵷɐW",
  "block.minecraft.banner.stripe_top.orange": "ɟǝᴉɥƆ ǝᵷuɐɹO",
  "block.minecraft.banner.stripe_top.pink": "ɟǝᴉɥƆ ʞuᴉԀ",
  "block.minecraft.banner.stripe_top.purple": "ɟǝᴉɥƆ ǝꞁdɹnԀ",
  "block.minecraft.banner.stripe_top.red": "ɟǝᴉɥƆ pǝᴚ",
  "block.minecraft.banner.stripe_top.white": "ɟǝᴉɥƆ ǝʇᴉɥM",
  "block.minecraft.banner.stripe_top.yellow": "ɟǝᴉɥƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.triangle_bottom.black": "uoɹʌǝɥƆ pǝʇɹǝʌuI ʞɔɐꞁᗺ",
  "block.minecraft.banner.triangle_bottom.blue": "uoɹʌǝɥƆ pǝʇɹǝʌuI ǝnꞁᗺ",
  "block.minecraft.banner.triangle_bottom.brown": "uoɹʌǝɥƆ pǝʇɹǝʌuI uʍoɹᗺ",
  "block.minecraft.banner.triangle_bottom.cyan": "uoɹʌǝɥƆ pǝʇɹǝʌuI uɐʎƆ",
  "block.minecraft.banner.triangle_bottom.gray": "uoɹʌǝɥƆ pǝʇɹǝʌuI ʎǝɹ⅁",
  "block.minecraft.banner.triangle_bottom.green": "uoɹʌǝɥƆ pǝʇɹǝʌuI uǝǝɹ⅁",
  "block.minecraft.banner.triangle_bottom.light_blue": "uoɹʌǝɥƆ pǝʇɹǝʌuI ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.triangle_bottom.light_gray": "uoɹʌǝɥƆ pǝʇɹǝʌuI ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.triangle_bottom.lime": "uoɹʌǝɥƆ pǝʇɹǝʌuI ǝɯᴉꞀ",
  "block.minecraft.banner.triangle_bottom.magenta": "uoɹʌǝɥƆ pǝʇɹǝʌuI ɐʇuǝᵷɐW",
  "block.minecraft.banner.triangle_bottom.orange": "uoɹʌǝɥƆ pǝʇɹǝʌuI ǝᵷuɐɹO",
  "block.minecraft.banner.triangle_bottom.pink": "uoɹʌǝɥƆ pǝʇɹǝʌuI ʞuᴉԀ",
  "block.minecraft.banner.triangle_bottom.purple": "uoɹʌǝɥƆ pǝʇɹǝʌuI ǝꞁdɹnԀ",
  "block.minecraft.banner.triangle_bottom.red": "uoɹʌǝɥƆ pǝʇɹǝʌuI pǝᴚ",
  "block.minecraft.banner.triangle_bottom.white": "uoɹʌǝɥƆ pǝʇɹǝʌuI ǝʇᴉɥM",
  "block.minecraft.banner.triangle_bottom.yellow": "uoɹʌǝɥƆ pǝʇɹǝʌuI ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.triangle_top.black": "uoɹʌǝɥƆ ʞɔɐꞁᗺ",
  "block.minecraft.banner.triangle_top.blue": "uoɹʌǝɥƆ ǝnꞁᗺ",
  "block.minecraft.banner.triangle_top.brown": "uoɹʌǝɥƆ uʍoɹᗺ",
  "block.minecraft.banner.triangle_top.cyan": "uoɹʌǝɥƆ uɐʎƆ",
  "block.minecraft.banner.triangle_top.gray": "uoɹʌǝɥƆ ʎǝɹ⅁",
  "block.minecraft.banner.triangle_top.green": "uoɹʌǝɥƆ uǝǝɹ⅁",
  "block.minecraft.banner.triangle_top.light_blue": "uoɹʌǝɥƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.triangle_top.light_gray": "uoɹʌǝɥƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.triangle_top.lime": "uoɹʌǝɥƆ ǝɯᴉꞀ",
  "block.minecraft.banner.triangle_top.magenta": "uoɹʌǝɥƆ ɐʇuǝᵷɐW",
  "block.minecraft.banner.triangle_top.orange": "uoɹʌǝɥƆ ǝᵷuɐɹO",
  "block.minecraft.banner.triangle_top.pink": "uoɹʌǝɥƆ ʞuᴉԀ",
  "block.minecraft.banner.triangle_top.purple": "uoɹʌǝɥƆ ǝꞁdɹnԀ",
  "block.minecraft.banner.triangle_top.red": "uoɹʌǝɥƆ pǝᴚ",
  "block.minecraft.banner.triangle_top.white": "uoɹʌǝɥƆ ǝʇᴉɥM",
  "block.minecraft.banner.triangle_top.yellow": "uoɹʌǝɥƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.triangles_bottom.black": "pǝʇuǝpuI ɟǝᴉɥƆ ʞɔɐꞁᗺ",
  "block.minecraft.banner.triangles_bottom.blue": "pǝʇuǝpuI ɟǝᴉɥƆ ǝnꞁᗺ",
  "block.minecraft.banner.triangles_bottom.brown": "pǝʇuǝpuI ɟǝᴉɥƆ uʍoɹᗺ",
  "block.minecraft.banner.triangles_bottom.cyan": "pǝʇuǝpuI ɟǝᴉɥƆ uɐʎƆ",
  "block.minecraft.banner.triangles_bottom.gray": "pǝʇuǝpuI ɟǝᴉɥƆ ʎǝɹ⅁",
  "block.minecraft.banner.triangles_bottom.green": "pǝʇuǝpuI ɟǝᴉɥƆ uǝǝɹ⅁",
  "block.minecraft.banner.triangles_bottom.light_blue": "pǝʇuǝpuI ɟǝᴉɥƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.triangles_bottom.light_gray": "pǝʇuǝpuI ɟǝᴉɥƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.triangles_bottom.lime": "pǝʇuǝpuI ɟǝᴉɥƆ ǝɯᴉꞀ",
  "block.minecraft.banner.triangles_bottom.magenta": "pǝʇuǝpuI ɟǝᴉɥƆ ɐʇuǝᵷɐW",
  "block.minecraft.banner.triangles_bottom.orange": "pǝʇuǝpuI ɟǝᴉɥƆ ǝᵷuɐɹO",
  "block.minecraft.banner.triangles_bottom.pink": "pǝʇuǝpuI ɟǝᴉɥƆ ʞuᴉԀ",
  "block.minecraft.banner.triangles_bottom.purple": "pǝʇuǝpuI ɟǝᴉɥƆ ǝꞁdɹnԀ",
  "block.minecraft.banner.triangles_bottom.red": "pǝʇuǝpuI ɟǝᴉɥƆ pǝᴚ",
  "block.minecraft.banner.triangles_bottom.white": "pǝʇuǝpuI ɟǝᴉɥƆ ǝʇᴉɥM",
  "block.minecraft.banner.triangles_bottom.yellow": "pǝʇuǝpuI ɟǝᴉɥƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.banner.triangles_top.black": "pǝʇuǝpuI ǝsɐᗺ ʞɔɐꞁᗺ",
  "block.minecraft.banner.triangles_top.blue": "pǝʇuǝpuI ǝsɐᗺ ǝnꞁᗺ",
  "block.minecraft.banner.triangles_top.brown": "pǝʇuǝpuI ǝsɐᗺ uʍoɹᗺ",
  "block.minecraft.banner.triangles_top.cyan": "pǝʇuǝpuI ǝsɐᗺ uɐʎƆ",
  "block.minecraft.banner.triangles_top.gray": "pǝʇuǝpuI ǝsɐᗺ ʎǝɹ⅁",
  "block.minecraft.banner.triangles_top.green": "pǝʇuǝpuI ǝsɐᗺ uǝǝɹ⅁",
  "block.minecraft.banner.triangles_top.light_blue": "pǝʇuǝpuI ǝsɐᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.triangles_top.light_gray": "pǝʇuǝpuI ǝsɐᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.banner.triangles_top.lime": "pǝʇuǝpuI ǝsɐᗺ ǝɯᴉꞀ",
  "block.minecraft.banner.triangles_top.magenta": "pǝʇuǝpuI ǝsɐᗺ ɐʇuǝᵷɐW",
  "block.minecraft.banner.triangles_top.orange": "pǝʇuǝpuI ǝsɐᗺ ǝᵷuɐɹO",
  "block.minecraft.banner.triangles_top.pink": "pǝʇuǝpuI ǝsɐᗺ ʞuᴉԀ",
  "block.minecraft.banner.triangles_top.purple": "pǝʇuǝpuI ǝsɐᗺ ǝꞁdɹnԀ",
  "block.minecraft.banner.triangles_top.red": "pǝʇuǝpuI ǝsɐᗺ pǝᴚ",
  "block.minecraft.banner.triangles_top.white": "pǝʇuǝpuI ǝsɐᗺ ǝʇᴉɥM",
  "block.minecraft.banner.triangles_top.yellow": "pǝʇuǝpuI ǝsɐᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.barrel": "ꞁǝɹɹɐᗺ",
  "block.minecraft.barrier": "ɹǝᴉɹɹɐᗺ",
  "block.minecraft.basalt": "ʇꞁɐsɐᗺ",
  "block.minecraft.beacon": "uoɔɐǝᗺ",
  "block.minecraft.beacon.primary": "ɹǝʍoԀ ʎɹɐɯᴉɹԀ",
  "block.minecraft.beacon.secondary": "ɹǝʍoԀ ʎɹɐpuoɔǝS",
  "block.minecraft.bed.no_sleep": "sɯɹoʇsɹǝpunɥʇ ᵷuᴉɹnp ɹo ʇɥᵷᴉu ʇɐ ʎꞁuo dǝǝꞁs uɐɔ no⅄",
  "block.minecraft.bed.not_safe": "ʎqɹɐǝu sɹǝʇsuoɯ ǝɹɐ ǝɹǝɥʇ ⸵ʍou ʇsǝɹ ʇou ʎɐɯ no⅄",
  "block.minecraft.bed.obstructed": "pǝʇɔnɹʇsqo sᴉ pǝᗺ sᴉɥ⟘",
  "block.minecraft.bed.occupied": "pǝᴉdnɔɔo sᴉ pǝᗺ sᴉɥ⟘",
  "block.minecraft.bed.too_far_away": "ʎɐʍɐ ɹɐɟ ooʇ sᴉ pǝᗺ ǝɥʇ ⸵ʍou ʇsǝɹ ʇou ʎɐɯ no⅄",
  "block.minecraft.bedrock": "ʞɔoɹpǝᗺ",
  "block.minecraft.bee_nest": "ʇsǝN ǝǝᗺ",
  "block.minecraft.beehive": "ǝʌᴉɥǝǝᗺ",
  "block.minecraft.beetroots": "sʇooɹʇǝǝᗺ",
  "block.minecraft.bell": "ꞁꞁǝᗺ",
  "block.minecraft.big_dripleaf": "ɟɐǝꞁdᴉɹᗡ ᵷᴉᗺ",
  "block.minecraft.big_dripleaf_stem": "ɯǝʇS ɟɐǝꞁdᴉɹᗡ ᵷᴉᗺ",
  "block.minecraft.birch_button": "uoʇʇnᗺ ɥɔɹᴉᗺ",
  "block.minecraft.birch_door": "ɹooᗡ ɥɔɹᴉᗺ",
  "block.minecraft.birch_fence": "ǝɔuǝℲ ɥɔɹᴉᗺ",
  "block.minecraft.birch_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ ɥɔɹᴉᗺ",
  "block.minecraft.birch_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ɥɔɹᴉᗺ",
  "block.minecraft.birch_leaves": "sǝʌɐǝꞀ ɥɔɹᴉᗺ",
  "block.minecraft.birch_log": "ᵷoꞀ ɥɔɹᴉᗺ",
  "block.minecraft.birch_planks": "sʞuɐꞁԀ ɥɔɹᴉᗺ",
  "block.minecraft.birch_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ɥɔɹᴉᗺ",
  "block.minecraft.birch_sapling": "ᵷuᴉꞁdɐS ɥɔɹᴉᗺ",
  "block.minecraft.birch_shelf": "ɟlǝɥS ɥɔɹᴉᗺ",
  "block.minecraft.birch_sign": "uᵷᴉS ɥɔɹᴉᗺ",
  "block.minecraft.birch_slab": "qɐꞁS ɥɔɹᴉᗺ",
  "block.minecraft.birch_stairs": "sɹᴉɐʇS ɥɔɹᴉᗺ",
  "block.minecraft.birch_trapdoor": "ɹoopdɐɹ⟘ ɥɔɹᴉᗺ",
  "block.minecraft.birch_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM ɥɔɹᴉᗺ",
  "block.minecraft.birch_wall_sign": "uᵷᴉS ꞁꞁɐM ɥɔɹᴉᗺ",
  "block.minecraft.birch_wood": "pooM ɥɔɹᴉᗺ",
  "block.minecraft.black_banner": "ɹǝuuɐᗺ ʞɔɐꞁᗺ",
  "block.minecraft.black_bed": "pǝᗺ ʞɔɐꞁᗺ",
  "block.minecraft.black_candle": "ǝꞁpuɐƆ ʞɔɐꞁᗺ",
  "block.minecraft.black_candle_cake": "ǝꞁpuɐƆ ʞɔɐꞁᗺ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.black_carpet": "ʇǝdɹɐƆ ʞɔɐꞁᗺ",
  "block.minecraft.black_concrete": "ǝʇǝɹɔuoƆ ʞɔɐꞁᗺ",
  "block.minecraft.black_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ʞɔɐꞁᗺ",
  "block.minecraft.black_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ʞɔɐꞁᗺ",
  "block.minecraft.black_shulker_box": "xoᗺ ɹǝʞꞁnɥS ʞɔɐꞁᗺ",
  "block.minecraft.black_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ʞɔɐꞁᗺ",
  "block.minecraft.black_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ʞɔɐꞁᗺ",
  "block.minecraft.black_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ʞɔɐꞁᗺ",
  "block.minecraft.black_wool": "ꞁooM ʞɔɐꞁᗺ",
  "block.minecraft.blackstone": "ǝuoʇsʞɔɐꞁᗺ",
  "block.minecraft.blackstone_slab": "qɐꞁS ǝuoʇsʞɔɐꞁᗺ",
  "block.minecraft.blackstone_stairs": "sɹᴉɐʇS ǝuoʇsʞɔɐꞁᗺ",
  "block.minecraft.blackstone_wall": "ꞁꞁɐM ǝuoʇsʞɔɐꞁᗺ",
  "block.minecraft.blast_furnace": "ǝɔɐuɹnℲ ʇsɐꞁᗺ",
  "block.minecraft.blue_banner": "ɹǝuuɐᗺ ǝnꞁᗺ",
  "block.minecraft.blue_bed": "pǝᗺ ǝnꞁᗺ",
  "block.minecraft.blue_candle": "ǝꞁpuɐƆ ǝnꞁᗺ",
  "block.minecraft.blue_candle_cake": "ǝꞁpuɐƆ ǝnꞁᗺ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.blue_carpet": "ʇǝdɹɐƆ ǝnꞁᗺ",
  "block.minecraft.blue_concrete": "ǝʇǝɹɔuoƆ ǝnꞁᗺ",
  "block.minecraft.blue_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ǝnꞁᗺ",
  "block.minecraft.blue_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝnꞁᗺ",
  "block.minecraft.blue_ice": "ǝɔI ǝnꞁᗺ",
  "block.minecraft.blue_orchid": "pᴉɥɔɹO ǝnꞁᗺ",
  "block.minecraft.blue_shulker_box": "xoᗺ ɹǝʞꞁnɥS ǝnꞁᗺ",
  "block.minecraft.blue_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ǝnꞁᗺ",
  "block.minecraft.blue_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ǝnꞁᗺ",
  "block.minecraft.blue_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝnꞁᗺ",
  "block.minecraft.blue_wool": "ꞁooM ǝnꞁᗺ",
  "block.minecraft.bone_block": "ʞɔoꞁᗺ ǝuoᗺ",
  "block.minecraft.bookshelf": "ɟꞁǝɥsʞooᗺ",
  "block.minecraft.brain_coral": "ꞁɐɹoƆ uᴉɐɹᗺ",
  "block.minecraft.brain_coral_block": "ʞɔoꞁᗺ ꞁɐɹoƆ uᴉɐɹᗺ",
  "block.minecraft.brain_coral_fan": "uɐℲ ꞁɐɹoƆ uᴉɐɹᗺ",
  "block.minecraft.brain_coral_wall_fan": "uɐℲ ꞁꞁɐM ꞁɐɹoƆ uᴉɐɹᗺ",
  "block.minecraft.brewing_stand": "puɐʇS ᵷuᴉʍǝɹᗺ",
  "block.minecraft.brick_slab": "qɐꞁS ʞɔᴉɹᗺ",
  "block.minecraft.brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ",
  "block.minecraft.brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ",
  "block.minecraft.bricks": "sʞɔᴉɹᗺ",
  "block.minecraft.brown_banner": "ɹǝuuɐᗺ uʍoɹᗺ",
  "block.minecraft.brown_bed": "pǝᗺ uʍoɹᗺ",
  "block.minecraft.brown_candle": "ǝꞁpuɐƆ uʍoɹᗺ",
  "block.minecraft.brown_candle_cake": "ǝꞁpuɐƆ uʍoɹᗺ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.brown_carpet": "ʇǝdɹɐƆ uʍoɹᗺ",
  "block.minecraft.brown_concrete": "ǝʇǝɹɔuoƆ uʍoɹᗺ",
  "block.minecraft.brown_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ uʍoɹᗺ",
  "block.minecraft.brown_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ uʍoɹᗺ",
  "block.minecraft.brown_mushroom": "ɯooɹɥsnW uʍoɹᗺ",
  "block.minecraft.brown_mushroom_block": "ʞɔoꞁᗺ ɯooɹɥsnW uʍoɹᗺ",
  "block.minecraft.brown_shulker_box": "xoᗺ ɹǝʞꞁnɥS uʍoɹᗺ",
  "block.minecraft.brown_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS uʍoɹᗺ",
  "block.minecraft.brown_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS uʍoɹᗺ",
  "block.minecraft.brown_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ uʍoɹᗺ",
  "block.minecraft.brown_wool": "ꞁooM uʍoɹᗺ",
  "block.minecraft.bubble_column": "uɯnꞁoƆ ǝꞁqqnᗺ",
  "block.minecraft.bubble_coral": "ꞁɐɹoƆ ǝꞁqqnᗺ",
  "block.minecraft.bubble_coral_block": "ʞɔoꞁᗺ ꞁɐɹoƆ ǝꞁqqnᗺ",
  "block.minecraft.bubble_coral_fan": "uɐℲ ꞁɐɹoƆ ǝꞁqqnᗺ",
  "block.minecraft.bubble_coral_wall_fan": "uɐℲ ꞁꞁɐM ꞁɐɹoƆ ǝꞁqqnᗺ",
  "block.minecraft.budding_amethyst": "ʇsʎɥʇǝɯⱯ ᵷuᴉppnᗺ",
  "block.minecraft.bush": "ɥsnᗺ",
  "block.minecraft.cactus": "snʇɔɐƆ",
  "block.minecraft.cactus_flower": "ɹǝʍoꞁℲ snʇɔɐƆ",
  "block.minecraft.cake": "ǝʞɐƆ",
  "block.minecraft.calcite": "ǝʇᴉɔꞁɐƆ",
  "block.minecraft.calibrated_sculk_sensor": "ɹosuǝS ʞꞁnɔS pǝʇɐɹqᴉꞁɐƆ",
  "block.minecraft.campfire": "ǝɹᴉɟdɯɐƆ",
  "block.minecraft.candle": "ǝꞁpuɐƆ",
  "block.minecraft.candle_cake": "ǝꞁpuɐƆ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.carrots": "sʇoɹɹɐƆ",
  "block.minecraft.cartography_table": "ǝꞁqɐ⟘ ʎɥdɐɹᵷoʇɹɐƆ",
  "block.minecraft.carved_pumpkin": "uᴉʞdɯnԀ pǝʌɹɐƆ",
  "block.minecraft.cauldron": "uoɹpꞁnɐƆ",
  "block.minecraft.cave_air": "ɹᴉⱯ ǝʌɐƆ",
  "block.minecraft.cave_vines": "sǝuᴉɅ ǝʌɐƆ",
  "block.minecraft.cave_vines_plant": "ʇuɐꞁԀ sǝuᴉɅ ǝʌɐƆ",
  "block.minecraft.chain": "uᴉɐɥƆ",
  "block.minecraft.chain_command_block": "ʞɔoꞁᗺ puɐɯɯoƆ uᴉɐɥƆ",
  "block.minecraft.cherry_button": "uoʇʇnᗺ ʎɹɹǝɥƆ",
  "block.minecraft.cherry_door": "ɹooᗡ ʎɹɹǝɥƆ",
  "block.minecraft.cherry_fence": "ǝɔuǝℲ ʎɹɹǝɥƆ",
  "block.minecraft.cherry_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ ʎɹɹǝɥƆ",
  "block.minecraft.cherry_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ʎɹɹǝɥƆ",
  "block.minecraft.cherry_leaves": "sǝʌɐǝꞀ ʎɹɹǝɥƆ",
  "block.minecraft.cherry_log": "ᵷoꞀ ʎɹɹǝɥƆ",
  "block.minecraft.cherry_planks": "sʞuɐꞁԀ ʎɹɹǝɥƆ",
  "block.minecraft.cherry_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ʎɹɹǝɥƆ",
  "block.minecraft.cherry_sapling": "ᵷuᴉꞁdɐS ʎɹɹǝɥƆ",
  "block.minecraft.cherry_shelf": "ɟlǝɥS ʎɹɹǝɥƆ",
  "block.minecraft.cherry_sign": "uᵷᴉS ʎɹɹǝɥƆ",
  "block.minecraft.cherry_slab": "qɐꞁS ʎɹɹǝɥƆ",
  "block.minecraft.cherry_stairs": "sɹᴉɐʇS ʎɹɹǝɥƆ",
  "block.minecraft.cherry_trapdoor": "ɹoopdɐɹ⟘ ʎɹɹǝɥƆ",
  "block.minecraft.cherry_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM ʎɹɹǝɥƆ",
  "block.minecraft.cherry_wall_sign": "uᵷᴉS ꞁꞁɐM ʎɹɹǝɥƆ",
  "block.minecraft.cherry_wood": "pooM ʎɹɹǝɥƆ",
  "block.minecraft.chest": "ʇsǝɥƆ",
  "block.minecraft.chipped_anvil": "ꞁᴉʌuⱯ pǝddᴉɥƆ",
  "block.minecraft.chiseled_bookshelf": "ɟꞁǝɥsʞooᗺ pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_copper": "ɹǝddoƆ pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_deepslate": "ǝʇɐꞁsdǝǝᗡ pǝꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_nether_bricks": "sʞɔᴉɹᗺ ɹǝɥʇǝN pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_polished_blackstone": "ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_quartz_block": "ʞɔoꞁᗺ zʇɹɐnꝹ pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_red_sandstone": "ǝuoʇspuɐS pǝᴚ pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_resin_bricks": "sʞɔᴉɹᗺ uᴉsǝᴚ pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_sandstone": "ǝuoʇspuɐS pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇS pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_tuff": "ɟɟn⟘ pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chiseled_tuff_bricks": "sʞɔᴉɹᗺ ɟɟn⟘ pǝꞁꞁǝsᴉɥƆ",
  "block.minecraft.chorus_flower": "ɹǝʍoꞁℲ snɹoɥƆ",
  "block.minecraft.chorus_plant": "ʇuɐꞁԀ snɹoɥƆ",
  "block.minecraft.clay": "ʎɐꞁƆ",
  "block.minecraft.closed_eyeblossom": "ɯossoꞁqǝʎƎ pǝsoꞁƆ",
  "block.minecraft.coal_block": "ʞɔoꞁᗺ ꞁɐoƆ",
  "block.minecraft.coal_ore": "ǝɹO ꞁɐoƆ",
  "block.minecraft.coarse_dirt": "ʇɹᴉᗡ ǝsɹɐoƆ",
  "block.minecraft.cobbled_deepslate": "ǝʇɐꞁsdǝǝᗡ pǝꞁqqoƆ",
  "block.minecraft.cobbled_deepslate_slab": "qɐꞁS ǝʇɐꞁsdǝǝᗡ pǝꞁqqoƆ",
  "block.minecraft.cobbled_deepslate_stairs": "sɹᴉɐʇS ǝʇɐꞁsdǝǝᗡ pǝꞁqqoƆ",
  "block.minecraft.cobbled_deepslate_wall": "ꞁꞁɐM ǝʇɐꞁsdǝǝᗡ pǝꞁqqoƆ",
  "block.minecraft.cobblestone": "ǝuoʇsǝꞁqqoƆ",
  "block.minecraft.cobblestone_slab": "qɐꞁS ǝuoʇsǝꞁqqoƆ",
  "block.minecraft.cobblestone_stairs": "sɹᴉɐʇS ǝuoʇsǝꞁqqoƆ",
  "block.minecraft.cobblestone_wall": "ꞁꞁɐM ǝuoʇsǝꞁqqoƆ",
  "block.minecraft.cobweb": "qǝʍqoƆ",
  "block.minecraft.cocoa": "ɐoɔoƆ",
  "block.minecraft.command_block": "ʞɔoꞁᗺ puɐɯɯoƆ",
  "block.minecraft.comparator": "ɹoʇɐɹɐdɯoƆ ǝuoʇspǝᴚ",
  "block.minecraft.composter": "ɹǝʇsodɯoƆ",
  "block.minecraft.conduit": "ʇᴉnpuoƆ",
  "block.minecraft.copper_bars": "sɹɐᗺ ɹǝddoƆ",
  "block.minecraft.copper_block": "ɹǝddoƆ ɟo ʞɔoꞁᗺ",
  "block.minecraft.copper_bulb": "qꞁnᗺ ɹǝddoƆ",
  "block.minecraft.copper_chain": "uᴉɐɥƆ ɹǝddoƆ",
  "block.minecraft.copper_chest": "ʇsǝɥƆ ɹǝddoƆ",
  "block.minecraft.copper_door": "ɹooᗡ ɹǝddoƆ",
  "block.minecraft.copper_golem_statue": "ǝnʇɐʇS ɯǝꞁo⅁ ɹǝddoƆ",
  "block.minecraft.copper_grate": "ǝʇɐɹ⅁ ɹǝddoƆ",
  "block.minecraft.copper_lantern": "uɹǝʇuɐꞀ ɹǝddoƆ",
  "block.minecraft.copper_ore": "ǝɹO ɹǝddoƆ",
  "block.minecraft.copper_torch": "ɥɔɹo⟘ ɹǝddoƆ",
  "block.minecraft.copper_trapdoor": "ɹoopdɐɹ⟘ ɹǝddoƆ",
  "block.minecraft.copper_wall_torch": "ɥɔɹo⟘ ꞁꞁɐM ɹǝddoƆ",
  "block.minecraft.cornflower": "ɹǝʍoꞁɟuɹoƆ",
  "block.minecraft.cracked_deepslate_bricks": "sʞɔᴉɹᗺ ǝʇɐꞁsdǝǝᗡ pǝʞɔɐɹƆ",
  "block.minecraft.cracked_deepslate_tiles": "sǝꞁᴉ⟘ ǝʇɐꞁsdǝǝᗡ pǝʞɔɐɹƆ",
  "block.minecraft.cracked_nether_bricks": "sʞɔᴉɹᗺ ɹǝɥʇǝN pǝʞɔɐɹƆ",
  "block.minecraft.cracked_polished_blackstone_bricks": "sʞɔᴉɹᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ pǝʞɔɐɹƆ",
  "block.minecraft.cracked_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇS pǝʞɔɐɹƆ",
  "block.minecraft.crafter": "ɹǝʇɟɐɹƆ",
  "block.minecraft.crafting_table": "ǝꞁqɐ⟘ ᵷuᴉʇɟɐɹƆ",
  "block.minecraft.creaking_heart": "ʇɹɐǝH ᵷuᴉʞɐǝɹƆ",
  "block.minecraft.creeper_head": "pɐǝH ɹǝdǝǝɹƆ",
  "block.minecraft.creeper_wall_head": "pɐǝH ꞁꞁɐM ɹǝdǝǝɹƆ",
  "block.minecraft.crimson_button": "uoʇʇnᗺ uosɯᴉɹƆ",
  "block.minecraft.crimson_door": "ɹooᗡ uosɯᴉɹƆ",
  "block.minecraft.crimson_fence": "ǝɔuǝℲ uosɯᴉɹƆ",
  "block.minecraft.crimson_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ uosɯᴉɹƆ",
  "block.minecraft.crimson_fungus": "snᵷunℲ uosɯᴉɹƆ",
  "block.minecraft.crimson_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH uosɯᴉɹƆ",
  "block.minecraft.crimson_hyphae": "ǝɐɥdʎH uosɯᴉɹƆ",
  "block.minecraft.crimson_nylium": "ɯnᴉꞁʎN uosɯᴉɹƆ",
  "block.minecraft.crimson_planks": "sʞuɐꞁԀ uosɯᴉɹƆ",
  "block.minecraft.crimson_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ uosɯᴉɹƆ",
  "block.minecraft.crimson_roots": "sʇooᴚ uosɯᴉɹƆ",
  "block.minecraft.crimson_shelf": "ɟlǝɥS uosɯᴉɹƆ",
  "block.minecraft.crimson_sign": "uᵷᴉS uosɯᴉɹƆ",
  "block.minecraft.crimson_slab": "qɐꞁS uosɯᴉɹƆ",
  "block.minecraft.crimson_stairs": "sɹᴉɐʇS uosɯᴉɹƆ",
  "block.minecraft.crimson_stem": "ɯǝʇS uosɯᴉɹƆ",
  "block.minecraft.crimson_trapdoor": "ɹoopdɐɹ⟘ uosɯᴉɹƆ",
  "block.minecraft.crimson_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM uosɯᴉɹƆ",
  "block.minecraft.crimson_wall_sign": "uᵷᴉS ꞁꞁɐM uosɯᴉɹƆ",
  "block.minecraft.crying_obsidian": "uɐᴉpᴉsqO ᵷuᴉʎɹƆ",
  "block.minecraft.cut_copper": "ɹǝddoƆ ʇnƆ",
  "block.minecraft.cut_copper_slab": "qɐꞁS ɹǝddoƆ ʇnƆ",
  "block.minecraft.cut_copper_stairs": "sɹᴉɐʇS ɹǝddoƆ ʇnƆ",
  "block.minecraft.cut_red_sandstone": "ǝuoʇspuɐS pǝᴚ ʇnƆ",
  "block.minecraft.cut_red_sandstone_slab": "qɐꞁS ǝuoʇspuɐS pǝᴚ ʇnƆ",
  "block.minecraft.cut_sandstone": "ǝuoʇspuɐS ʇnƆ",
  "block.minecraft.cut_sandstone_slab": "qɐꞁS ǝuoʇspuɐS ʇnƆ",
  "block.minecraft.cyan_banner": "ɹǝuuɐᗺ uɐʎƆ",
  "block.minecraft.cyan_bed": "pǝᗺ uɐʎƆ",
  "block.minecraft.cyan_candle": "ǝꞁpuɐƆ uɐʎƆ",
  "block.minecraft.cyan_candle_cake": "ǝꞁpuɐƆ uɐʎƆ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.cyan_carpet": "ʇǝdɹɐƆ uɐʎƆ",
  "block.minecraft.cyan_concrete": "ǝʇǝɹɔuoƆ uɐʎƆ",
  "block.minecraft.cyan_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ uɐʎƆ",
  "block.minecraft.cyan_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ uɐʎƆ",
  "block.minecraft.cyan_shulker_box": "xoᗺ ɹǝʞꞁnɥS uɐʎƆ",
  "block.minecraft.cyan_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS uɐʎƆ",
  "block.minecraft.cyan_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS uɐʎƆ",
  "block.minecraft.cyan_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ uɐʎƆ",
  "block.minecraft.cyan_wool": "ꞁooM uɐʎƆ",
  "block.minecraft.damaged_anvil": "ꞁᴉʌuⱯ pǝᵷɐɯɐᗡ",
  "block.minecraft.dandelion": "uoᴉꞁǝpuɐᗡ",
  "block.minecraft.dark_oak_button": "uoʇʇnᗺ ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_door": "ɹooᗡ ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_fence": "ǝɔuǝℲ ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_leaves": "sǝʌɐǝꞀ ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_log": "ᵷoꞀ ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_planks": "sʞuɐꞁԀ ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_sapling": "ᵷuᴉꞁdɐS ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_shelf": "ɟlǝɥS ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_sign": "uᵷᴉS ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_slab": "qɐꞁS ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_stairs": "sɹᴉɐʇS ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_trapdoor": "ɹoopdɐɹ⟘ ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_wall_sign": "uᵷᴉS ꞁꞁɐM ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_oak_wood": "pooM ʞɐO ʞɹɐᗡ",
  "block.minecraft.dark_prismarine": "ǝuᴉɹɐɯsᴉɹԀ ʞɹɐᗡ",
  "block.minecraft.dark_prismarine_slab": "qɐꞁS ǝuᴉɹɐɯsᴉɹԀ ʞɹɐᗡ",
  "block.minecraft.dark_prismarine_stairs": "sɹᴉɐʇS ǝuᴉɹɐɯsᴉɹԀ ʞɹɐᗡ",
  "block.minecraft.daylight_detector": "ɹoʇɔǝʇǝᗡ ʇɥᵷᴉꞁʎɐᗡ",
  "block.minecraft.dead_brain_coral": "ꞁɐɹoƆ uᴉɐɹᗺ pɐǝᗡ",
  "block.minecraft.dead_brain_coral_block": "ʞɔoꞁᗺ ꞁɐɹoƆ uᴉɐɹᗺ pɐǝᗡ",
  "block.minecraft.dead_brain_coral_fan": "uɐℲ ꞁɐɹoƆ uᴉɐɹᗺ pɐǝᗡ",
  "block.minecraft.dead_brain_coral_wall_fan": "uɐℲ ꞁꞁɐM ꞁɐɹoƆ uᴉɐɹᗺ pɐǝᗡ",
  "block.minecraft.dead_bubble_coral": "ꞁɐɹoƆ ǝꞁqqnᗺ pɐǝᗡ",
  "block.minecraft.dead_bubble_coral_block": "ʞɔoꞁᗺ ꞁɐɹoƆ ǝꞁqqnᗺ pɐǝᗡ",
  "block.minecraft.dead_bubble_coral_fan": "uɐℲ ꞁɐɹoƆ ǝꞁqqnᗺ pɐǝᗡ",
  "block.minecraft.dead_bubble_coral_wall_fan": "uɐℲ ꞁꞁɐM ꞁɐɹoƆ ǝꞁqqnᗺ pɐǝᗡ",
  "block.minecraft.dead_bush": "ɥsnᗺ pɐǝᗡ",
  "block.minecraft.dead_fire_coral": "ꞁɐɹoƆ ǝɹᴉℲ pɐǝᗡ",
  "block.minecraft.dead_fire_coral_block": "ʞɔoꞁᗺ ꞁɐɹoƆ ǝɹᴉℲ pɐǝᗡ",
  "block.minecraft.dead_fire_coral_fan": "uɐℲ ꞁɐɹoƆ ǝɹᴉℲ pɐǝᗡ",
  "block.minecraft.dead_fire_coral_wall_fan": "uɐℲ ꞁꞁɐM ꞁɐɹoƆ ǝɹᴉℲ pɐǝᗡ",
  "block.minecraft.dead_horn_coral": "ꞁɐɹoƆ uɹoH pɐǝᗡ",
  "block.minecraft.dead_horn_coral_block": "ʞɔoꞁᗺ ꞁɐɹoƆ uɹoH pɐǝᗡ",
  "block.minecraft.dead_horn_coral_fan": "uɐℲ ꞁɐɹoƆ uɹoH pɐǝᗡ",
  "block.minecraft.dead_horn_coral_wall_fan": "uɐℲ ꞁꞁɐM ꞁɐɹoƆ uɹoH pɐǝᗡ",
  "block.minecraft.dead_tube_coral": "ꞁɐɹoƆ ǝqn⟘ pɐǝᗡ",
  "block.minecraft.dead_tube_coral_block": "ʞɔoꞁᗺ ꞁɐɹoƆ ǝqn⟘ pɐǝᗡ",
  "block.minecraft.dead_tube_coral_fan": "uɐℲ ꞁɐɹoƆ ǝqn⟘ pɐǝᗡ",
  "block.minecraft.dead_tube_coral_wall_fan": "uɐℲ ꞁꞁɐM ꞁɐɹoƆ ǝqn⟘ pɐǝᗡ",
  "block.minecraft.decorated_pot": "ʇoԀ pǝʇɐɹoɔǝᗡ",
  "block.minecraft.deepslate": "ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_brick_slab": "qɐꞁS ʞɔᴉɹᗺ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_bricks": "sʞɔᴉɹᗺ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_coal_ore": "ǝɹO ꞁɐoƆ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_copper_ore": "ǝɹO ɹǝddoƆ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_diamond_ore": "ǝɹO puoɯɐᴉᗡ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_emerald_ore": "ǝɹO pꞁɐɹǝɯƎ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_gold_ore": "ǝɹO pꞁo⅁ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_iron_ore": "ǝɹO uoɹI ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_lapis_ore": "ǝɹO ᴉꞁnzɐꞀ sᴉdɐꞀ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_redstone_ore": "ǝɹO ǝuoʇspǝᴚ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_tile_slab": "qɐꞁS ǝꞁᴉ⟘ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_tile_stairs": "sɹᴉɐʇS ǝꞁᴉ⟘ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_tile_wall": "ꞁꞁɐM ǝꞁᴉ⟘ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.deepslate_tiles": "sǝꞁᴉ⟘ ǝʇɐꞁsdǝǝᗡ",
  "block.minecraft.detector_rail": "ꞁᴉɐᴚ ɹoʇɔǝʇǝᗡ",
  "block.minecraft.diamond_block": "ʞɔoꞁᗺ puoɯɐᴉᗡ",
  "block.minecraft.diamond_ore": "ǝɹO puoɯɐᴉᗡ",
  "block.minecraft.diorite": "ǝʇᴉɹoᴉᗡ",
  "block.minecraft.diorite_slab": "qɐꞁS ǝʇᴉɹoᴉᗡ",
  "block.minecraft.diorite_stairs": "sɹᴉɐʇS ǝʇᴉɹoᴉᗡ",
  "block.minecraft.diorite_wall": "ꞁꞁɐM ǝʇᴉɹoᴉᗡ",
  "block.minecraft.dirt": "ʇɹᴉᗡ",
  "block.minecraft.dirt_path": "ɥʇɐԀ ʇɹᴉᗡ",
  "block.minecraft.dispenser": "ɹǝsuǝdsᴉᗡ",
  "block.minecraft.dragon_egg": "ᵷᵷƎ uoᵷɐɹᗡ",
  "block.minecraft.dragon_head": "pɐǝH uoᵷɐɹᗡ",
  "block.minecraft.dragon_wall_head": "pɐǝH ꞁꞁɐM uoᵷɐɹᗡ",
  "block.minecraft.dried_ghast": "ʇsɐɥ⅁ pǝᴉɹᗡ",
  "block.minecraft.dried_kelp_block": "ʞɔoꞁᗺ dꞁǝꞰ pǝᴉɹᗡ",
  "block.minecraft.dripstone_block": "ʞɔoꞁᗺ ǝuoʇsdᴉɹᗡ",
  "block.minecraft.dropper": "ɹǝddoɹᗡ",
  "block.minecraft.emerald_block": "ʞɔoꞁᗺ pꞁɐɹǝɯƎ",
  "block.minecraft.emerald_ore": "ǝɹO pꞁɐɹǝɯƎ",
  "block.minecraft.enchanting_table": "ǝꞁqɐ⟘ ᵷuᴉʇuɐɥɔuƎ",
  "block.minecraft.end_gateway": "ʎɐʍǝʇɐ⅁ puƎ",
  "block.minecraft.end_portal": "ꞁɐʇɹoԀ puƎ",
  "block.minecraft.end_portal_frame": "ǝɯɐɹℲ ꞁɐʇɹoԀ puƎ",
  "block.minecraft.end_rod": "poᴚ puƎ",
  "block.minecraft.end_stone": "ǝuoʇS puƎ",
  "block.minecraft.end_stone_brick_slab": "qɐꞁS ʞɔᴉɹᗺ ǝuoʇS puƎ",
  "block.minecraft.end_stone_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ ǝuoʇS puƎ",
  "block.minecraft.end_stone_brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ ǝuoʇS puƎ",
  "block.minecraft.end_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇS puƎ",
  "block.minecraft.ender_chest": "ʇsǝɥƆ ɹǝpuƎ",
  "block.minecraft.exposed_chiseled_copper": "ɹǝddoƆ pǝꞁꞁǝsᴉɥƆ pǝsodxƎ",
  "block.minecraft.exposed_copper": "ɹǝddoƆ pǝsodxƎ",
  "block.minecraft.exposed_copper_bars": "sɹɐᗺ ɹǝddoƆ pǝsodxƎ",
  "block.minecraft.exposed_copper_bulb": "qꞁnᗺ ɹǝddoƆ pǝsodxƎ",
  "block.minecraft.exposed_copper_chain": "uᴉɐɥƆ ɹǝddoƆ pǝsodxƎ",
  "block.minecraft.exposed_copper_chest": "ʇsǝɥƆ ɹǝddoƆ pǝsodxƎ",
  "block.minecraft.exposed_copper_door": "ɹooᗡ ɹǝddoƆ pǝsodxƎ",
  "block.minecraft.exposed_copper_golem_statue": "ǝnʇɐʇS ɯǝꞁo⅁ ɹǝddoƆ pǝsodxƎ",
  "block.minecraft.exposed_copper_grate": "ǝʇɐɹ⅁ ɹǝddoƆ pǝsodxƎ",
  "block.minecraft.exposed_copper_lantern": "uɹǝʇuɐꞀ ɹǝddoƆ pǝsodxƎ",
  "block.minecraft.exposed_copper_trapdoor": "ɹoopdɐɹ⟘ ɹǝddoƆ pǝsodxƎ",
  "block.minecraft.exposed_cut_copper": "ɹǝddoƆ ʇnƆ pǝsodxƎ",
  "block.minecraft.exposed_cut_copper_slab": "qɐꞁS ɹǝddoƆ ʇnƆ pǝsodxƎ",
  "block.minecraft.exposed_cut_copper_stairs": "sɹᴉɐʇS ɹǝddoƆ ʇnƆ pǝsodxƎ",
  "block.minecraft.exposed_lightning_rod": "poᴚ ᵷuᴉuʇɥᵷᴉꞀ pǝsodxƎ",
  "block.minecraft.farmland": "puɐꞁɯɹɐℲ",
  "block.minecraft.fern": "uɹǝℲ",
  "block.minecraft.fire": "ǝɹᴉℲ",
  "block.minecraft.fire_coral": "ꞁɐɹoƆ ǝɹᴉℲ",
  "block.minecraft.fire_coral_block": "ʞɔoꞁᗺ ꞁɐɹoƆ ǝɹᴉℲ",
  "block.minecraft.fire_coral_fan": "uɐℲ ꞁɐɹoƆ ǝɹᴉℲ",
  "block.minecraft.fire_coral_wall_fan": "uɐℲ ꞁꞁɐM ꞁɐɹoƆ ǝɹᴉℲ",
  "block.minecraft.firefly_bush": "ɥsnᗺ ʎꞁɟǝɹᴉℲ",
  "block.minecraft.fletching_table": "ǝꞁqɐ⟘ ᵷuᴉɥɔʇǝꞁℲ",
  "block.minecraft.flower_pot": "ʇoԀ ɹǝʍoꞁℲ",
  "block.minecraft.flowering_azalea": "ɐǝꞁɐzⱯ ᵷuᴉɹǝʍoꞁℲ",
  "block.minecraft.flowering_azalea_leaves": "sǝʌɐǝꞀ ɐǝꞁɐzⱯ ᵷuᴉɹǝʍoꞁℲ",
  "block.minecraft.frogspawn": "uʍɐdsᵷoɹℲ",
  "block.minecraft.frosted_ice": "ǝɔI pǝʇsoɹℲ",
  "block.minecraft.furnace": "ǝɔɐuɹnℲ",
  "block.minecraft.gilded_blackstone": "ǝuoʇsʞɔɐꞁᗺ pǝpꞁᴉ⅁",
  "block.minecraft.glass": "ssɐꞁ⅁",
  "block.minecraft.glass_pane": "ǝuɐԀ ssɐꞁ⅁",
  "block.minecraft.glow_lichen": "uǝɥɔᴉꞀ ʍoꞁ⅁",
  "block.minecraft.glowstone": "ǝuoʇsʍoꞁ⅁",
  "block.minecraft.gold_block": "ʞɔoꞁᗺ pꞁo⅁",
  "block.minecraft.gold_ore": "ǝɹO pꞁo⅁",
  "block.minecraft.golden_dandelion": "uoᴉꞁǝpuɐᗡ uǝpꞁo⅁",
  "block.minecraft.granite": "ǝʇᴉuɐɹ⅁",
  "block.minecraft.granite_slab": "qɐꞁS ǝʇᴉuɐɹ⅁",
  "block.minecraft.granite_stairs": "sɹᴉɐʇS ǝʇᴉuɐɹ⅁",
  "block.minecraft.granite_wall": "ꞁꞁɐM ǝʇᴉuɐɹ⅁",
  "block.minecraft.grass": "ssɐɹ⅁",
  "block.minecraft.grass_block": "ʞɔoꞁᗺ ssɐɹ⅁",
  "block.minecraft.gravel": "ꞁǝʌɐɹ⅁",
  "block.minecraft.gray_banner": "ɹǝuuɐᗺ ʎǝɹ⅁",
  "block.minecraft.gray_bed": "pǝᗺ ʎǝɹ⅁",
  "block.minecraft.gray_candle": "ǝꞁpuɐƆ ʎǝɹ⅁",
  "block.minecraft.gray_candle_cake": "ǝꞁpuɐƆ ʎǝɹ⅁ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.gray_carpet": "ʇǝdɹɐƆ ʎǝɹ⅁",
  "block.minecraft.gray_concrete": "ǝʇǝɹɔuoƆ ʎǝɹ⅁",
  "block.minecraft.gray_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ʎǝɹ⅁",
  "block.minecraft.gray_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ʎǝɹ⅁",
  "block.minecraft.gray_shulker_box": "xoᗺ ɹǝʞꞁnɥS ʎǝɹ⅁",
  "block.minecraft.gray_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ʎǝɹ⅁",
  "block.minecraft.gray_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ʎǝɹ⅁",
  "block.minecraft.gray_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ʎǝɹ⅁",
  "block.minecraft.gray_wool": "ꞁooM ʎǝɹ⅁",
  "block.minecraft.green_banner": "ɹǝuuɐᗺ uǝǝɹ⅁",
  "block.minecraft.green_bed": "pǝᗺ uǝǝɹ⅁",
  "block.minecraft.green_candle": "ǝꞁpuɐƆ uǝǝɹ⅁",
  "block.minecraft.green_candle_cake": "ǝꞁpuɐƆ uǝǝɹ⅁ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.green_carpet": "ʇǝdɹɐƆ uǝǝɹ⅁",
  "block.minecraft.green_concrete": "ǝʇǝɹɔuoƆ uǝǝɹ⅁",
  "block.minecraft.green_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ uǝǝɹ⅁",
  "block.minecraft.green_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ uǝǝɹ⅁",
  "block.minecraft.green_shulker_box": "xoᗺ ɹǝʞꞁnɥS uǝǝɹ⅁",
  "block.minecraft.green_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS uǝǝɹ⅁",
  "block.minecraft.green_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS uǝǝɹ⅁",
  "block.minecraft.green_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ uǝǝɹ⅁",
  "block.minecraft.green_wool": "ꞁooM uǝǝɹ⅁",
  "block.minecraft.grindstone": "ǝuoʇspuᴉɹ⅁",
  "block.minecraft.hanging_roots": "sʇooᴚ ᵷuᴉᵷuɐH",
  "block.minecraft.hay_block": "ǝꞁɐᗺ ʎɐH",
  "block.minecraft.heavy_core": "ǝɹoƆ ʎʌɐǝH",
  "block.minecraft.heavy_weighted_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ pǝʇɥᵷᴉǝM ʎʌɐǝH",
  "block.minecraft.honey_block": "ʞɔoꞁᗺ ʎǝuoH",
  "block.minecraft.honeycomb_block": "ʞɔoꞁᗺ qɯoɔʎǝuoH",
  "block.minecraft.hopper": "ɹǝddoH",
  "block.minecraft.horn_coral": "ꞁɐɹoƆ uɹoH",
  "block.minecraft.horn_coral_block": "ʞɔoꞁᗺ ꞁɐɹoƆ uɹoH",
  "block.minecraft.horn_coral_fan": "uɐℲ ꞁɐɹoƆ uɹoH",
  "block.minecraft.horn_coral_wall_fan": "uɐℲ ꞁꞁɐM ꞁɐɹoƆ uɹoH",
  "block.minecraft.ice": "ǝɔI",
  "block.minecraft.infested_chiseled_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇS pǝꞁꞁǝsᴉɥƆ pǝʇsǝɟuI",
  "block.minecraft.infested_cobblestone": "ǝuoʇsǝꞁqqoƆ pǝʇsǝɟuI",
  "block.minecraft.infested_cracked_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇS pǝʞɔɐɹƆ pǝʇsǝɟuI",
  "block.minecraft.infested_deepslate": "ǝʇɐꞁsdǝǝᗡ pǝʇsǝɟuI",
  "block.minecraft.infested_mossy_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇS ʎssoW pǝʇsǝɟuI",
  "block.minecraft.infested_stone": "ǝuoʇS pǝʇsǝɟuI",
  "block.minecraft.infested_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇS pǝʇsǝɟuI",
  "block.minecraft.iron_bars": "sɹɐᗺ uoɹI",
  "block.minecraft.iron_block": "ʞɔoꞁᗺ uoɹI",
  "block.minecraft.iron_chain": "uᴉɐɥƆ uoɹI",
  "block.minecraft.iron_door": "ɹooᗡ uoɹI",
  "block.minecraft.iron_ore": "ǝɹO uoɹI",
  "block.minecraft.iron_trapdoor": "ɹoopdɐɹ⟘ uoɹI",
  "block.minecraft.jack_o_lantern": "uɹǝʇuɐꞀ,o ʞɔɐՐ",
  "block.minecraft.jigsaw": "ʞɔoꞁᗺ ʍɐsᵷᴉՐ",
  "block.minecraft.jukebox": "xoqǝʞnՐ",
  "block.minecraft.jungle_button": "uoʇʇnᗺ ǝꞁᵷunՐ",
  "block.minecraft.jungle_door": "ɹooᗡ ǝꞁᵷunՐ",
  "block.minecraft.jungle_fence": "ǝɔuǝℲ ǝꞁᵷunՐ",
  "block.minecraft.jungle_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ ǝꞁᵷunՐ",
  "block.minecraft.jungle_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ǝꞁᵷunՐ",
  "block.minecraft.jungle_leaves": "sǝʌɐǝꞀ ǝꞁᵷunՐ",
  "block.minecraft.jungle_log": "ᵷoꞀ ǝꞁᵷunՐ",
  "block.minecraft.jungle_planks": "sʞuɐꞁԀ ǝꞁᵷunՐ",
  "block.minecraft.jungle_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ǝꞁᵷunՐ",
  "block.minecraft.jungle_sapling": "ᵷuᴉꞁdɐS ǝꞁᵷunՐ",
  "block.minecraft.jungle_shelf": "ɟlǝɥS ǝꞁᵷunՐ",
  "block.minecraft.jungle_sign": "uᵷᴉS ǝꞁᵷunՐ",
  "block.minecraft.jungle_slab": "qɐꞁS ǝꞁᵷunՐ",
  "block.minecraft.jungle_stairs": "sɹᴉɐʇS ǝꞁᵷunՐ",
  "block.minecraft.jungle_trapdoor": "ɹoopdɐɹ⟘ ǝꞁᵷunՐ",
  "block.minecraft.jungle_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM ǝꞁᵷunՐ",
  "block.minecraft.jungle_wall_sign": "uᵷᴉS ꞁꞁɐM ǝꞁᵷunՐ",
  "block.minecraft.jungle_wood": "pooM ǝꞁᵷunՐ",
  "block.minecraft.kelp": "dꞁǝꞰ",
  "block.minecraft.kelp_plant": "ʇuɐꞁԀ dꞁǝꞰ",
  "block.minecraft.ladder": "ɹǝppɐꞀ",
  "block.minecraft.lantern": "uɹǝʇuɐꞀ",
  "block.minecraft.lapis_block": "ᴉꞁnzɐꞀ sᴉdɐꞀ ɟo ʞɔoꞁᗺ",
  "block.minecraft.lapis_ore": "ǝɹO ᴉꞁnzɐꞀ sᴉdɐꞀ",
  "block.minecraft.large_amethyst_bud": "pnᗺ ʇsʎɥʇǝɯⱯ ǝᵷɹɐꞀ",
  "block.minecraft.large_fern": "uɹǝℲ ǝᵷɹɐꞀ",
  "block.minecraft.lava": "ɐʌɐꞀ",
  "block.minecraft.lava_cauldron": "uoɹpꞁnɐƆ ɐʌɐꞀ",
  "block.minecraft.leaf_litter": "ɹǝʇʇᴉꞀ ɟɐǝꞀ",
  "block.minecraft.lectern": "uɹǝʇɔǝꞀ",
  "block.minecraft.lever": "ɹǝʌǝꞀ",
  "block.minecraft.light": "ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_banner": "ɹǝuuɐᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_bed": "pǝᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_candle": "ǝꞁpuɐƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_candle_cake": "ǝꞁpuɐƆ ǝnꞁᗺ ʇɥᵷᴉꞀ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.light_blue_carpet": "ʇǝdɹɐƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_concrete": "ǝʇǝɹɔuoƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_shulker_box": "xoᗺ ɹǝʞꞁnɥS ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_blue_wool": "ꞁooM ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_banner": "ɹǝuuɐᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_bed": "pǝᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_candle": "ǝꞁpuɐƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_candle_cake": "ǝꞁpuɐƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.light_gray_carpet": "ʇǝdɹɐƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_concrete": "ǝʇǝɹɔuoƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_shulker_box": "xoᗺ ɹǝʞꞁnɥS ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_gray_wool": "ꞁooM ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "block.minecraft.light_weighted_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ pǝʇɥᵷᴉǝM ʇɥᵷᴉꞀ",
  "block.minecraft.lightning_rod": "poᴚ ᵷuᴉuʇɥᵷᴉꞀ",
  "block.minecraft.lilac": "ɔɐꞁᴉꞀ",
  "block.minecraft.lily_of_the_valley": "ʎǝꞁꞁɐɅ ǝɥʇ ɟo ʎꞁᴉꞀ",
  "block.minecraft.lily_pad": "pɐԀ ʎꞁᴉꞀ",
  "block.minecraft.lime_banner": "ɹǝuuɐᗺ ǝɯᴉꞀ",
  "block.minecraft.lime_bed": "pǝᗺ ǝɯᴉꞀ",
  "block.minecraft.lime_candle": "ǝꞁpuɐƆ ǝɯᴉꞀ",
  "block.minecraft.lime_candle_cake": "ǝꞁpuɐƆ ǝɯᴉꞀ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.lime_carpet": "ʇǝdɹɐƆ ǝɯᴉꞀ",
  "block.minecraft.lime_concrete": "ǝʇǝɹɔuoƆ ǝɯᴉꞀ",
  "block.minecraft.lime_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ǝɯᴉꞀ",
  "block.minecraft.lime_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝɯᴉꞀ",
  "block.minecraft.lime_shulker_box": "xoᗺ ɹǝʞꞁnɥS ǝɯᴉꞀ",
  "block.minecraft.lime_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ǝɯᴉꞀ",
  "block.minecraft.lime_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ǝɯᴉꞀ",
  "block.minecraft.lime_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝɯᴉꞀ",
  "block.minecraft.lime_wool": "ꞁooM ǝɯᴉꞀ",
  "block.minecraft.lodestone": "ǝuoʇsǝpoꞀ",
  "block.minecraft.loom": "ɯooꞀ",
  "block.minecraft.magenta_banner": "ɹǝuuɐᗺ ɐʇuǝᵷɐW",
  "block.minecraft.magenta_bed": "pǝᗺ ɐʇuǝᵷɐW",
  "block.minecraft.magenta_candle": "ǝꞁpuɐƆ ɐʇuǝᵷɐW",
  "block.minecraft.magenta_candle_cake": "ǝꞁpuɐƆ ɐʇuǝᵷɐW ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.magenta_carpet": "ʇǝdɹɐƆ ɐʇuǝᵷɐW",
  "block.minecraft.magenta_concrete": "ǝʇǝɹɔuoƆ ɐʇuǝᵷɐW",
  "block.minecraft.magenta_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ɐʇuǝᵷɐW",
  "block.minecraft.magenta_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ɐʇuǝᵷɐW",
  "block.minecraft.magenta_shulker_box": "xoᗺ ɹǝʞꞁnɥS ɐʇuǝᵷɐW",
  "block.minecraft.magenta_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ɐʇuǝᵷɐW",
  "block.minecraft.magenta_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ɐʇuǝᵷɐW",
  "block.minecraft.magenta_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ɐʇuǝᵷɐW",
  "block.minecraft.magenta_wool": "ꞁooM ɐʇuǝᵷɐW",
  "block.minecraft.magma_block": "ʞɔoꞁᗺ ɐɯᵷɐW",
  "block.minecraft.mangrove_button": "uoʇʇnᗺ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_door": "ɹooᗡ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_fence": "ǝɔuǝℲ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_leaves": "sǝʌɐǝꞀ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_log": "ᵷoꞀ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_planks": "sʞuɐꞁԀ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_propagule": "ǝꞁnᵷɐdoɹԀ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_roots": "sʇooᴚ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_shelf": "ɟlǝɥS ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_sign": "uᵷᴉS ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_slab": "qɐꞁS ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_stairs": "sɹᴉɐʇS ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_trapdoor": "ɹoopdɐɹ⟘ ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_wall_sign": "uᵷᴉS ꞁꞁɐM ǝʌoɹᵷuɐW",
  "block.minecraft.mangrove_wood": "pooM ǝʌoɹᵷuɐW",
  "block.minecraft.medium_amethyst_bud": "pnᗺ ʇsʎɥʇǝɯⱯ ɯnᴉpǝW",
  "block.minecraft.melon": "uoꞁǝW",
  "block.minecraft.melon_stem": "ɯǝʇS uoꞁǝW",
  "block.minecraft.moss_block": "ʞɔoꞁᗺ ssoW",
  "block.minecraft.moss_carpet": "ʇǝdɹɐƆ ssoW",
  "block.minecraft.mossy_cobblestone": "ǝuoʇsǝꞁqqoƆ ʎssoW",
  "block.minecraft.mossy_cobblestone_slab": "qɐꞁS ǝuoʇsǝꞁqqoƆ ʎssoW",
  "block.minecraft.mossy_cobblestone_stairs": "sɹᴉɐʇS ǝuoʇsǝꞁqqoƆ ʎssoW",
  "block.minecraft.mossy_cobblestone_wall": "ꞁꞁɐM ǝuoʇsǝꞁqqoƆ ʎssoW",
  "block.minecraft.mossy_stone_brick_slab": "qɐꞁS ʞɔᴉɹᗺ ǝuoʇS ʎssoW",
  "block.minecraft.mossy_stone_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ ǝuoʇS ʎssoW",
  "block.minecraft.mossy_stone_brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ ǝuoʇS ʎssoW",
  "block.minecraft.mossy_stone_bricks": "sʞɔᴉɹᗺ ǝuoʇS ʎssoW",
  "block.minecraft.moving_piston": "uoʇsᴉԀ ᵷuᴉʌoW",
  "block.minecraft.mud": "pnW",
  "block.minecraft.mud_brick_slab": "qɐꞁS ʞɔᴉɹᗺ pnW",
  "block.minecraft.mud_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ pnW",
  "block.minecraft.mud_brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ pnW",
  "block.minecraft.mud_bricks": "sʞɔᴉɹᗺ pnW",
  "block.minecraft.muddy_mangrove_roots": "sʇooᴚ ǝʌoɹᵷuɐW ʎppnW",
  "block.minecraft.mushroom_stem": "ɯǝʇS ɯooɹɥsnW",
  "block.minecraft.mycelium": "ɯnᴉꞁǝɔʎW",
  "block.minecraft.nether_brick_fence": "ǝɔuǝℲ ʞɔᴉɹᗺ ɹǝɥʇǝN",
  "block.minecraft.nether_brick_slab": "qɐꞁS ʞɔᴉɹᗺ ɹǝɥʇǝN",
  "block.minecraft.nether_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ ɹǝɥʇǝN",
  "block.minecraft.nether_brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ ɹǝɥʇǝN",
  "block.minecraft.nether_bricks": "sʞɔᴉɹᗺ ɹǝɥʇǝN",
  "block.minecraft.nether_gold_ore": "ǝɹO pꞁo⅁ ɹǝɥʇǝN",
  "block.minecraft.nether_portal": "ꞁɐʇɹoԀ ɹǝɥʇǝN",
  "block.minecraft.nether_quartz_ore": "ǝɹO zʇɹɐnꝹ ɹǝɥʇǝN",
  "block.minecraft.nether_sprouts": "sʇnoɹdS ɹǝɥʇǝN",
  "block.minecraft.nether_wart": "ʇɹɐM ɹǝɥʇǝN",
  "block.minecraft.nether_wart_block": "ʞɔoꞁᗺ ʇɹɐM ɹǝɥʇǝN",
  "block.minecraft.netherite_block": "ǝʇᴉɹǝɥʇǝN ɟo ʞɔoꞁᗺ",
  "block.minecraft.netherrack": "ʞɔɐɹɹǝɥʇǝN",
  "block.minecraft.note_block": "ʞɔoꞁᗺ ǝʇoN",
  "block.minecraft.oak_button": "uoʇʇnᗺ ʞɐO",
  "block.minecraft.oak_door": "ɹooᗡ ʞɐO",
  "block.minecraft.oak_fence": "ǝɔuǝℲ ʞɐO",
  "block.minecraft.oak_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ ʞɐO",
  "block.minecraft.oak_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ʞɐO",
  "block.minecraft.oak_leaves": "sǝʌɐǝꞀ ʞɐO",
  "block.minecraft.oak_log": "ᵷoꞀ ʞɐO",
  "block.minecraft.oak_planks": "sʞuɐꞁԀ ʞɐO",
  "block.minecraft.oak_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ʞɐO",
  "block.minecraft.oak_sapling": "ᵷuᴉꞁdɐS ʞɐO",
  "block.minecraft.oak_shelf": "ɟlǝɥS ʞɐO",
  "block.minecraft.oak_sign": "uᵷᴉS ʞɐO",
  "block.minecraft.oak_slab": "qɐꞁS ʞɐO",
  "block.minecraft.oak_stairs": "sɹᴉɐʇS ʞɐO",
  "block.minecraft.oak_trapdoor": "ɹoopdɐɹ⟘ ʞɐO",
  "block.minecraft.oak_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM ʞɐO",
  "block.minecraft.oak_wall_sign": "uᵷᴉS ꞁꞁɐM ʞɐO",
  "block.minecraft.oak_wood": "pooM ʞɐO",
  "block.minecraft.observer": "ɹǝʌɹǝsqO",
  "block.minecraft.obsidian": "uɐᴉpᴉsqO",
  "block.minecraft.ochre_froglight": "ʇɥᵷᴉꞁᵷoɹℲ ǝɹɥɔO",
  "block.minecraft.ominous_banner": "ɹǝuuɐᗺ snouᴉɯO",
  "block.minecraft.open_eyeblossom": "ɯossoꞁqǝʎƎ uǝdO",
  "block.minecraft.orange_banner": "ɹǝuuɐᗺ ǝᵷuɐɹO",
  "block.minecraft.orange_bed": "pǝᗺ ǝᵷuɐɹO",
  "block.minecraft.orange_candle": "ǝꞁpuɐƆ ǝᵷuɐɹO",
  "block.minecraft.orange_candle_cake": "ǝꞁpuɐƆ ǝᵷuɐɹO ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.orange_carpet": "ʇǝdɹɐƆ ǝᵷuɐɹO",
  "block.minecraft.orange_concrete": "ǝʇǝɹɔuoƆ ǝᵷuɐɹO",
  "block.minecraft.orange_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ǝᵷuɐɹO",
  "block.minecraft.orange_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝᵷuɐɹO",
  "block.minecraft.orange_shulker_box": "xoᗺ ɹǝʞꞁnɥS ǝᵷuɐɹO",
  "block.minecraft.orange_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ǝᵷuɐɹO",
  "block.minecraft.orange_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ǝᵷuɐɹO",
  "block.minecraft.orange_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝᵷuɐɹO",
  "block.minecraft.orange_tulip": "dᴉꞁn⟘ ǝᵷuɐɹO",
  "block.minecraft.orange_wool": "ꞁooM ǝᵷuɐɹO",
  "block.minecraft.oxeye_daisy": "ʎsᴉɐᗡ ǝʎǝxO",
  "block.minecraft.oxidized_chiseled_copper": "ɹǝddoƆ pǝꞁꞁǝsᴉɥƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_copper": "ɹǝddoƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_copper_bars": "sɹɐᗺ ɹǝddoƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_copper_bulb": "qꞁnᗺ ɹǝddoƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_copper_chain": "uᴉɐɥƆ ɹǝddoƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_copper_chest": "ʇsǝɥƆ ɹǝddoƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_copper_door": "ɹooᗡ ɹǝddoƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_copper_golem_statue": "ǝnʇɐʇS ɯǝꞁo⅁ ɹǝddoƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_copper_grate": "ǝʇɐɹ⅁ ɹǝddoƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_copper_lantern": "uɹǝʇuɐꞀ ɹǝddoƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_copper_trapdoor": "ɹoopdɐɹ⟘ ɹǝddoƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_cut_copper": "ɹǝddoƆ ʇnƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_cut_copper_slab": "qɐꞁS ɹǝddoƆ ʇnƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_cut_copper_stairs": "sɹᴉɐʇS ɹǝddoƆ ʇnƆ pǝsᴉpᴉxO",
  "block.minecraft.oxidized_lightning_rod": "poᴚ ᵷuᴉuʇɥᵷᴉꞀ pǝsᴉpᴉxO",
  "block.minecraft.packed_ice": "ǝɔI pǝʞɔɐԀ",
  "block.minecraft.packed_mud": "pnW pǝʞɔɐԀ",
  "block.minecraft.pale_hanging_moss": "ssoW ᵷuᴉᵷuɐH ǝꞁɐԀ",
  "block.minecraft.pale_moss_block": "ʞɔoꞁᗺ ssoW ǝꞁɐԀ",
  "block.minecraft.pale_moss_carpet": "ʇǝdɹɐƆ ssoW ǝꞁɐԀ",
  "block.minecraft.pale_oak_button": "uoʇʇnᗺ ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_door": "ɹooᗡ ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_fence": "ǝɔuǝℲ ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_leaves": "sǝʌɐǝꞀ ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_log": "ᵷoꞀ ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_planks": "sʞuɐꞁԀ ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_sapling": "ᵷuᴉꞁdɐS ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_shelf": "ɟlǝɥS ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_sign": "uᵷᴉS ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_slab": "qɐꞁS ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_stairs": "sɹᴉɐʇS ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_trapdoor": "ɹoopdɐɹ⟘ ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_wall_sign": "uᵷᴉS ꞁꞁɐM ʞɐO ǝꞁɐԀ",
  "block.minecraft.pale_oak_wood": "pooM ʞɐO ǝꞁɐԀ",
  "block.minecraft.pearlescent_froglight": "ʇɥᵷᴉꞁᵷoɹℲ ʇuǝɔsǝꞁɹɐǝԀ",
  "block.minecraft.peony": "ʎuoǝԀ",
  "block.minecraft.petrified_oak_slab": "qɐꞁS ʞɐO pǝᴉɟᴉɹʇǝԀ",
  "block.minecraft.piglin_head": "pɐǝH uᴉꞁᵷᴉԀ",
  "block.minecraft.piglin_wall_head": "pɐǝH ꞁꞁɐM uᴉꞁᵷᴉԀ",
  "block.minecraft.pink_banner": "ɹǝuuɐᗺ ʞuᴉԀ",
  "block.minecraft.pink_bed": "pǝᗺ ʞuᴉԀ",
  "block.minecraft.pink_candle": "ǝꞁpuɐƆ ʞuᴉԀ",
  "block.minecraft.pink_candle_cake": "ǝꞁpuɐƆ ʞuᴉԀ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.pink_carpet": "ʇǝdɹɐƆ ʞuᴉԀ",
  "block.minecraft.pink_concrete": "ǝʇǝɹɔuoƆ ʞuᴉԀ",
  "block.minecraft.pink_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ʞuᴉԀ",
  "block.minecraft.pink_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ʞuᴉԀ",
  "block.minecraft.pink_petals": "sꞁɐʇǝԀ ʞuᴉԀ",
  "block.minecraft.pink_shulker_box": "xoᗺ ɹǝʞꞁnɥS ʞuᴉԀ",
  "block.minecraft.pink_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ʞuᴉԀ",
  "block.minecraft.pink_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ʞuᴉԀ",
  "block.minecraft.pink_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ʞuᴉԀ",
  "block.minecraft.pink_tulip": "dᴉꞁn⟘ ʞuᴉԀ",
  "block.minecraft.pink_wool": "ꞁooM ʞuᴉԀ",
  "block.minecraft.piston": "uoʇsᴉԀ",
  "block.minecraft.piston_head": "pɐǝH uoʇsᴉԀ",
  "block.minecraft.pitcher_crop": "doɹƆ ɹǝɥɔʇᴉԀ",
  "block.minecraft.pitcher_plant": "ʇuɐꞁԀ ɹǝɥɔʇᴉԀ",
  "block.minecraft.player_head": "pɐǝH ɹǝʎɐꞁԀ",
  "block.minecraft.player_head.named": "pɐǝH s,%s",
  "block.minecraft.player_wall_head": "pɐǝH ꞁꞁɐM ɹǝʎɐꞁԀ",
  "block.minecraft.podzol": "ꞁozpoԀ",
  "block.minecraft.pointed_dripstone": "ǝuoʇsdᴉɹᗡ pǝʇuᴉoԀ",
  "block.minecraft.polished_andesite": "ǝʇᴉsǝpuⱯ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_andesite_slab": "qɐꞁS ǝʇᴉsǝpuⱯ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_andesite_stairs": "sɹᴉɐʇS ǝʇᴉsǝpuⱯ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_basalt": "ʇꞁɐsɐᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_blackstone": "ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_blackstone_brick_slab": "qɐꞁS ʞɔᴉɹᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_blackstone_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_blackstone_brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_blackstone_bricks": "sʞɔᴉɹᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_blackstone_button": "uoʇʇnᗺ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_blackstone_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_blackstone_slab": "qɐꞁS ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_blackstone_stairs": "sɹᴉɐʇS ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_blackstone_wall": "ꞁꞁɐM ǝuoʇsʞɔɐꞁᗺ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_deepslate": "ǝʇɐꞁsdǝǝᗡ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_deepslate_slab": "qɐꞁS ǝʇɐꞁsdǝǝᗡ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_deepslate_stairs": "sɹᴉɐʇS ǝʇɐꞁsdǝǝᗡ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_deepslate_wall": "ꞁꞁɐM ǝʇɐꞁsdǝǝᗡ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_diorite": "ǝʇᴉɹoᴉᗡ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_diorite_slab": "qɐꞁS ǝʇᴉɹoᴉᗡ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_diorite_stairs": "sɹᴉɐʇS ǝʇᴉɹoᴉᗡ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_granite": "ǝʇᴉuɐɹ⅁ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_granite_slab": "qɐꞁS ǝʇᴉuɐɹ⅁ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_granite_stairs": "sɹᴉɐʇS ǝʇᴉuɐɹ⅁ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_tuff": "ɟɟn⟘ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_tuff_slab": "qɐꞁS ɟɟn⟘ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_tuff_stairs": "sɹᴉɐʇS ɟɟn⟘ pǝɥsᴉꞁoԀ",
  "block.minecraft.polished_tuff_wall": "ꞁꞁɐM ɟɟn⟘ pǝɥsᴉꞁoԀ",
  "block.minecraft.poppy": "ʎddoԀ",
  "block.minecraft.potatoes": "sǝoʇɐʇoԀ",
  "block.minecraft.potted_acacia_sapling": "ᵷuᴉꞁdɐS ɐᴉɔɐɔⱯ pǝʇʇoԀ",
  "block.minecraft.potted_allium": "ɯnᴉꞁꞁⱯ pǝʇʇoԀ",
  "block.minecraft.potted_azalea_bush": "ɐǝꞁɐzⱯ pǝʇʇoԀ",
  "block.minecraft.potted_azure_bluet": "ʇǝnꞁᗺ ǝɹnzⱯ pǝʇʇoԀ",
  "block.minecraft.potted_bamboo": "ooqɯɐᗺ pǝʇʇoԀ",
  "block.minecraft.potted_birch_sapling": "ᵷuᴉꞁdɐS ɥɔɹᴉᗺ pǝʇʇoԀ",
  "block.minecraft.potted_blue_orchid": "pᴉɥɔɹO ǝnꞁᗺ pǝʇʇoԀ",
  "block.minecraft.potted_brown_mushroom": "ɯooɹɥsnW uʍoɹᗺ pǝʇʇoԀ",
  "block.minecraft.potted_cactus": "snʇɔɐƆ pǝʇʇoԀ",
  "block.minecraft.potted_cherry_sapling": "ᵷuᴉꞁdɐS ʎɹɹǝɥƆ pǝʇʇoԀ",
  "block.minecraft.potted_closed_eyeblossom": "ɯossoꞁqǝʎƎ pǝsoꞁƆ pǝʇʇoԀ",
  "block.minecraft.potted_cornflower": "ɹǝʍoꞁɟuɹoƆ pǝʇʇoԀ",
  "block.minecraft.potted_crimson_fungus": "snᵷunℲ uosɯᴉɹƆ pǝʇʇoԀ",
  "block.minecraft.potted_crimson_roots": "sʇooᴚ uosɯᴉɹƆ pǝʇʇoԀ",
  "block.minecraft.potted_dandelion": "uoᴉꞁǝpuɐᗡ pǝʇʇoԀ",
  "block.minecraft.potted_dark_oak_sapling": "ᵷuᴉꞁdɐS ʞɐO ʞɹɐᗡ pǝʇʇoԀ",
  "block.minecraft.potted_dead_bush": "ɥsnᗺ pɐǝᗡ pǝʇʇoԀ",
  "block.minecraft.potted_fern": "uɹǝℲ pǝʇʇoԀ",
  "block.minecraft.potted_flowering_azalea_bush": "ɐǝꞁɐzⱯ ᵷuᴉɹǝʍoꞁℲ pǝʇʇoԀ",
  "block.minecraft.potted_golden_dandelion": "uoᴉꞁǝpuɐᗡ uǝpꞁo⅁ pǝʇʇoԀ",
  "block.minecraft.potted_jungle_sapling": "ᵷuᴉꞁdɐS ǝꞁᵷunՐ pǝʇʇoԀ",
  "block.minecraft.potted_lily_of_the_valley": "ʎǝꞁꞁɐɅ ǝɥʇ ɟo ʎꞁᴉꞀ pǝʇʇoԀ",
  "block.minecraft.potted_mangrove_propagule": "ǝꞁnᵷɐdoɹԀ ǝʌoɹᵷuɐW pǝʇʇoԀ",
  "block.minecraft.potted_oak_sapling": "ᵷuᴉꞁdɐS ʞɐO pǝʇʇoԀ",
  "block.minecraft.potted_open_eyeblossom": "ɯossoꞁqǝʎƎ uǝdO pǝʇʇoԀ",
  "block.minecraft.potted_orange_tulip": "dᴉꞁn⟘ ǝᵷuɐɹO pǝʇʇoԀ",
  "block.minecraft.potted_oxeye_daisy": "ʎsᴉɐᗡ ǝʎǝxO pǝʇʇoԀ",
  "block.minecraft.potted_pale_oak_sapling": "ᵷuᴉꞁdɐS ʞɐO ǝꞁɐԀ pǝʇʇoԀ",
  "block.minecraft.potted_pink_tulip": "dᴉꞁn⟘ ʞuᴉԀ pǝʇʇoԀ",
  "block.minecraft.potted_poppy": "ʎddoԀ pǝʇʇoԀ",
  "block.minecraft.potted_red_mushroom": "ɯooɹɥsnW pǝᴚ pǝʇʇoԀ",
  "block.minecraft.potted_red_tulip": "dᴉꞁn⟘ pǝᴚ pǝʇʇoԀ",
  "block.minecraft.potted_spruce_sapling": "ᵷuᴉꞁdɐS ǝɔnɹdS pǝʇʇoԀ",
  "block.minecraft.potted_torchflower": "ɹǝʍoꞁɟɥɔɹo⟘ pǝʇʇoԀ",
  "block.minecraft.potted_warped_fungus": "snᵷunℲ pǝdɹɐM pǝʇʇoԀ",
  "block.minecraft.potted_warped_roots": "sʇooᴚ pǝdɹɐM pǝʇʇoԀ",
  "block.minecraft.potted_white_tulip": "dᴉꞁn⟘ ǝʇᴉɥM pǝʇʇoԀ",
  "block.minecraft.potted_wither_rose": "ǝsoᴚ ɹǝɥʇᴉM pǝʇʇoԀ",
  "block.minecraft.powder_snow": "ʍouS ɹǝpʍoԀ",
  "block.minecraft.powder_snow_cauldron": "uoɹpꞁnɐƆ ʍouS ɹǝpʍoԀ",
  "block.minecraft.powered_rail": "ꞁᴉɐᴚ pǝɹǝʍoԀ",
  "block.minecraft.prismarine": "ǝuᴉɹɐɯsᴉɹԀ",
  "block.minecraft.prismarine_brick_slab": "qɐꞁS ʞɔᴉɹᗺ ǝuᴉɹɐɯsᴉɹԀ",
  "block.minecraft.prismarine_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ ǝuᴉɹɐɯsᴉɹԀ",
  "block.minecraft.prismarine_bricks": "sʞɔᴉɹᗺ ǝuᴉɹɐɯsᴉɹԀ",
  "block.minecraft.prismarine_slab": "qɐꞁS ǝuᴉɹɐɯsᴉɹԀ",
  "block.minecraft.prismarine_stairs": "sɹᴉɐʇS ǝuᴉɹɐɯsᴉɹԀ",
  "block.minecraft.prismarine_wall": "ꞁꞁɐM ǝuᴉɹɐɯsᴉɹԀ",
  "block.minecraft.pumpkin": "uᴉʞdɯnԀ",
  "block.minecraft.pumpkin_stem": "ɯǝʇS uᴉʞdɯnԀ",
  "block.minecraft.purple_banner": "ɹǝuuɐᗺ ǝꞁdɹnԀ",
  "block.minecraft.purple_bed": "pǝᗺ ǝꞁdɹnԀ",
  "block.minecraft.purple_candle": "ǝꞁpuɐƆ ǝꞁdɹnԀ",
  "block.minecraft.purple_candle_cake": "ǝꞁpuɐƆ ǝꞁdɹnԀ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.purple_carpet": "ʇǝdɹɐƆ ǝꞁdɹnԀ",
  "block.minecraft.purple_concrete": "ǝʇǝɹɔuoƆ ǝꞁdɹnԀ",
  "block.minecraft.purple_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ǝꞁdɹnԀ",
  "block.minecraft.purple_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝꞁdɹnԀ",
  "block.minecraft.purple_shulker_box": "xoᗺ ɹǝʞꞁnɥS ǝꞁdɹnԀ",
  "block.minecraft.purple_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ǝꞁdɹnԀ",
  "block.minecraft.purple_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ǝꞁdɹnԀ",
  "block.minecraft.purple_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝꞁdɹnԀ",
  "block.minecraft.purple_wool": "ꞁooM ǝꞁdɹnԀ",
  "block.minecraft.purpur_block": "ʞɔoꞁᗺ ɹndɹnԀ",
  "block.minecraft.purpur_pillar": "ɹɐꞁꞁᴉԀ ɹndɹnԀ",
  "block.minecraft.purpur_slab": "qɐꞁS ɹndɹnԀ",
  "block.minecraft.purpur_stairs": "sɹᴉɐʇS ɹndɹnԀ",
  "block.minecraft.quartz_block": "ʞɔoꞁᗺ zʇɹɐnꝹ",
  "block.minecraft.quartz_bricks": "sʞɔᴉɹᗺ zʇɹɐnꝹ",
  "block.minecraft.quartz_pillar": "ɹɐꞁꞁᴉԀ zʇɹɐnꝹ",
  "block.minecraft.quartz_slab": "qɐꞁS zʇɹɐnꝹ",
  "block.minecraft.quartz_stairs": "sɹᴉɐʇS zʇɹɐnꝹ",
  "block.minecraft.rail": "ꞁᴉɐᴚ",
  "block.minecraft.raw_copper_block": "ɹǝddoƆ ʍɐᴚ ɟo ʞɔoꞁᗺ",
  "block.minecraft.raw_gold_block": "pꞁo⅁ ʍɐᴚ ɟo ʞɔoꞁᗺ",
  "block.minecraft.raw_iron_block": "uoɹI ʍɐᴚ ɟo ʞɔoꞁᗺ",
  "block.minecraft.red_banner": "ɹǝuuɐᗺ pǝᴚ",
  "block.minecraft.red_bed": "pǝᗺ pǝᴚ",
  "block.minecraft.red_candle": "ǝꞁpuɐƆ pǝᴚ",
  "block.minecraft.red_candle_cake": "ǝꞁpuɐƆ pǝᴚ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.red_carpet": "ʇǝdɹɐƆ pǝᴚ",
  "block.minecraft.red_concrete": "ǝʇǝɹɔuoƆ pǝᴚ",
  "block.minecraft.red_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ pǝᴚ",
  "block.minecraft.red_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ pǝᴚ",
  "block.minecraft.red_mushroom": "ɯooɹɥsnW pǝᴚ",
  "block.minecraft.red_mushroom_block": "ʞɔoꞁᗺ ɯooɹɥsnW pǝᴚ",
  "block.minecraft.red_nether_brick_slab": "qɐꞁS ʞɔᴉɹᗺ ɹǝɥʇǝN pǝᴚ",
  "block.minecraft.red_nether_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ ɹǝɥʇǝN pǝᴚ",
  "block.minecraft.red_nether_brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ ɹǝɥʇǝN pǝᴚ",
  "block.minecraft.red_nether_bricks": "sʞɔᴉɹᗺ ɹǝɥʇǝN pǝᴚ",
  "block.minecraft.red_sand": "puɐS pǝᴚ",
  "block.minecraft.red_sandstone": "ǝuoʇspuɐS pǝᴚ",
  "block.minecraft.red_sandstone_slab": "qɐꞁS ǝuoʇspuɐS pǝᴚ",
  "block.minecraft.red_sandstone_stairs": "sɹᴉɐʇS ǝuoʇspuɐS pǝᴚ",
  "block.minecraft.red_sandstone_wall": "ꞁꞁɐM ǝuoʇspuɐS pǝᴚ",
  "block.minecraft.red_shulker_box": "xoᗺ ɹǝʞꞁnɥS pǝᴚ",
  "block.minecraft.red_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS pǝᴚ",
  "block.minecraft.red_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS pǝᴚ",
  "block.minecraft.red_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝᴚ",
  "block.minecraft.red_tulip": "dᴉꞁn⟘ pǝᴚ",
  "block.minecraft.red_wool": "ꞁooM pǝᴚ",
  "block.minecraft.redstone_block": "ʞɔoꞁᗺ ǝuoʇspǝᴚ",
  "block.minecraft.redstone_lamp": "dɯɐꞀ ǝuoʇspǝᴚ",
  "block.minecraft.redstone_ore": "ǝɹO ǝuoʇspǝᴚ",
  "block.minecraft.redstone_torch": "ɥɔɹo⟘ ǝuoʇspǝᴚ",
  "block.minecraft.redstone_wall_torch": "ɥɔɹo⟘ ꞁꞁɐM ǝuoʇspǝᴚ",
  "block.minecraft.redstone_wire": "ǝɹᴉM ǝuoʇspǝᴚ",
  "block.minecraft.reinforced_deepslate": "ǝʇɐꞁsdǝǝᗡ pǝɔɹoɟuᴉǝᴚ",
  "block.minecraft.repeater": "ɹǝʇɐǝdǝᴚ ǝuoʇspǝᴚ",
  "block.minecraft.repeating_command_block": "ʞɔoꞁᗺ puɐɯɯoƆ ᵷuᴉʇɐǝdǝᴚ",
  "block.minecraft.resin_block": "uᴉsǝᴚ ɟo ʞɔoꞁᗺ",
  "block.minecraft.resin_brick_slab": "qɐꞁS ʞɔᴉɹᗺ uᴉsǝᴚ",
  "block.minecraft.resin_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ uᴉsǝᴚ",
  "block.minecraft.resin_brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ uᴉsǝᴚ",
  "block.minecraft.resin_bricks": "sʞɔᴉɹᗺ uᴉsǝᴚ",
  "block.minecraft.resin_clump": "dɯnꞁƆ uᴉsǝᴚ",
  "block.minecraft.respawn_anchor": "ɹoɥɔuⱯ uʍɐdsǝᴚ",
  "block.minecraft.rooted_dirt": "ʇɹᴉᗡ pǝʇooᴚ",
  "block.minecraft.rose_bush": "ɥsnᗺ ǝsoᴚ",
  "block.minecraft.sand": "puɐS",
  "block.minecraft.sandstone": "ǝuoʇspuɐS",
  "block.minecraft.sandstone_slab": "qɐꞁS ǝuoʇspuɐS",
  "block.minecraft.sandstone_stairs": "sɹᴉɐʇS ǝuoʇspuɐS",
  "block.minecraft.sandstone_wall": "ꞁꞁɐM ǝuoʇspuɐS",
  "block.minecraft.scaffolding": "ᵷuᴉpꞁoɟɟɐɔS",
  "block.minecraft.sculk": "ʞꞁnɔS",
  "block.minecraft.sculk_catalyst": "ʇsʎꞁɐʇɐƆ ʞꞁnɔS",
  "block.minecraft.sculk_sensor": "ɹosuǝS ʞꞁnɔS",
  "block.minecraft.sculk_shrieker": "ɹǝʞǝᴉɹɥS ʞꞁnɔS",
  "block.minecraft.sculk_vein": "uᴉǝɅ ʞꞁnɔS",
  "block.minecraft.sea_lantern": "uɹǝʇuɐꞀ ɐǝS",
  "block.minecraft.sea_pickle": "ǝꞁʞɔᴉԀ ɐǝS",
  "block.minecraft.seagrass": "ssɐɹᵷɐǝS",
  "block.minecraft.set_spawn": "ʇǝs ʇuᴉod uʍɐdsǝᴚ",
  "block.minecraft.short_dry_grass": "ssɐɹ⅁ ʎɹᗡ ʇɹoɥS",
  "block.minecraft.short_grass": "ssɐɹ⅁ ʇɹoɥS",
  "block.minecraft.shroomlight": "ʇɥᵷᴉꞁɯooɹɥS",
  "block.minecraft.shulker_box": "xoᗺ ɹǝʞꞁnɥS",
  "block.minecraft.skeleton_skull": "ꞁꞁnʞS uoʇǝꞁǝʞS",
  "block.minecraft.skeleton_wall_skull": "ꞁꞁnʞS ꞁꞁɐM uoʇǝꞁǝʞS",
  "block.minecraft.slime_block": "ʞɔoꞁᗺ ǝɯᴉꞁS",
  "block.minecraft.small_amethyst_bud": "pnᗺ ʇsʎɥʇǝɯⱯ ꞁꞁɐɯS",
  "block.minecraft.small_dripleaf": "ɟɐǝꞁdᴉɹᗡ ꞁꞁɐɯS",
  "block.minecraft.smithing_table": "ǝꞁqɐ⟘ ᵷuᴉɥʇᴉɯS",
  "block.minecraft.smoker": "ɹǝʞoɯS",
  "block.minecraft.smooth_basalt": "ʇꞁɐsɐᗺ ɥʇooɯS",
  "block.minecraft.smooth_quartz": "ʞɔoꞁᗺ zʇɹɐnꝹ ɥʇooɯS",
  "block.minecraft.smooth_quartz_slab": "qɐꞁS zʇɹɐnꝹ ɥʇooɯS",
  "block.minecraft.smooth_quartz_stairs": "sɹᴉɐʇS zʇɹɐnꝹ ɥʇooɯS",
  "block.minecraft.smooth_red_sandstone": "ǝuoʇspuɐS pǝᴚ ɥʇooɯS",
  "block.minecraft.smooth_red_sandstone_slab": "qɐꞁS ǝuoʇspuɐS pǝᴚ ɥʇooɯS",
  "block.minecraft.smooth_red_sandstone_stairs": "sɹᴉɐʇS ǝuoʇspuɐS pǝᴚ ɥʇooɯS",
  "block.minecraft.smooth_sandstone": "ǝuoʇspuɐS ɥʇooɯS",
  "block.minecraft.smooth_sandstone_slab": "qɐꞁS ǝuoʇspuɐS ɥʇooɯS",
  "block.minecraft.smooth_sandstone_stairs": "sɹᴉɐʇS ǝuoʇspuɐS ɥʇooɯS",
  "block.minecraft.smooth_stone": "ǝuoʇS ɥʇooɯS",
  "block.minecraft.smooth_stone_slab": "qɐꞁS ǝuoʇS ɥʇooɯS",
  "block.minecraft.sniffer_egg": "ᵷᵷƎ ɹǝɟɟᴉuS",
  "block.minecraft.snow": "ʍouS",
  "block.minecraft.snow_block": "ʞɔoꞁᗺ ʍouS",
  "block.minecraft.soul_campfire": "ǝɹᴉɟdɯɐƆ ꞁnoS",
  "block.minecraft.soul_fire": "ǝɹᴉℲ ꞁnoS",
  "block.minecraft.soul_lantern": "uɹǝʇuɐꞀ ꞁnoS",
  "block.minecraft.soul_sand": "puɐS ꞁnoS",
  "block.minecraft.soul_soil": "ꞁᴉoS ꞁnoS",
  "block.minecraft.soul_torch": "ɥɔɹo⟘ ꞁnoS",
  "block.minecraft.soul_wall_torch": "ɥɔɹo⟘ ꞁꞁɐM ꞁnoS",
  "block.minecraft.spawn.not_valid": "pǝʇɔnɹʇsqo sɐʍ ʇᴉ ɹo 'ɹoɥɔuⱯ uʍɐdsǝᴚ pǝᵷɹɐɥɔ ɹo pǝᗺ ǝɯoɥ ou ǝʌɐɥ no⅄",
  "block.minecraft.spawner": "ɹǝuʍɐdS ɹǝʇsuoW",
  "block.minecraft.spawner.desc1": ":ᵷᵷƎ uʍɐdS ɥʇᴉʍ ʇɔɐɹǝʇuI",
  "block.minecraft.spawner.desc2": "ǝdʎ⟘ qoW sʇǝS",
  "block.minecraft.sponge": "ǝᵷuodS",
  "block.minecraft.spore_blossom": "ɯossoꞁᗺ ǝɹodS",
  "block.minecraft.spruce_button": "uoʇʇnᗺ ǝɔnɹdS",
  "block.minecraft.spruce_door": "ɹooᗡ ǝɔnɹdS",
  "block.minecraft.spruce_fence": "ǝɔuǝℲ ǝɔnɹdS",
  "block.minecraft.spruce_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ ǝɔnɹdS",
  "block.minecraft.spruce_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ǝɔnɹdS",
  "block.minecraft.spruce_leaves": "sǝʌɐǝꞀ ǝɔnɹdS",
  "block.minecraft.spruce_log": "ᵷoꞀ ǝɔnɹdS",
  "block.minecraft.spruce_planks": "sʞuɐꞁԀ ǝɔnɹdS",
  "block.minecraft.spruce_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ǝɔnɹdS",
  "block.minecraft.spruce_sapling": "ᵷuᴉꞁdɐS ǝɔnɹdS",
  "block.minecraft.spruce_shelf": "ɟlǝɥS ǝɔnɹdS ",
  "block.minecraft.spruce_sign": "uᵷᴉS ǝɔnɹdS",
  "block.minecraft.spruce_slab": "qɐꞁS ǝɔnɹdS",
  "block.minecraft.spruce_stairs": "sɹᴉɐʇS ǝɔnɹdS",
  "block.minecraft.spruce_trapdoor": "ɹoopdɐɹ⟘ ǝɔnɹdS",
  "block.minecraft.spruce_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM ǝɔnɹdS",
  "block.minecraft.spruce_wall_sign": "uᵷᴉS ꞁꞁɐM ǝɔnɹdS",
  "block.minecraft.spruce_wood": "pooM ǝɔnɹdS",
  "block.minecraft.sticky_piston": "uoʇsᴉԀ ʎʞɔᴉʇS",
  "block.minecraft.stone": "ǝuoʇS",
  "block.minecraft.stone_brick_slab": "qɐꞁS ʞɔᴉɹᗺ ǝuoʇS",
  "block.minecraft.stone_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ ǝuoʇS",
  "block.minecraft.stone_brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ ǝuoʇS",
  "block.minecraft.stone_bricks": "sʞɔᴉɹᗺ ǝuoʇS",
  "block.minecraft.stone_button": "uoʇʇnᗺ ǝuoʇS",
  "block.minecraft.stone_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ ǝuoʇS",
  "block.minecraft.stone_slab": "qɐꞁS ǝuoʇS",
  "block.minecraft.stone_stairs": "sɹᴉɐʇS ǝuoʇS",
  "block.minecraft.stonecutter": "ɹǝʇʇnɔǝuoʇS",
  "block.minecraft.stripped_acacia_log": "ᵷoꞀ ɐᴉɔɐɔⱯ pǝddᴉɹʇS",
  "block.minecraft.stripped_acacia_wood": "pooM ɐᴉɔɐɔⱯ pǝddᴉɹʇS",
  "block.minecraft.stripped_bamboo_block": "ooqɯɐᗺ pǝddᴉɹʇS ɟo ʞɔoꞁᗺ",
  "block.minecraft.stripped_birch_log": "ᵷoꞀ ɥɔɹᴉᗺ pǝddᴉɹʇS",
  "block.minecraft.stripped_birch_wood": "pooM ɥɔɹᴉᗺ pǝddᴉɹʇS",
  "block.minecraft.stripped_cherry_log": "ᵷoꞀ ʎɹɹǝɥƆ pǝddᴉɹʇS",
  "block.minecraft.stripped_cherry_wood": "pooM ʎɹɹǝɥƆ pǝddᴉɹʇS",
  "block.minecraft.stripped_crimson_hyphae": "ǝɐɥdʎH uosɯᴉɹƆ pǝddᴉɹʇS",
  "block.minecraft.stripped_crimson_stem": "ɯǝʇS uosɯᴉɹƆ pǝddᴉɹʇS",
  "block.minecraft.stripped_dark_oak_log": "ᵷoꞀ ʞɐO ʞɹɐᗡ pǝddᴉɹʇS",
  "block.minecraft.stripped_dark_oak_wood": "pooM ʞɐO ʞɹɐᗡ pǝddᴉɹʇS",
  "block.minecraft.stripped_jungle_log": "ᵷoꞀ ǝꞁᵷunՐ pǝddᴉɹʇS",
  "block.minecraft.stripped_jungle_wood": "pooM ǝꞁᵷunՐ pǝddᴉɹʇS",
  "block.minecraft.stripped_mangrove_log": "ᵷoꞀ ǝʌoɹᵷuɐW pǝddᴉɹʇS",
  "block.minecraft.stripped_mangrove_wood": "pooM ǝʌoɹᵷuɐW pǝddᴉɹʇS",
  "block.minecraft.stripped_oak_log": "ᵷoꞀ ʞɐO pǝddᴉɹʇS",
  "block.minecraft.stripped_oak_wood": "pooM ʞɐO pǝddᴉɹʇS",
  "block.minecraft.stripped_pale_oak_log": "ᵷoꞀ ʞɐO ǝꞁɐԀ pǝddᴉɹʇS",
  "block.minecraft.stripped_pale_oak_wood": "pooM ʞɐO ǝꞁɐԀ pǝddᴉɹʇS",
  "block.minecraft.stripped_spruce_log": "ᵷoꞀ ǝɔnɹdS pǝddᴉɹʇS",
  "block.minecraft.stripped_spruce_wood": "pooM ǝɔnɹdS pǝddᴉɹʇS",
  "block.minecraft.stripped_warped_hyphae": "ǝɐɥdʎH pǝdɹɐM pǝddᴉɹʇS",
  "block.minecraft.stripped_warped_stem": "ɯǝʇS pǝdɹɐM pǝddᴉɹʇS",
  "block.minecraft.structure_block": "ʞɔoꞁᗺ ǝɹnʇɔnɹʇS",
  "block.minecraft.structure_void": "pᴉoɅ ǝɹnʇɔnɹʇS",
  "block.minecraft.sugar_cane": "ǝuɐƆ ɹɐᵷnS",
  "block.minecraft.sunflower": "ɹǝʍoꞁɟunS",
  "block.minecraft.suspicious_gravel": "ꞁǝʌɐɹ⅁ snoᴉɔᴉdsnS",
  "block.minecraft.suspicious_sand": "puɐS snoᴉɔᴉdsnS",
  "block.minecraft.sweet_berry_bush": "ɥsnᗺ ʎɹɹǝᗺ ʇǝǝʍS",
  "block.minecraft.tall_dry_grass": "ssɐɹ⅁ ʎɹᗡ ꞁꞁɐ⟘",
  "block.minecraft.tall_grass": "ssɐɹ⅁ ꞁꞁɐ⟘",
  "block.minecraft.tall_seagrass": "ssɐɹᵷɐǝS ꞁꞁɐ⟘",
  "block.minecraft.target": "ʇǝᵷɹɐ⟘",
  "block.minecraft.terracotta": "ɐʇʇoɔɐɹɹǝ⟘",
  "block.minecraft.test_block": "ʞɔoꞁᗺ ʇsǝ⟘",
  "block.minecraft.test_instance_block": "ʞɔoꞁᗺ ǝɔuɐʇsuI ʇsǝ⟘",
  "block.minecraft.tinted_glass": "ssɐꞁ⅁ pǝʇuᴉ⟘",
  "block.minecraft.tnt": "⟘N⟘",
  "block.minecraft.tnt.disabled": "pǝꞁqɐsᴉp ǝɹɐ suoᴉsoꞁdxǝ ⟘N⟘",
  "block.minecraft.torch": "ɥɔɹo⟘",
  "block.minecraft.torchflower": "ɹǝʍoꞁɟɥɔɹo⟘",
  "block.minecraft.torchflower_crop": "doɹƆ ɹǝʍoꞁɟɥɔɹo⟘",
  "block.minecraft.trapped_chest": "ʇsǝɥƆ pǝddɐɹ⟘",
  "block.minecraft.trial_spawner": "ɹǝuʍɐdS ꞁɐᴉɹ⟘",
  "block.minecraft.tripwire": "ǝɹᴉʍdᴉɹ⟘",
  "block.minecraft.tripwire_hook": "ʞooH ǝɹᴉʍdᴉɹ⟘",
  "block.minecraft.tube_coral": "ꞁɐɹoƆ ǝqn⟘",
  "block.minecraft.tube_coral_block": "ʞɔoꞁᗺ ꞁɐɹoƆ ǝqn⟘",
  "block.minecraft.tube_coral_fan": "uɐℲ ꞁɐɹoƆ ǝqn⟘",
  "block.minecraft.tube_coral_wall_fan": "uɐℲ ꞁꞁɐM ꞁɐɹoƆ ǝqn⟘",
  "block.minecraft.tuff": "ɟɟn⟘",
  "block.minecraft.tuff_brick_slab": "qɐꞁS ʞɔᴉɹᗺ ɟɟn⟘",
  "block.minecraft.tuff_brick_stairs": "sɹᴉɐʇS ʞɔᴉɹᗺ ɟɟn⟘",
  "block.minecraft.tuff_brick_wall": "ꞁꞁɐM ʞɔᴉɹᗺ ɟɟn⟘",
  "block.minecraft.tuff_bricks": "sʞɔᴉɹᗺ ɟɟn⟘",
  "block.minecraft.tuff_slab": "qɐꞁS ɟɟn⟘",
  "block.minecraft.tuff_stairs": "sɹᴉɐʇS ɟɟn⟘",
  "block.minecraft.tuff_wall": "ꞁꞁɐM ɟɟn⟘",
  "block.minecraft.turtle_egg": "ᵷᵷƎ ǝꞁʇɹn⟘",
  "block.minecraft.twisting_vines": "sǝuᴉɅ ᵷuᴉʇsᴉʍ⟘",
  "block.minecraft.twisting_vines_plant": "ʇuɐꞁԀ sǝuᴉɅ ᵷuᴉʇsᴉʍ⟘",
  "block.minecraft.vault": "ʇꞁnɐɅ",
  "block.minecraft.verdant_froglight": "ʇɥᵷᴉꞁᵷoɹℲ ʇuɐpɹǝɅ",
  "block.minecraft.vine": "sǝuᴉɅ",
  "block.minecraft.void_air": "ɹᴉⱯ pᴉoɅ",
  "block.minecraft.wall_torch": "ɥɔɹo⟘ ꞁꞁɐM",
  "block.minecraft.warped_button": "uoʇʇnᗺ pǝdɹɐM",
  "block.minecraft.warped_door": "ɹooᗡ pǝdɹɐM",
  "block.minecraft.warped_fence": "ǝɔuǝℲ pǝdɹɐM",
  "block.minecraft.warped_fence_gate": "ǝʇɐ⅁ ǝɔuǝℲ pǝdɹɐM",
  "block.minecraft.warped_fungus": "snᵷunℲ pǝdɹɐM",
  "block.minecraft.warped_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH pǝdɹɐM",
  "block.minecraft.warped_hyphae": "ǝɐɥdʎH pǝdɹɐM",
  "block.minecraft.warped_nylium": "ɯnᴉꞁʎN pǝdɹɐM",
  "block.minecraft.warped_planks": "sʞuɐꞁԀ pǝdɹɐM",
  "block.minecraft.warped_pressure_plate": "ǝʇɐꞁԀ ǝɹnssǝɹԀ pǝdɹɐM",
  "block.minecraft.warped_roots": "sʇooᴚ pǝdɹɐM",
  "block.minecraft.warped_shelf": "ɟlǝɥS pǝdɹɐM",
  "block.minecraft.warped_sign": "uᵷᴉS pǝdɹɐM",
  "block.minecraft.warped_slab": "qɐꞁS pǝdɹɐM",
  "block.minecraft.warped_stairs": "sɹᴉɐʇS pǝdɹɐM",
  "block.minecraft.warped_stem": "ɯǝʇS pǝdɹɐM",
  "block.minecraft.warped_trapdoor": "ɹoopdɐɹ⟘ pǝdɹɐM",
  "block.minecraft.warped_wall_hanging_sign": "uᵷᴉS ᵷuᴉᵷuɐH ꞁꞁɐM pǝdɹɐM",
  "block.minecraft.warped_wall_sign": "uᵷᴉS ꞁꞁɐM pǝdɹɐM",
  "block.minecraft.warped_wart_block": "ʞɔoꞁᗺ ʇɹɐM pǝdɹɐM",
  "block.minecraft.water": "ɹǝʇɐM",
  "block.minecraft.water_cauldron": "uoɹpꞁnɐƆ ɹǝʇɐM",
  "block.minecraft.waxed_chiseled_copper": "ɹǝddoƆ pǝꞁꞁǝsᴉɥƆ pǝxɐM",
  "block.minecraft.waxed_copper_bars": "sɹɐᗺ ɹǝddoƆ pǝxɐM",
  "block.minecraft.waxed_copper_block": "ɹǝddoƆ ɟo ʞɔoꞁᗺ pǝxɐM",
  "block.minecraft.waxed_copper_bulb": "qꞁnᗺ ɹǝddoƆ pǝxɐM",
  "block.minecraft.waxed_copper_chain": "uᴉɐɥƆ ɹǝddoƆ pǝxɐM",
  "block.minecraft.waxed_copper_chest": "ʇsǝɥƆ ɹǝddoƆ pǝxɐM",
  "block.minecraft.waxed_copper_door": "ɹooᗡ ɹǝddoƆ pǝxɐM",
  "block.minecraft.waxed_copper_golem_statue": "ǝnʇɐʇS ɯǝꞁo⅁ ɹǝddoƆ pǝxɐM",
  "block.minecraft.waxed_copper_grate": "ǝʇɐɹ⅁ ɹǝddoƆ pǝxɐM",
  "block.minecraft.waxed_copper_lantern": "uɹǝʇuɐꞀ ɹǝddoƆ pǝxɐM",
  "block.minecraft.waxed_copper_trapdoor": "ɹoopdɐɹ⟘ ɹǝddoƆ pǝxɐM",
  "block.minecraft.waxed_cut_copper": "ɹǝddoƆ ʇnƆ pǝxɐM",
  "block.minecraft.waxed_cut_copper_slab": "qɐꞁS ɹǝddoƆ ʇnƆ pǝxɐM",
  "block.minecraft.waxed_cut_copper_stairs": "sɹᴉɐʇS ɹǝddoƆ ʇnƆ pǝxɐM",
  "block.minecraft.waxed_exposed_chiseled_copper": "ɹǝddoƆ pǝꞁꞁǝsᴉɥƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_copper": "ɹǝddoƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_copper_bars": "sɹɐᗺ ɹǝddoƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_copper_bulb": "qꞁnᗺ ɹǝddoƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_copper_chain": "uᴉɐɥƆ ɹǝddoƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_copper_chest": "ʇsǝɥƆ ɹǝddoƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_copper_door": "ɹooᗡ ɹǝddoƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_copper_golem_statue": "ǝnʇɐʇS ɯǝꞁo⅁ ɹǝddoƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_copper_grate": "ǝʇɐɹ⅁ ɹǝddoƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_copper_lantern": "uɹǝʇuɐꞀ ɹǝddoƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_copper_trapdoor": "ɹoopdɐɹ⟘ ɹǝddoƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_cut_copper": "ɹǝddoƆ ʇnƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_cut_copper_slab": "qɐꞁS ɹǝddoƆ ʇnƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "sɹᴉɐʇS ɹǝddoƆ ʇnƆ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_exposed_lightning_rod": "poᴚ ᵷuᴉuʇɥᵷᴉꞀ pǝsodxƎ pǝxɐM",
  "block.minecraft.waxed_lightning_rod": "poᴚ ᵷuᴉuʇɥᵷᴉꞀ pǝxɐM",
  "block.minecraft.waxed_oxidized_chiseled_copper": "ɹǝddoƆ pǝꞁꞁǝsᴉɥƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_copper": "ɹǝddoƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_copper_bars": "sɹɐᗺ ɹǝddoƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_copper_bulb": "qꞁnᗺ ɹǝddoƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_copper_chain": "uᴉɐɥƆ ɹǝddoƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_copper_chest": "ʇsǝɥƆ ɹǝddoƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_copper_door": "ɹooᗡ ɹǝddoƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "ǝnʇɐʇS ɯǝꞁo⅁ ɹǝddoƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_copper_grate": "ǝʇɐɹ⅁ ɹǝddoƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_copper_lantern": "uɹǝʇuɐꞀ ɹǝddoƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "ɹoopdɐɹ⟘ ɹǝddoƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_cut_copper": "ɹǝddoƆ ʇnƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "qɐꞁS ɹǝddoƆ ʇnƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "sɹᴉɐʇS ɹǝddoƆ ʇnƆ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_oxidized_lightning_rod": "poᴚ ᵷuᴉuʇɥᵷᴉꞀ pǝsᴉpᴉxO pǝxɐM",
  "block.minecraft.waxed_weathered_chiseled_copper": "ɹǝddoƆ pǝꞁꞁǝsᴉɥƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_copper": "ɹǝddoƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_copper_bars": "sɹɐᗺ ɹǝddoƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_copper_bulb": "qꞁnᗺ ɹǝddoƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_copper_chain": "uᴉɐɥƆ ɹǝddoƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_copper_chest": "ʇsǝɥƆ ɹǝddoƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_copper_door": "ɹooᗡ ɹǝddoƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_copper_golem_statue": "ǝnʇɐʇS ɯǝꞁo⅁ ɹǝddoƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_copper_grate": "ǝʇɐɹ⅁ ɹǝddoƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_copper_lantern": "uɹǝʇuɐꞀ ɹǝddoƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_copper_trapdoor": "ɹoopdɐɹ⟘ ɹǝddoƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_cut_copper": "ɹǝddoƆ ʇnƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_cut_copper_slab": "qɐꞁS ɹǝddoƆ ʇnƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "sɹᴉɐʇS ɹǝddoƆ ʇnƆ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.waxed_weathered_lightning_rod": "poᴚ ᵷuᴉuʇɥᵷᴉꞀ pǝɹǝɥʇɐǝM pǝxɐM",
  "block.minecraft.weathered_chiseled_copper": "ɹǝddoƆ pǝꞁꞁǝsᴉɥƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_copper": "ɹǝddoƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_copper_bars": "sɹɐᗺ ɹǝddoƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_copper_bulb": "qꞁnᗺ ɹǝddoƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_copper_chain": "uᴉɐɥƆ ɹǝddoƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_copper_chest": "ʇsǝɥƆ ɹǝddoƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_copper_door": "ɹooᗡ ɹǝddoƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_copper_golem_statue": "ǝnʇɐʇS ɯǝꞁo⅁ ɹǝddoƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_copper_grate": "ǝʇɐɹ⅁ ɹǝddoƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_copper_lantern": "uɹǝʇuɐꞀ ɹǝddoƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_copper_trapdoor": "ɹoopdɐɹ⟘ ɹǝddoƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_cut_copper": "ɹǝddoƆ ʇnƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_cut_copper_slab": "qɐꞁS ɹǝddoƆ ʇnƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_cut_copper_stairs": "sɹᴉɐʇS ɹǝddoƆ ʇnƆ pǝɹǝɥʇɐǝM",
  "block.minecraft.weathered_lightning_rod": "poᴚ ᵷuᴉuʇɥᵷᴉꞀ pǝɹǝɥʇɐǝM",
  "block.minecraft.weeping_vines": "sǝuᴉɅ ᵷuᴉdǝǝM",
  "block.minecraft.weeping_vines_plant": "ʇuɐꞁԀ sǝuᴉɅ ᵷuᴉdǝǝM",
  "block.minecraft.wet_sponge": "ǝᵷuodS ʇǝM",
  "block.minecraft.wheat": "sdoɹƆ ʇɐǝɥM",
  "block.minecraft.white_banner": "ɹǝuuɐᗺ ǝʇᴉɥM",
  "block.minecraft.white_bed": "pǝᗺ ǝʇᴉɥM",
  "block.minecraft.white_candle": "ǝꞁpuɐƆ ǝʇᴉɥM",
  "block.minecraft.white_candle_cake": "ǝꞁpuɐƆ ǝʇᴉɥM ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.white_carpet": "ʇǝdɹɐƆ ǝʇᴉɥM",
  "block.minecraft.white_concrete": "ǝʇǝɹɔuoƆ ǝʇᴉɥM",
  "block.minecraft.white_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ǝʇᴉɥM",
  "block.minecraft.white_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ǝʇᴉɥM",
  "block.minecraft.white_shulker_box": "xoᗺ ɹǝʞꞁnɥS ǝʇᴉɥM",
  "block.minecraft.white_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ǝʇᴉɥM",
  "block.minecraft.white_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ǝʇᴉɥM",
  "block.minecraft.white_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ǝʇᴉɥM",
  "block.minecraft.white_tulip": "dᴉꞁn⟘ ǝʇᴉɥM",
  "block.minecraft.white_wool": "ꞁooM ǝʇᴉɥM",
  "block.minecraft.wildflowers": "sɹǝʍoꞁɟpꞁᴉM",
  "block.minecraft.wither_rose": "ǝsoᴚ ɹǝɥʇᴉM",
  "block.minecraft.wither_skeleton_skull": "ꞁꞁnʞS uoʇǝꞁǝʞS ɹǝɥʇᴉM",
  "block.minecraft.wither_skeleton_wall_skull": "ꞁꞁnʞS ꞁꞁɐM uoʇǝꞁǝʞS ɹǝɥʇᴉM",
  "block.minecraft.yellow_banner": "ɹǝuuɐᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_bed": "pǝᗺ ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_candle": "ǝꞁpuɐƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_candle_cake": "ǝꞁpuɐƆ ʍoꞁꞁǝ⅄ ɥʇᴉʍ ǝʞɐƆ",
  "block.minecraft.yellow_carpet": "ʇǝdɹɐƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_concrete": "ǝʇǝɹɔuoƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_concrete_powder": "ɹǝpʍoԀ ǝʇǝɹɔuoƆ ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_glazed_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ pǝzɐꞁ⅁ ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_shulker_box": "xoᗺ ɹǝʞꞁnɥS ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_stained_glass": "ssɐꞁ⅁ pǝuᴉɐʇS ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_stained_glass_pane": "ǝuɐԀ ssɐꞁ⅁ pǝuᴉɐʇS ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_terracotta": "ɐʇʇoɔɐɹɹǝ⟘ ʍoꞁꞁǝ⅄",
  "block.minecraft.yellow_wool": "ꞁooM ʍoꞁꞁǝ⅄",
  "block.minecraft.zombie_head": "pɐǝH ǝᴉqɯoZ",
  "block.minecraft.zombie_wall_head": "pɐǝH ꞁꞁɐM ǝᴉqɯoZ",
  "item.minecraft.acacia_boat": "ʇɐoᗺ ɐᴉɔɐɔⱯ",
  "item.minecraft.acacia_chest_boat": "ʇsǝɥƆ ɥʇᴉʍ ʇɐoᗺ ɐᴉɔɐɔⱯ",
  "item.minecraft.allay_spawn_egg": "ᵷᵷƎ uʍɐdS ʎɐꞁꞁⱯ",
  "item.minecraft.amethyst_shard": "pɹɐɥS ʇsʎɥʇǝɯⱯ",
  "item.minecraft.angler_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ɹǝꞁᵷuⱯ",
  "item.minecraft.angler_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ɹǝꞁᵷuⱯ",
  "item.minecraft.apple": "ǝꞁddⱯ",
  "item.minecraft.archer_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ɹǝɥɔɹⱯ",
  "item.minecraft.archer_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ɹǝɥɔɹⱯ",
  "item.minecraft.armadillo_scute": "ǝʇnɔS oꞁꞁᴉpɐɯɹⱯ",
  "item.minecraft.armadillo_spawn_egg": "ᵷᵷƎ uʍɐdS oꞁꞁᴉpɐɯɹⱯ",
  "item.minecraft.armor_stand": "puɐʇS ɹnoɯɹⱯ",
  "item.minecraft.arms_up_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ d∩ sɯɹⱯ",
  "item.minecraft.arms_up_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ d∩ sɯɹⱯ",
  "item.minecraft.arrow": "ʍoɹɹⱯ",
  "item.minecraft.axolotl_bucket": "ꞁʇoꞁoxⱯ ɟo ʇǝʞɔnᗺ",
  "item.minecraft.axolotl_spawn_egg": "ᵷᵷƎ uʍɐdS ꞁʇoꞁoxⱯ",
  "item.minecraft.baked_potato": "oʇɐʇoԀ ʇǝʞɔɐՐ",
  "item.minecraft.bamboo_chest_raft": "ʇsǝɥƆ ɥʇᴉʍ ʇɟɐᴚ ooqɯɐᗺ",
  "item.minecraft.bamboo_raft": "ʇɟɐᴚ ooqɯɐᗺ",
  "item.minecraft.bat_spawn_egg": "ᵷᵷƎ uʍɐdS ʇɐᗺ",
  "item.minecraft.bee_spawn_egg": "ᵷᵷƎ uʍɐdS ǝǝᗺ",
  "item.minecraft.beef": "ɟǝǝᗺ ʍɐᴚ",
  "item.minecraft.beetroot": "ʇooɹʇǝǝᗺ",
  "item.minecraft.beetroot_seeds": "spǝǝS ʇooɹʇǝǝᗺ",
  "item.minecraft.beetroot_soup": "dnoS ʇooɹʇǝǝᗺ",
  "item.minecraft.birch_boat": "ʇɐoᗺ ɥɔɹᴉᗺ",
  "item.minecraft.birch_chest_boat": "ʇsǝɥƆ ɥʇᴉʍ ʇɐoᗺ ɥɔɹᴉᗺ",
  "item.minecraft.black_bundle": "ǝꞁpunᗺ ʞɔɐꞁᗺ",
  "item.minecraft.black_dye": "ǝʎᗡ ʞɔɐꞁᗺ",
  "item.minecraft.black_harness": "ssǝuɹɐH ʞɔɐꞁᗺ",
  "item.minecraft.blade_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ǝpɐꞁᗺ",
  "item.minecraft.blade_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ǝpɐꞁᗺ",
  "item.minecraft.blaze_powder": "ɹǝpʍoԀ ǝzɐꞁᗺ",
  "item.minecraft.blaze_rod": "poᴚ ǝzɐꞁᗺ",
  "item.minecraft.blaze_spawn_egg": "ᵷᵷƎ uʍɐdS ǝzɐꞁᗺ",
  "item.minecraft.blue_bundle": "ǝꞁpunᗺ ǝnꞁᗺ",
  "item.minecraft.blue_dye": "ǝʎᗡ ǝnꞁᗺ",
  "item.minecraft.blue_egg": "ᵷᵷƎ ǝnꞁᗺ",
  "item.minecraft.blue_harness": "ssǝuɹɐH ǝnꞁᗺ",
  "item.minecraft.bogged_spawn_egg": "ᵷᵷƎ uʍɐdS pǝᵷᵷoᗺ",
  "item.minecraft.bolt_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ʇꞁoᗺ",
  "item.minecraft.bone": "ǝuoᗺ",
  "item.minecraft.bone_meal": "ꞁɐǝW ǝuoᗺ",
  "item.minecraft.book": "ʞooᗺ",
  "item.minecraft.bordure_indented_banner_pattern": "uɹǝʇʇɐԀ ɹǝuuɐᗺ pǝʇuǝpuI ǝɹnpɹoᗺ",
  "item.minecraft.bow": "ʍoᗺ",
  "item.minecraft.bowl": "ꞁʍoᗺ",
  "item.minecraft.bread": "pɐǝɹᗺ",
  "item.minecraft.breeze_rod": "poᴚ ǝzǝǝɹᗺ",
  "item.minecraft.breeze_spawn_egg": "ᵷᵷƎ uʍɐdS ǝzǝǝɹᗺ",
  "item.minecraft.brewer_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ɹǝʍǝɹᗺ",
  "item.minecraft.brewer_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ɹǝʍǝɹᗺ",
  "item.minecraft.brewing_stand": "puɐʇS ᵷuᴉʍǝɹᗺ",
  "item.minecraft.brick": "ʞɔᴉɹᗺ",
  "item.minecraft.brown_bundle": "ǝꞁpunᗺ uʍoɹᗺ",
  "item.minecraft.brown_dye": "ǝʎᗡ uʍoɹᗺ",
  "item.minecraft.brown_egg": "ᵷᵷƎ uʍoɹᗺ",
  "item.minecraft.brown_harness": "ssǝuɹɐH uʍoɹᗺ",
  "item.minecraft.brush": "ɥsnɹᗺ",
  "item.minecraft.bucket": "ʇǝʞɔnᗺ",
  "item.minecraft.bundle": "ǝꞁpunᗺ",
  "item.minecraft.bundle.empty": "ʎʇdɯƎ",
  "item.minecraft.bundle.empty.description": "sɯǝʇᴉ ɟo ʞɔɐʇs pǝxᴉɯ ɐ pꞁoɥ uɐƆ",
  "item.minecraft.bundle.full": "ꞁꞁnℲ",
  "item.minecraft.bundle.fullness": "%2$s/%1$s",
  "item.minecraft.burn_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ uɹnᗺ",
  "item.minecraft.burn_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ uɹnᗺ",
  "item.minecraft.camel_husk_spawn_egg": "ᵷᵷƎ uʍɐdS ʞsnH ꞁǝɯɐƆ",
  "item.minecraft.camel_spawn_egg": "ᵷᵷƎ uʍɐdS ꞁǝɯɐƆ",
  "item.minecraft.carrot": "ʇoɹɹɐƆ",
  "item.minecraft.carrot_on_a_stick": "ʞɔᴉʇS ɐ uo ʇoɹɹɐƆ",
  "item.minecraft.cat_spawn_egg": "ᵷᵷƎ uʍɐdS ʇɐƆ",
  "item.minecraft.cauldron": "uoɹpꞁnɐƆ",
  "item.minecraft.cave_spider_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝpᴉdS ǝʌɐƆ",
  "item.minecraft.chainmail_boots": "sʇooᗺ ꞁᴉɐɯuᴉɐɥƆ",
  "item.minecraft.chainmail_chestplate": "ǝʇɐꞁdʇsǝɥƆ ꞁᴉɐɯuᴉɐɥƆ",
  "item.minecraft.chainmail_helmet": "ʇǝɯꞁǝH ꞁᴉɐɯuᴉɐɥƆ",
  "item.minecraft.chainmail_leggings": "sᵷuᴉᵷᵷǝꞀ ꞁᴉɐɯuᴉɐɥƆ",
  "item.minecraft.charcoal": "ꞁɐoɔɹɐɥƆ",
  "item.minecraft.cherry_boat": "ʇɐoᗺ ʎɹɹǝɥƆ",
  "item.minecraft.cherry_chest_boat": "ʇsǝɥƆ ɥʇᴉʍ ʇɐoᗺ ʎɹɹǝɥƆ",
  "item.minecraft.chest_minecart": "ʇsǝɥƆ ɥʇᴉʍ ʇɹɐɔǝuᴉW",
  "item.minecraft.chicken": "uǝʞɔᴉɥƆ ʍɐᴚ",
  "item.minecraft.chicken_spawn_egg": "ᵷᵷƎ uʍɐdS uǝʞɔᴉɥƆ",
  "item.minecraft.chorus_fruit": "ʇᴉnɹℲ snɹoɥƆ",
  "item.minecraft.clay_ball": "ꞁꞁɐᗺ ʎɐꞁƆ",
  "item.minecraft.clock": "ʞɔoꞁƆ",
  "item.minecraft.coal": "ꞁɐoƆ",
  "item.minecraft.coast_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.coast_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ʇsɐoƆ",
  "item.minecraft.cocoa_beans": "suɐǝᗺ ɐoɔoƆ",
  "item.minecraft.cod": "poƆ ʍɐᴚ",
  "item.minecraft.cod_bucket": "poƆ ɟo ʇǝʞɔnᗺ",
  "item.minecraft.cod_spawn_egg": "ᵷᵷƎ uʍɐdS poƆ",
  "item.minecraft.command_block_minecart": "ʞɔoꞁᗺ puɐɯɯoƆ ɥʇᴉʍ ʇɹɐɔǝuᴉW",
  "item.minecraft.compass": "ssɐdɯoƆ",
  "item.minecraft.cooked_beef": "ʞɐǝʇS",
  "item.minecraft.cooked_chicken": "uǝʞɔᴉɥƆ ʇsɐoᴚ",
  "item.minecraft.cooked_cod": "poƆ pǝʞooƆ",
  "item.minecraft.cooked_mutton": "uoʇʇnW pǝʞooƆ",
  "item.minecraft.cooked_porkchop": "doɥɔʞɹoԀ pǝʞooƆ",
  "item.minecraft.cooked_rabbit": "ʇᴉqqɐᴚ pǝʞooƆ",
  "item.minecraft.cooked_salmon": "uoɯꞁɐS pǝʞooƆ",
  "item.minecraft.cookie": "ʇᴉnɔsᴉᗺ",
  "item.minecraft.copper_axe": "ǝxⱯ ɹǝddoƆ",
  "item.minecraft.copper_boots": "sʇooᗺ ɹǝddoƆ",
  "item.minecraft.copper_chestplate": "ǝʇɐꞁdʇsǝɥƆ ɹǝddoƆ",
  "item.minecraft.copper_golem_spawn_egg": "ᵷᵷƎ uʍɐdS ɯǝꞁo⅁ ɹǝddoƆ",
  "item.minecraft.copper_helmet": "ʇǝɯꞁǝH ɹǝddoƆ",
  "item.minecraft.copper_hoe": "ǝoH ɹǝddoƆ",
  "item.minecraft.copper_horse_armor": "ɹnoɯɹⱯ ǝsɹoH ɹǝddoƆ",
  "item.minecraft.copper_ingot": "ʇoᵷuI ɹǝddoƆ",
  "item.minecraft.copper_leggings": "sᵷuᴉᵷᵷǝꞀ ɹǝddoƆ",
  "item.minecraft.copper_nautilus_armor": "ɹnoɯɹⱯ snꞁᴉʇnɐN ɹǝddoƆ",
  "item.minecraft.copper_nugget": "ʇǝᵷᵷnN ɹǝddoƆ",
  "item.minecraft.copper_pickaxe": "ǝxɐʞɔᴉԀ ɹǝddoƆ",
  "item.minecraft.copper_shovel": "ꞁǝʌoɥS ɹǝddoƆ",
  "item.minecraft.copper_spear": "ɹɐǝdS ɹǝddoƆ",
  "item.minecraft.copper_sword": "pɹoʍS ɹǝddoƆ",
  "item.minecraft.cow_spawn_egg": "ᵷᵷƎ uʍɐdS ʍoƆ",
  "item.minecraft.creaking_spawn_egg": "ᵷᵷƎ uʍɐdS ᵷuᴉʞɐǝɹƆ",
  "item.minecraft.creeper_banner_pattern": "uɹǝʇʇɐԀ ɹǝuuɐᗺ",
  "item.minecraft.creeper_banner_pattern.desc": "ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ",
  "item.minecraft.creeper_banner_pattern.new": "uɹǝʇʇɐԀ ɹǝuuɐᗺ ǝᵷɹɐɥƆ ɹǝdǝǝɹƆ",
  "item.minecraft.creeper_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝdǝǝɹƆ",
  "item.minecraft.crossbow": "ʍoqssoɹƆ",
  "item.minecraft.crossbow.projectile": ":ǝꞁᴉʇɔǝɾoɹԀ",
  "item.minecraft.crossbow.projectile.multiple": "%2$s x %1$s :ǝꞁᴉʇɔǝɾoɹԀ",
  "item.minecraft.crossbow.projectile.single": "%s :ǝꞁᴉʇɔǝɾoɹԀ",
  "item.minecraft.cyan_bundle": "ǝꞁpunᗺ uɐʎƆ",
  "item.minecraft.cyan_dye": "ǝʎᗡ uɐʎƆ",
  "item.minecraft.cyan_harness": "ssǝuɹɐH uɐʎƆ",
  "item.minecraft.danger_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ɹǝᵷuɐᗡ",
  "item.minecraft.danger_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ɹǝᵷuɐᗡ",
  "item.minecraft.dark_oak_boat": "ʇɐoᗺ ʞɐO ʞɹɐᗡ",
  "item.minecraft.dark_oak_chest_boat": "ʇsǝɥƆ ɥʇᴉʍ ʇɐoᗺ ʞɐO ʞɹɐᗡ",
  "item.minecraft.debug_stick": "ʞɔᴉʇS ᵷnqǝᗡ",
  "item.minecraft.debug_stick.empty": "sǝᴉʇɹǝdoɹd ou sɐɥ %s",
  "item.minecraft.debug_stick.select": "(%2$s) ,,%1$s,, pǝʇɔǝꞁǝs",
  "item.minecraft.debug_stick.update": "%2$s oʇ ,,%1$s,,",
  "item.minecraft.diamond": "puoɯɐᴉᗡ",
  "item.minecraft.diamond_axe": "ǝxⱯ puoɯɐᴉᗡ",
  "item.minecraft.diamond_boots": "sʇooᗺ puoɯɐᴉᗡ",
  "item.minecraft.diamond_chestplate": "ǝʇɐꞁdʇsǝɥƆ puoɯɐᴉᗡ",
  "item.minecraft.diamond_helmet": "ʇǝɯꞁǝH puoɯɐᴉᗡ",
  "item.minecraft.diamond_hoe": "ǝoH puoɯɐᴉᗡ",
  "item.minecraft.diamond_horse_armor": "ɹnoɯɹⱯ ǝsɹoH puoɯɐᴉᗡ",
  "item.minecraft.diamond_leggings": "sᵷuᴉᵷᵷǝꞀ puoɯɐᴉᗡ",
  "item.minecraft.diamond_nautilus_armor": "ɹnoɯɹⱯ snꞁᴉʇnɐN puoɯɐᴉᗡ",
  "item.minecraft.diamond_pickaxe": "ǝxɐʞɔᴉԀ puoɯɐᴉᗡ",
  "item.minecraft.diamond_shovel": "ꞁǝʌoɥS puoɯɐᴉᗡ",
  "item.minecraft.diamond_spear": "ɹɐǝdS puoɯɐᴉᗡ",
  "item.minecraft.diamond_sword": "pɹoʍS puoɯɐᴉᗡ",
  "item.minecraft.disc_fragment_5": "ʇuǝɯᵷɐɹℲ ɔsᴉᗡ",
  "item.minecraft.disc_fragment_5.desc": "ϛ - ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.dolphin_spawn_egg": "ᵷᵷƎ uʍɐdS uᴉɥdꞁoᗡ",
  "item.minecraft.donkey_spawn_egg": "ᵷᵷƎ uʍɐdS ʎǝʞuoᗡ",
  "item.minecraft.dragon_breath": "ɥʇɐǝɹᗺ s,uoᵷɐɹᗡ",
  "item.minecraft.dried_kelp": "dꞁǝꞰ pǝᴉɹᗡ",
  "item.minecraft.drowned_spawn_egg": "ᵷᵷƎ uʍɐdS pǝuʍoɹᗡ",
  "item.minecraft.dune_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.dune_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ǝunᗡ",
  "item.minecraft.echo_shard": "pɹɐɥS oɥɔƎ",
  "item.minecraft.egg": "ᵷᵷƎ",
  "item.minecraft.elder_guardian_spawn_egg": "ᵷᵷƎ uʍɐdS uɐᴉpɹɐn⅁ ɹǝpꞁƎ",
  "item.minecraft.elytra": "ɐɹʇʎꞁƎ",
  "item.minecraft.emerald": "pꞁɐɹǝɯƎ",
  "item.minecraft.enchanted_book": "ʞooᗺ pǝʇuɐɥɔuƎ",
  "item.minecraft.enchanted_golden_apple": "ǝꞁddⱯ uǝpꞁo⅁ pǝʇuɐɥɔuƎ",
  "item.minecraft.end_crystal": "ꞁɐʇsʎɹƆ puƎ",
  "item.minecraft.ender_dragon_spawn_egg": "ᵷᵷƎ uʍɐdS uoᵷɐɹᗡ ɹǝpuƎ",
  "item.minecraft.ender_eye": "ɹǝpuƎ ɟo ǝʎƎ",
  "item.minecraft.ender_pearl": "ꞁɹɐǝԀ ɹǝpuƎ",
  "item.minecraft.enderman_spawn_egg": "ᵷᵷƎ uʍɐdS uɐɯɹǝpuƎ",
  "item.minecraft.endermite_spawn_egg": "ᵷᵷƎ uʍɐdS ǝʇᴉɯɹǝpuƎ",
  "item.minecraft.evoker_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝʞoʌƎ",
  "item.minecraft.experience_bottle": "ᵷuᴉʇuɐɥɔuƎ ,o ǝꞁʇʇoᗺ",
  "item.minecraft.explorer_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ɹǝɹoꞁdxƎ",
  "item.minecraft.explorer_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ɹǝɹoꞁdxƎ",
  "item.minecraft.eye_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.eye_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ǝʎƎ",
  "item.minecraft.feather": "ɹǝɥʇɐǝℲ",
  "item.minecraft.fermented_spider_eye": "ǝʎƎ ɹǝpᴉdS pǝʇuǝɯɹǝℲ",
  "item.minecraft.field_masoned_banner_pattern": "uɹǝʇʇɐԀ ɹǝuuɐᗺ pǝuosɐW pꞁǝᴉℲ",
  "item.minecraft.filled_map": "dɐW",
  "item.minecraft.fire_charge": "ǝᵷɹɐɥƆ ǝɹᴉℲ",
  "item.minecraft.firework_rocket": "ʇǝʞɔoᴚ ʞɹoʍǝɹᴉℲ",
  "item.minecraft.firework_rocket.flight": ":uoᴉʇɐɹnᗡ ʇɥᵷᴉꞁℲ",
  "item.minecraft.firework_rocket.multiple_stars": "%2$s x %1$s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "ɹɐʇS ʞɹoʍǝɹᴉℲ",
  "item.minecraft.firework_star.black": "ʞɔɐꞁᗺ",
  "item.minecraft.firework_star.blue": "ǝnꞁᗺ",
  "item.minecraft.firework_star.brown": "uʍoɹᗺ",
  "item.minecraft.firework_star.custom_color": "ɯoʇsnƆ",
  "item.minecraft.firework_star.cyan": "uɐʎƆ",
  "item.minecraft.firework_star.fade_to": "oʇ ǝpɐℲ",
  "item.minecraft.firework_star.flicker": "ǝꞁʞuᴉʍ⟘",
  "item.minecraft.firework_star.gray": "ʎǝɹ⅁",
  "item.minecraft.firework_star.green": "uǝǝɹ⅁",
  "item.minecraft.firework_star.light_blue": "ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "item.minecraft.firework_star.light_gray": "ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "item.minecraft.firework_star.lime": "ǝɯᴉꞀ",
  "item.minecraft.firework_star.magenta": "ɐʇuǝᵷɐW",
  "item.minecraft.firework_star.orange": "ǝᵷuɐɹO",
  "item.minecraft.firework_star.pink": "ʞuᴉԀ",
  "item.minecraft.firework_star.purple": "ǝꞁdɹnԀ",
  "item.minecraft.firework_star.red": "pǝᴚ",
  "item.minecraft.firework_star.shape": "ǝdɐɥS uʍouʞu∩",
  "item.minecraft.firework_star.shape.burst": "ʇsɹnᗺ",
  "item.minecraft.firework_star.shape.creeper": "pǝdɐɥs-ɹǝdǝǝɹƆ",
  "item.minecraft.firework_star.shape.large_ball": "ꞁꞁɐᗺ ǝᵷɹɐꞀ",
  "item.minecraft.firework_star.shape.small_ball": "ꞁꞁɐᗺ ꞁꞁɐɯS",
  "item.minecraft.firework_star.shape.star": "pǝdɐɥs-ɹɐʇS",
  "item.minecraft.firework_star.trail": "ꞁᴉɐɹ⟘",
  "item.minecraft.firework_star.white": "ǝʇᴉɥM",
  "item.minecraft.firework_star.yellow": "ʍoꞁꞁǝ⅄",
  "item.minecraft.fishing_rod": "poᴚ ᵷuᴉɥsᴉℲ",
  "item.minecraft.flint": "ʇuᴉꞁℲ",
  "item.minecraft.flint_and_steel": "ꞁǝǝʇS puɐ ʇuᴉꞁℲ",
  "item.minecraft.flow_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.flow_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ʍoꞁℲ",
  "item.minecraft.flow_banner_pattern": "uɹǝʇʇɐԀ ɹǝuuɐᗺ",
  "item.minecraft.flow_banner_pattern.desc": "ʍoꞁℲ",
  "item.minecraft.flow_banner_pattern.new": "uɹǝʇʇɐԀ ɹǝuuɐᗺ ʍoꞁℲ",
  "item.minecraft.flow_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ʍoꞁℲ",
  "item.minecraft.flower_banner_pattern": "uɹǝʇʇɐԀ ɹǝuuɐᗺ",
  "item.minecraft.flower_banner_pattern.desc": "ǝᵷɹɐɥƆ ɹǝʍoꞁℲ",
  "item.minecraft.flower_banner_pattern.new": "uɹǝʇʇɐԀ ɹǝuuɐᗺ ǝᵷɹɐɥƆ ɹǝʍoꞁℲ",
  "item.minecraft.flower_pot": "ʇoԀ ɹǝʍoꞁℲ",
  "item.minecraft.fox_spawn_egg": "ᵷᵷƎ uʍɐdS xoℲ",
  "item.minecraft.friend_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ puǝᴉɹℲ",
  "item.minecraft.friend_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ puǝᴉɹℲ",
  "item.minecraft.frog_spawn_egg": "ᵷᵷƎ uʍɐdS ᵷoɹℲ",
  "item.minecraft.furnace_minecart": "ǝɔɐuɹnℲ ɥʇᴉʍ ʇɹɐɔǝuᴉW",
  "item.minecraft.ghast_spawn_egg": "ᵷᵷƎ uʍɐdS ʇsɐɥ⅁",
  "item.minecraft.ghast_tear": "ɹɐǝ⟘ ʇsɐɥ⅁",
  "item.minecraft.glass_bottle": "ǝꞁʇʇoᗺ ssɐꞁ⅁",
  "item.minecraft.glistering_melon_slice": "ǝɔᴉꞁS uoꞁǝW ᵷuᴉɹǝʇsᴉꞁ⅁",
  "item.minecraft.globe_banner_pattern": "uɹǝʇʇɐԀ ɹǝuuɐᗺ",
  "item.minecraft.globe_banner_pattern.desc": "ǝqoꞁ⅁",
  "item.minecraft.globe_banner_pattern.new": "uɹǝʇʇɐԀ ɹǝuuɐᗺ ǝqoꞁ⅁",
  "item.minecraft.glow_berries": "sǝᴉɹɹǝᗺ ʍoꞁ⅁",
  "item.minecraft.glow_ink_sac": "ɔɐS ʞuI ʍoꞁ⅁",
  "item.minecraft.glow_item_frame": "ǝɯɐɹℲ ɯǝʇI ʍoꞁ⅁",
  "item.minecraft.glow_squid_spawn_egg": "ᵷᵷƎ uʍɐdS pᴉnbS ʍoꞁ⅁",
  "item.minecraft.glowstone_dust": "ʇsnᗡ ǝuoʇsʍoꞁ⅁",
  "item.minecraft.goat_horn": "uɹoH ʇɐo⅁",
  "item.minecraft.goat_spawn_egg": "ᵷᵷƎ uʍɐdS ʇɐo⅁",
  "item.minecraft.gold_ingot": "ʇoᵷuI pꞁo⅁",
  "item.minecraft.gold_nugget": "ʇǝᵷᵷnN uǝpꞁo⅁",
  "item.minecraft.golden_apple": "ǝꞁddⱯ uǝpꞁo⅁",
  "item.minecraft.golden_axe": "ǝxⱯ uǝpꞁo⅁",
  "item.minecraft.golden_boots": "sʇooᗺ uǝpꞁo⅁",
  "item.minecraft.golden_carrot": "ʇoɹɹɐƆ uǝpꞁo⅁",
  "item.minecraft.golden_chestplate": "ǝʇɐꞁdʇsǝɥƆ uǝpꞁo⅁",
  "item.minecraft.golden_helmet": "ʇǝɯꞁǝH uǝpꞁo⅁",
  "item.minecraft.golden_hoe": "ǝoH uǝpꞁo⅁",
  "item.minecraft.golden_horse_armor": "ɹnoɯɹⱯ ǝsɹoH uǝpꞁo⅁",
  "item.minecraft.golden_leggings": "sᵷuᴉᵷᵷǝꞀ uǝpꞁo⅁",
  "item.minecraft.golden_nautilus_armor": "ɹnoɯɹⱯ snꞁᴉʇnɐN uǝpꞁo⅁",
  "item.minecraft.golden_pickaxe": "ǝxɐʞɔᴉԀ uǝpꞁo⅁",
  "item.minecraft.golden_shovel": "ꞁǝʌoɥS uǝpꞁo⅁",
  "item.minecraft.golden_spear": "ɹɐǝdS uǝpꞁo⅁",
  "item.minecraft.golden_sword": "pɹoʍS uǝpꞁo⅁",
  "item.minecraft.gray_bundle": "ǝꞁpunᗺ ʎǝɹ⅁",
  "item.minecraft.gray_dye": "ǝʎᗡ ʎǝɹ⅁",
  "item.minecraft.gray_harness": "ssǝuɹɐH ʎǝɹ⅁",
  "item.minecraft.green_bundle": "ǝꞁpunᗺ uǝǝɹ⅁",
  "item.minecraft.green_dye": "ǝʎᗡ uǝǝɹ⅁",
  "item.minecraft.green_harness": "ssǝuɹɐH uǝǝɹ⅁",
  "item.minecraft.guardian_spawn_egg": "ᵷᵷƎ uʍɐdS uɐᴉpɹɐn⅁",
  "item.minecraft.gunpowder": "ɹǝpʍodun⅁",
  "item.minecraft.guster_banner_pattern": "uɹǝʇʇɐԀ ɹǝuuɐᗺ",
  "item.minecraft.guster_banner_pattern.desc": "ɹǝʇsn⅁",
  "item.minecraft.guster_banner_pattern.new": "uɹǝʇʇɐԀ ɹǝuuɐᗺ ɹǝʇsn⅁",
  "item.minecraft.guster_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ɹǝʇsn⅁",
  "item.minecraft.happy_ghast_spawn_egg": "ᵷᵷƎ uʍɐdS ʇsɐɥ⅁ ʎddɐH",
  "item.minecraft.harness": "ssǝuɹɐH",
  "item.minecraft.heart_of_the_sea": "ɐǝS ǝɥʇ ɟo ʇɹɐǝH",
  "item.minecraft.heart_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ʇɹɐǝH",
  "item.minecraft.heart_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ʇɹɐǝH",
  "item.minecraft.heartbreak_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ʞɐǝɹqʇɹɐǝH",
  "item.minecraft.heartbreak_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ʞɐǝɹqʇɹɐǝH",
  "item.minecraft.hoglin_spawn_egg": "ᵷᵷƎ uʍɐdS uᴉꞁᵷoH",
  "item.minecraft.honey_bottle": "ǝꞁʇʇoᗺ ʎǝuoH",
  "item.minecraft.honeycomb": "qɯoɔʎǝuoH",
  "item.minecraft.hopper_minecart": "ɹǝddoH ɥʇᴉʍ ʇɹɐɔǝuᴉW",
  "item.minecraft.horse_spawn_egg": "ᵷᵷƎ uʍɐdS ǝsɹoH",
  "item.minecraft.host_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.host_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ʇsoH",
  "item.minecraft.howl_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ꞁʍoH",
  "item.minecraft.howl_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ꞁʍoH",
  "item.minecraft.husk_spawn_egg": "ᵷᵷƎ uʍɐdS ʞsnH",
  "item.minecraft.ink_sac": "ɔɐS ʞuI",
  "item.minecraft.iron_axe": "ǝxⱯ uoɹI",
  "item.minecraft.iron_boots": "sʇooᗺ uoɹI",
  "item.minecraft.iron_chestplate": "ǝʇɐꞁdʇsǝɥƆ uoɹI",
  "item.minecraft.iron_golem_spawn_egg": "ᵷᵷƎ uʍɐdS ɯǝꞁo⅁ uoɹI",
  "item.minecraft.iron_helmet": "ʇǝɯꞁǝH uoɹI",
  "item.minecraft.iron_hoe": "ǝoH uoɹI",
  "item.minecraft.iron_horse_armor": "ɹnoɯɹⱯ ǝsɹoH uoɹI",
  "item.minecraft.iron_ingot": "ʇoᵷuI uoɹI",
  "item.minecraft.iron_leggings": "sᵷuᴉᵷᵷǝꞀ uoɹI",
  "item.minecraft.iron_nautilus_armor": "ɹnoɯɹⱯ snꞁᴉʇnɐN uoɹI",
  "item.minecraft.iron_nugget": "ʇǝᵷᵷnN uoɹI",
  "item.minecraft.iron_pickaxe": "ǝxɐʞɔᴉԀ uoɹI",
  "item.minecraft.iron_shovel": "ꞁǝʌoɥS uoɹI",
  "item.minecraft.iron_spear": "ɹɐǝdS uoɹI",
  "item.minecraft.iron_sword": "pɹoʍS uoɹI",
  "item.minecraft.item_frame": "ǝɯɐɹℲ ɯǝʇI",
  "item.minecraft.jungle_boat": "ʇɐoᗺ ǝꞁᵷunՐ",
  "item.minecraft.jungle_chest_boat": "ʇsǝɥƆ ɥʇᴉʍ ʇɐoᗺ ǝꞁᵷunՐ",
  "item.minecraft.knowledge_book": "ʞooᗺ ǝᵷpǝꞁʍouꞰ",
  "item.minecraft.lapis_lazuli": "ᴉꞁnzɐꞀ sᴉdɐꞀ",
  "item.minecraft.lava_bucket": "ʇǝʞɔnᗺ ɐʌɐꞀ",
  "item.minecraft.lead": "pɐǝꞀ",
  "item.minecraft.leather": "ɹǝɥʇɐǝꞀ",
  "item.minecraft.leather_boots": "sʇooᗺ ɹǝɥʇɐǝꞀ",
  "item.minecraft.leather_chestplate": "ɔᴉun⟘ ɹǝɥʇɐǝꞀ",
  "item.minecraft.leather_helmet": "ʇɐH ɹǝɥʇɐǝꞀ",
  "item.minecraft.leather_horse_armor": "ɹnoɯɹⱯ ǝsɹoH ɹǝɥʇɐǝꞀ",
  "item.minecraft.leather_leggings": "sɹǝsnoɹ⟘ ɹǝɥʇɐǝꞀ",
  "item.minecraft.light_blue_bundle": "ǝꞁpunᗺ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "item.minecraft.light_blue_dye": "ǝʎᗡ ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "item.minecraft.light_blue_harness": "ssǝuɹɐH ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "item.minecraft.light_gray_bundle": "ǝꞁpunᗺ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "item.minecraft.light_gray_dye": "ǝʎᗡ ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "item.minecraft.light_gray_harness": "ssǝuɹɐH ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "item.minecraft.lime_bundle": "ǝꞁpunᗺ ǝɯᴉꞀ",
  "item.minecraft.lime_dye": "ǝʎᗡ ǝɯᴉꞀ",
  "item.minecraft.lime_harness": "ssǝuɹɐH ǝɯᴉꞀ",
  "item.minecraft.lingering_potion": "uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.awkward": "uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ pɹɐʍʞʍⱯ",
  "item.minecraft.lingering_potion.effect.empty": "uoᴉʇoԀ ǝꞁqɐʇɟɐɹɔu∩ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.fire_resistance": "ǝɔuɐʇsᴉsǝᴚ ǝɹᴉℲ ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.harming": "ᵷuᴉɯɹɐH ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.healing": "ᵷuᴉꞁɐǝH ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.infested": "uoᴉʇɐʇsǝɟuI ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.invisibility": "ʎʇᴉꞁᴉqᴉsᴉʌuI ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.leaping": "ᵷuᴉdɐǝꞀ ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.levitation": "uoᴉʇɐʇᴉʌǝꞀ ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.luck": "ʞɔnꞀ ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.mundane": "uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ ǝuɐpunW",
  "item.minecraft.lingering_potion.effect.night_vision": "uoᴉsᴉɅ ʇɥᵷᴉN ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.oozing": "ᵷuᴉzoO ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.poison": "uosᴉoԀ ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.regeneration": "uoᴉʇɐɹǝuǝᵷǝᴚ ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.slow_falling": "ᵷuᴉꞁꞁɐℲ ʍoꞁS ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.slowness": "ssǝuʍoꞁS ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.strength": "ɥʇᵷuǝɹʇS ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.swiftness": "ssǝuʇɟᴉʍS ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.thick": "uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ ʞɔᴉɥ⟘",
  "item.minecraft.lingering_potion.effect.turtle_master": "ɹǝʇsɐW ǝꞁʇɹn⟘ ǝɥʇ ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.water": "ǝꞁʇʇoᗺ ɹǝʇɐM ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.water_breathing": "ᵷuᴉɥʇɐǝɹᗺ ɹǝʇɐM ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.weakness": "ssǝuʞɐǝM ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.weaving": "ᵷuᴉʌɐǝM ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.lingering_potion.effect.wind_charged": "ᵷuᴉᵷɹɐɥƆ puᴉM ɟo uoᴉʇoԀ ᵷuᴉɹǝᵷuᴉꞀ",
  "item.minecraft.llama_spawn_egg": "ᵷᵷƎ uʍɐdS ɐɯɐꞁꞀ",
  "item.minecraft.lodestone_compass": "ssɐdɯoƆ ǝuoʇsǝpoꞀ",
  "item.minecraft.mace": "ǝɔɐW",
  "item.minecraft.magenta_bundle": "ǝꞁpunᗺ ɐʇuǝᵷɐW",
  "item.minecraft.magenta_dye": "ǝʎᗡ ɐʇuǝᵷɐW",
  "item.minecraft.magenta_harness": "ssǝuɹɐH ɐʇuǝᵷɐW",
  "item.minecraft.magma_cream": "ɯɐǝɹƆ ɐɯᵷɐW",
  "item.minecraft.magma_cube_spawn_egg": "ᵷᵷƎ uʍɐdS ǝqnƆ ɐɯᵷɐW",
  "item.minecraft.mangrove_boat": "ʇɐoᗺ ǝʌoɹᵷuɐW",
  "item.minecraft.mangrove_chest_boat": "ʇsǝɥƆ ɥʇᴉʍ ʇɐoᗺ ǝʌoɹᵷuɐW",
  "item.minecraft.map": "dɐW ʎʇdɯƎ",
  "item.minecraft.melon_seeds": "spǝǝS uoꞁǝW",
  "item.minecraft.melon_slice": "ǝɔᴉꞁS uoꞁǝW",
  "item.minecraft.milk_bucket": "ʇǝʞɔnᗺ ʞꞁᴉW",
  "item.minecraft.minecart": "ʇɹɐɔǝuᴉW",
  "item.minecraft.miner_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ɹǝuᴉW",
  "item.minecraft.miner_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ɹǝuᴉW",
  "item.minecraft.mojang_banner_pattern": "uɹǝʇʇɐԀ ɹǝuuɐᗺ",
  "item.minecraft.mojang_banner_pattern.desc": "ᵷuᴉɥ⟘",
  "item.minecraft.mojang_banner_pattern.new": "uɹǝʇʇɐԀ ɹǝuuɐᗺ ᵷuᴉɥ⟘",
  "item.minecraft.mooshroom_spawn_egg": "ᵷᵷƎ uʍɐdS ɯooɹɥsooW",
  "item.minecraft.mourner_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ɹǝuɹnoW",
  "item.minecraft.mourner_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ɹǝuɹnoW",
  "item.minecraft.mule_spawn_egg": "ᵷᵷƎ uʍɐdS ǝꞁnW",
  "item.minecraft.mushroom_stew": "ʍǝʇS ɯooɹɥsnW",
  "item.minecraft.music_disc_11": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_11.desc": "⥝⥝ - 8⥝߈Ɔ",
  "item.minecraft.music_disc_13": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_13.desc": "Ɛ⥝ - 8⥝߈Ɔ",
  "item.minecraft.music_disc_5": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_5.desc": "ϛ - ᵷɹǝqⱯ ꞁǝnɯɐS",
  "item.minecraft.music_disc_blocks": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_blocks.desc": "sʞɔoꞁq - 8⥝߈Ɔ",
  "item.minecraft.music_disc_cat": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_cat.desc": "ʇɐɔ - 8⥝߈Ɔ",
  "item.minecraft.music_disc_chirp": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_chirp.desc": "dɹᴉɥɔ - 8⥝߈Ɔ",
  "item.minecraft.music_disc_creator": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_creator.desc": "ɹoʇɐǝɹƆ - ǝuᴉɐᴚ ɐuǝꞀ",
  "item.minecraft.music_disc_creator_music_box": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_creator_music_box.desc": "(xoᗺ ꞁɐɔᴉsnW) ɹoʇɐǝɹƆ - ǝuᴉɐᴚ ɐuǝꞀ",
  "item.minecraft.music_disc_far": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_far.desc": "ɹɐɟ - 8⥝߈Ɔ",
  "item.minecraft.music_disc_lava_chicken": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_lava_chicken.desc": "uǝʞɔᴉɥƆ ɐʌɐꞀ - suoᴉʇoԀ ɹǝdʎH",
  "item.minecraft.music_disc_mall": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_mall.desc": "ꞁꞁɐɯ - 8⥝߈Ɔ",
  "item.minecraft.music_disc_mellohi": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_mellohi.desc": "ᴉɥoꞁꞁǝɯ - 8⥝߈Ɔ",
  "item.minecraft.music_disc_otherside": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_otherside.desc": "ǝpᴉsɹǝɥʇo - ǝuᴉɐᴚ ɐuǝꞀ",
  "item.minecraft.music_disc_pigstep": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_pigstep.desc": "dǝʇsᵷᴉԀ - ǝuᴉɐᴚ ɐuǝꞀ",
  "item.minecraft.music_disc_precipice": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_precipice.desc": "ǝɔᴉdᴉɔǝɹԀ - ɟoɹǝɥƆ uoɹɐⱯ",
  "item.minecraft.music_disc_relic": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_relic.desc": "ɔᴉꞁǝᴚ - ɟoɹǝɥƆ uoɹɐⱯ",
  "item.minecraft.music_disc_stal": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_stal.desc": "ꞁɐʇs - 8⥝߈Ɔ",
  "item.minecraft.music_disc_strad": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_strad.desc": "pɐɹʇs - 8⥝߈Ɔ",
  "item.minecraft.music_disc_tears": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_tears.desc": "sɹɐǝ⟘ - ʎppoᴚ soɯⱯ",
  "item.minecraft.music_disc_wait": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_wait.desc": "ʇᴉɐʍ - 8⥝߈Ɔ",
  "item.minecraft.music_disc_ward": "ɔsᴉᗡ ɔᴉsnW",
  "item.minecraft.music_disc_ward.desc": "pɹɐʍ - 8⥝߈Ɔ",
  "item.minecraft.mutton": "uoʇʇnW ʍɐᴚ",
  "item.minecraft.name_tag": "ᵷɐ⟘ ǝɯɐN",
  "item.minecraft.nautilus_shell": "ꞁꞁǝɥS snꞁᴉʇnɐN",
  "item.minecraft.nautilus_spawn_egg": "ᵷᵷƎ uʍɐdS snꞁᴉʇnɐN",
  "item.minecraft.nether_brick": "ʞɔᴉɹᗺ ɹǝɥʇǝN",
  "item.minecraft.nether_star": "ɹɐʇS ɹǝɥʇǝN",
  "item.minecraft.nether_wart": "ʇɹɐM ɹǝɥʇǝN",
  "item.minecraft.netherite_axe": "ǝxⱯ ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_boots": "sʇooᗺ ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_chestplate": "ǝʇɐꞁdʇsǝɥƆ ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_helmet": "ʇǝɯꞁǝH ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_hoe": "ǝoH ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_horse_armor": "ɹnoɯɹⱯ ǝsɹoH ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_ingot": "ʇoᵷuI ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_leggings": "sᵷuᴉᵷᵷǝꞀ ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_nautilus_armor": "ɹnoɯɹⱯ snꞁᴉʇnɐN ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_pickaxe": "ǝxɐʞɔᴉԀ ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_scrap": "dɐɹɔS ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_shovel": "ꞁǝʌoɥS ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_spear": "ɹɐǝdS ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_sword": "pɹoʍS ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.netherite_upgrade_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.netherite_upgrade_smithing_template.new": "ǝpɐɹᵷd∩ ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.oak_boat": "ʇɐoᗺ ʞɐO",
  "item.minecraft.oak_chest_boat": "ʇsǝɥƆ ɥʇᴉʍ ʇɐoᗺ ʞɐO",
  "item.minecraft.ocelot_spawn_egg": "ᵷᵷƎ uʍɐdS ʇoꞁǝɔO",
  "item.minecraft.ominous_bottle": "ǝꞁʇʇoᗺ snouᴉɯO",
  "item.minecraft.ominous_trial_key": "ʎǝꞰ ꞁɐᴉɹ⟘ snouᴉɯO",
  "item.minecraft.orange_bundle": "ǝꞁpunᗺ ǝᵷuɐɹO",
  "item.minecraft.orange_dye": "ǝʎᗡ ǝᵷuɐɹO",
  "item.minecraft.orange_harness": "ssǝuɹɐH ǝᵷuɐɹO",
  "item.minecraft.painting": "ᵷuᴉʇuᴉɐԀ",
  "item.minecraft.pale_oak_boat": "ʇɐoᗺ ʞɐO ǝꞁɐԀ",
  "item.minecraft.pale_oak_chest_boat": "ʇsǝɥƆ ɥʇᴉʍ ʇɐoᗺ ʞɐO ǝꞁɐԀ",
  "item.minecraft.panda_spawn_egg": "ᵷᵷƎ uʍɐdS ɐpuɐԀ",
  "item.minecraft.paper": "ɹǝdɐԀ",
  "item.minecraft.parched_spawn_egg": "ᵷᵷƎ uʍɐdS pǝɥɔɹɐԀ",
  "item.minecraft.parrot_spawn_egg": "ᵷᵷƎ uʍɐdS ʇoɹɹɐԀ",
  "item.minecraft.phantom_membrane": "ǝuɐɹqɯǝW ɯoʇuɐɥԀ",
  "item.minecraft.phantom_spawn_egg": "ᵷᵷƎ uʍɐdS ɯoʇuɐɥԀ",
  "item.minecraft.pig_spawn_egg": "ᵷᵷƎ uʍɐdS ᵷᴉԀ",
  "item.minecraft.piglin_banner_pattern": "uɹǝʇʇɐԀ ɹǝuuɐᗺ",
  "item.minecraft.piglin_banner_pattern.desc": "ʇnouS",
  "item.minecraft.piglin_banner_pattern.new": "uɹǝʇʇɐԀ ɹǝuuɐᗺ ʇnouS",
  "item.minecraft.piglin_brute_spawn_egg": "ᵷᵷƎ uʍɐdS ǝʇnɹᗺ uᴉꞁᵷᴉԀ",
  "item.minecraft.piglin_spawn_egg": "ᵷᵷƎ uʍɐdS uᴉꞁᵷᴉԀ",
  "item.minecraft.pillager_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝᵷɐꞁꞁᴉԀ",
  "item.minecraft.pink_bundle": "ǝꞁpunᗺ ʞuᴉԀ",
  "item.minecraft.pink_dye": "ǝʎᗡ ʞuᴉԀ",
  "item.minecraft.pink_harness": "ssǝuɹɐH ʞuᴉԀ",
  "item.minecraft.pitcher_plant": "ʇuɐꞁԀ ɹǝɥɔʇᴉԀ",
  "item.minecraft.pitcher_pod": "poԀ ɹǝɥɔʇᴉԀ",
  "item.minecraft.plenty_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ʎʇuǝꞁԀ",
  "item.minecraft.plenty_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ʎʇuǝꞁԀ",
  "item.minecraft.poisonous_potato": "oʇɐʇoԀ snouosᴉoԀ",
  "item.minecraft.polar_bear_spawn_egg": "ᵷᵷƎ uʍɐdS ɹɐǝᗺ ɹɐꞁoԀ",
  "item.minecraft.popped_chorus_fruit": "ʇᴉnɹℲ snɹoɥƆ pǝddoԀ",
  "item.minecraft.porkchop": "doɥɔʞɹoԀ ʍɐᴚ",
  "item.minecraft.potato": "oʇɐʇoԀ",
  "item.minecraft.potion": "uoᴉʇoԀ",
  "item.minecraft.potion.effect.awkward": "uoᴉʇoԀ pɹɐʍʞʍⱯ",
  "item.minecraft.potion.effect.empty": "uoᴉʇoԀ ǝꞁqɐʇɟɐɹɔu∩",
  "item.minecraft.potion.effect.fire_resistance": "ǝɔuɐʇsᴉsǝᴚ ǝɹᴉℲ ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.harming": "ᵷuᴉɯɹɐH ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.healing": "ᵷuᴉꞁɐǝH ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.infested": "uoᴉʇɐʇsǝɟuI ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.invisibility": "ʎʇᴉꞁᴉqᴉsᴉʌuI ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.leaping": "ᵷuᴉdɐǝꞀ ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.levitation": "uoᴉʇɐʇᴉʌǝꞀ ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.luck": "ʞɔnꞀ ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.mundane": "uoᴉʇoԀ ǝuɐpunW",
  "item.minecraft.potion.effect.night_vision": "uoᴉsᴉɅ ʇɥᵷᴉN ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.oozing": "ᵷuᴉzoO ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.poison": "uosᴉoԀ ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.regeneration": "uoᴉʇɐɹǝuǝᵷǝᴚ ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.slow_falling": "ᵷuᴉꞁꞁɐℲ ʍoꞁS ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.slowness": "ssǝuʍoꞁS ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.strength": "ɥʇᵷuǝɹʇS ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.swiftness": "ssǝuʇɟᴉʍS ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.thick": "uoᴉʇoԀ ʞɔᴉɥ⟘",
  "item.minecraft.potion.effect.turtle_master": "ɹǝʇsɐW ǝꞁʇɹn⟘ ǝɥʇ ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.water": "ǝꞁʇʇoᗺ ɹǝʇɐM",
  "item.minecraft.potion.effect.water_breathing": "ᵷuᴉɥʇɐǝɹᗺ ɹǝʇɐM ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.weakness": "ssǝuʞɐǝM ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.weaving": "ᵷuᴉʌɐǝM ɟo uoᴉʇoԀ",
  "item.minecraft.potion.effect.wind_charged": "ᵷuᴉᵷɹɐɥƆ puᴉM ɟo uoᴉʇoԀ",
  "item.minecraft.pottery_shard_archer": "pɹɐɥS ʎɹǝʇʇoԀ ɹǝɥɔɹⱯ",
  "item.minecraft.pottery_shard_arms_up": "pɹɐɥS ʎɹǝʇʇoԀ d∩ sɯɹⱯ",
  "item.minecraft.pottery_shard_prize": "pɹɐɥS ʎɹǝʇʇoԀ ǝzᴉɹԀ",
  "item.minecraft.pottery_shard_skull": "pɹɐɥS ʎɹǝʇʇoԀ ꞁꞁnʞS",
  "item.minecraft.powder_snow_bucket": "ʇǝʞɔnᗺ ʍouS ɹǝpʍoԀ",
  "item.minecraft.prismarine_crystals": "sꞁɐʇsʎɹƆ ǝuᴉɹɐɯsᴉɹԀ",
  "item.minecraft.prismarine_shard": "pɹɐɥS ǝuᴉɹɐɯsᴉɹԀ",
  "item.minecraft.prize_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ǝzᴉɹԀ",
  "item.minecraft.prize_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ǝzᴉɹԀ",
  "item.minecraft.pufferfish": "ɥsᴉɟɹǝɟɟnԀ",
  "item.minecraft.pufferfish_bucket": "ɥsᴉɟɹǝɟɟnԀ ɟo ʇǝʞɔnᗺ",
  "item.minecraft.pufferfish_spawn_egg": "ᵷᵷƎ uʍɐdS ɥsᴉɟɹǝɟɟnԀ",
  "item.minecraft.pumpkin_pie": "ǝᴉԀ uᴉʞdɯnԀ",
  "item.minecraft.pumpkin_seeds": "spǝǝS uᴉʞdɯnԀ",
  "item.minecraft.purple_bundle": "ǝꞁpunᗺ ǝꞁdɹnԀ",
  "item.minecraft.purple_dye": "ǝʎᗡ ǝꞁdɹnԀ",
  "item.minecraft.purple_harness": "ssǝuɹɐH ǝꞁdɹnԀ",
  "item.minecraft.quartz": "zʇɹɐnꝹ ɹǝɥʇǝN",
  "item.minecraft.rabbit": "ʇᴉqqɐᴚ ʍɐᴚ",
  "item.minecraft.rabbit_foot": "ʇooℲ s,ʇᴉqqɐᴚ",
  "item.minecraft.rabbit_hide": "ǝpᴉH ʇᴉqqɐᴚ",
  "item.minecraft.rabbit_spawn_egg": "ᵷᵷƎ uʍɐdS ʇᴉqqɐᴚ",
  "item.minecraft.rabbit_stew": "ʍǝʇS ʇᴉqqɐᴚ",
  "item.minecraft.raiser_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ɹǝsᴉɐᴚ",
  "item.minecraft.ravager_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝᵷɐʌɐᴚ",
  "item.minecraft.raw_copper": "ɹǝddoƆ ʍɐᴚ",
  "item.minecraft.raw_gold": "pꞁo⅁ ʍɐᴚ",
  "item.minecraft.raw_iron": "uoɹI ʍɐᴚ",
  "item.minecraft.recovery_compass": "ssɐdɯoƆ ʎɹǝʌoɔǝᴚ",
  "item.minecraft.red_bundle": "ǝꞁpunᗺ pǝᴚ",
  "item.minecraft.red_dye": "ǝʎᗡ pǝᴚ",
  "item.minecraft.red_harness": "ssǝuɹɐH pǝᴚ",
  "item.minecraft.redstone": "ʇsnᗡ ǝuoʇspǝᴚ",
  "item.minecraft.resin_brick": "ʞɔᴉɹᗺ uᴉsǝᴚ",
  "item.minecraft.resin_clump": "dɯnꞁƆ uᴉsǝᴚ",
  "item.minecraft.rib_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.rib_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ qᴉᴚ",
  "item.minecraft.rotten_flesh": "ɥsǝꞁℲ uǝʇʇoᴚ",
  "item.minecraft.saddle": "ǝꞁppɐS",
  "item.minecraft.salmon": "uoɯꞁɐS ʍɐᴚ",
  "item.minecraft.salmon_bucket": "uoɯꞁɐS ɟo ʇǝʞɔnᗺ",
  "item.minecraft.salmon_spawn_egg": "ᵷᵷƎ uʍɐdS uoɯꞁɐS",
  "item.minecraft.scrape_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ǝdɐɹɔS",
  "item.minecraft.scute": "ǝʇnɔS",
  "item.minecraft.sentry_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ʎɹʇuǝS",
  "item.minecraft.shaper_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ɹǝdɐɥS",
  "item.minecraft.sheaf_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ɟɐǝɥS",
  "item.minecraft.sheaf_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ɟɐǝɥS",
  "item.minecraft.shears": "sɹɐǝɥS",
  "item.minecraft.sheep_spawn_egg": "ᵷᵷƎ uʍɐdS dǝǝɥS",
  "item.minecraft.shelter_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ɹǝʇꞁǝɥS",
  "item.minecraft.shelter_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ɹǝʇꞁǝɥS",
  "item.minecraft.shield": "pꞁǝᴉɥS",
  "item.minecraft.shield.black": "pꞁǝᴉɥS ʞɔɐꞁᗺ",
  "item.minecraft.shield.blue": "pꞁǝᴉɥS ǝnꞁᗺ",
  "item.minecraft.shield.brown": "pꞁǝᴉɥS uʍoɹᗺ",
  "item.minecraft.shield.cyan": "pꞁǝᴉɥS uɐʎƆ",
  "item.minecraft.shield.gray": "pꞁǝᴉɥS ʎǝɹ⅁",
  "item.minecraft.shield.green": "pꞁǝᴉɥS uǝǝɹ⅁",
  "item.minecraft.shield.light_blue": "pꞁǝᴉɥS ǝnꞁᗺ ʇɥᵷᴉꞀ",
  "item.minecraft.shield.light_gray": "pꞁǝᴉɥS ʎǝɹ⅁ ʇɥᵷᴉꞀ",
  "item.minecraft.shield.lime": "pꞁǝᴉɥS ǝɯᴉꞀ",
  "item.minecraft.shield.magenta": "pꞁǝᴉɥS ɐʇuǝᵷɐW",
  "item.minecraft.shield.orange": "pꞁǝᴉɥS ǝᵷuɐɹO",
  "item.minecraft.shield.pink": "pꞁǝᴉɥS ʞuᴉԀ",
  "item.minecraft.shield.purple": "pꞁǝᴉɥS ǝꞁdɹnԀ",
  "item.minecraft.shield.red": "pꞁǝᴉɥS pǝᴚ",
  "item.minecraft.shield.white": "pꞁǝᴉɥS ǝʇᴉɥM",
  "item.minecraft.shield.yellow": "pꞁǝᴉɥS ʍoꞁꞁǝ⅄",
  "item.minecraft.shulker_shell": "ꞁꞁǝɥS ɹǝʞꞁnɥS",
  "item.minecraft.shulker_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝʞꞁnɥS",
  "item.minecraft.sign": "uᵷᴉS",
  "item.minecraft.silence_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.silence_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ǝɔuǝꞁᴉS",
  "item.minecraft.silverfish_spawn_egg": "ᵷᵷƎ uʍɐdS ɥsᴉɟɹǝʌꞁᴉS",
  "item.minecraft.skeleton_horse_spawn_egg": "ᵷᵷƎ uʍɐdS ǝsɹoH uoʇǝꞁǝʞS",
  "item.minecraft.skeleton_spawn_egg": "ᵷᵷƎ uʍɐdS uoʇǝꞁǝʞS",
  "item.minecraft.skull_banner_pattern": "uɹǝʇʇɐԀ ɹǝuuɐᗺ",
  "item.minecraft.skull_banner_pattern.desc": "ǝᵷɹɐɥƆ ꞁꞁnʞS",
  "item.minecraft.skull_banner_pattern.new": "uɹǝʇʇɐԀ ɹǝuuɐᗺ ǝᵷɹɐɥƆ ꞁꞁnʞS",
  "item.minecraft.skull_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ꞁꞁnʞS",
  "item.minecraft.skull_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ꞁꞁnʞS",
  "item.minecraft.slime_ball": "ꞁꞁɐqǝɯᴉꞁS",
  "item.minecraft.slime_spawn_egg": "ᵷᵷƎ uʍɐdS ǝɯᴉꞁS",
  "item.minecraft.smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.smithing_template.applies_to": ":oʇ sǝᴉꞁddⱯ",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "ꞁɐʇsʎɹɔ ɐ ɹo ʇoᵷuᴉ uɐ ppⱯ",
  "item.minecraft.smithing_template.armor_trim.applies_to": "ɹnoɯɹⱯ",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "ɹnoɯɹɐ ɟo ǝɔǝᴉd ɐ ppⱯ",
  "item.minecraft.smithing_template.armor_trim.ingredients": "sꞁɐʇsʎɹƆ ⅋ sʇoᵷuI",
  "item.minecraft.smithing_template.ingredients": ":sʇuǝᴉpǝɹᵷuI",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "ʇoᵷuI ǝʇᴉɹǝɥʇǝN ɐ ppⱯ",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "ʇuǝɯdᴉnbƎ puoɯɐᴉᗡ",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "ꞁooʇ ɐ ɹo uodɐǝʍ ɐ 'ɹnoɯɹɐ puoɯɐᴉp ppⱯ",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "ʇoᵷuI ǝʇᴉɹǝɥʇǝN",
  "item.minecraft.smithing_template.upgrade": " :ǝpɐɹᵷd∩",
  "item.minecraft.sniffer_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝɟɟᴉuS",
  "item.minecraft.snort_pottery_shard": "pɹɐɥS ʎɹǝʇʇoԀ ʇɹouS",
  "item.minecraft.snort_pottery_sherd": "pɹǝɥS ʎɹǝʇʇoԀ ʇɹouS",
  "item.minecraft.snout_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.snout_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ʇnouS",
  "item.minecraft.snow_golem_spawn_egg": "ᵷᵷƎ uʍɐdS ɯǝꞁo⅁ ʍouS",
  "item.minecraft.snowball": "ꞁꞁɐqʍouS",
  "item.minecraft.spectral_arrow": "ʍoɹɹⱯ ꞁɐɹʇɔǝdS",
  "item.minecraft.spider_eye": "ǝʎƎ ɹǝpᴉdS",
  "item.minecraft.spider_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝpᴉdS",
  "item.minecraft.spire_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.spire_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ǝɹᴉdS",
  "item.minecraft.splash_potion": "uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.awkward": "uoᴉʇoԀ ɥsɐꞁdS pɹɐʍʞʍⱯ",
  "item.minecraft.splash_potion.effect.empty": "uoᴉʇoԀ ǝꞁqɐʇɟɐɹɔu∩ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.fire_resistance": "ǝɔuɐʇsᴉsǝᴚ ǝɹᴉℲ ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.harming": "ᵷuᴉɯɹɐH ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.healing": "ᵷuᴉꞁɐǝH ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.infested": "uoᴉʇɐʇsǝɟuI ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.invisibility": "ʎʇᴉꞁᴉqᴉsᴉʌuI ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.leaping": "ᵷuᴉdɐǝꞀ ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.levitation": "uoᴉʇɐʇᴉʌǝꞀ ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.luck": "ʞɔnꞀ ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.mundane": "uoᴉʇoԀ ɥsɐꞁdS ǝuɐpunW",
  "item.minecraft.splash_potion.effect.night_vision": "uoᴉsᴉɅ ʇɥᵷᴉN ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.oozing": "ᵷuᴉzoO ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.poison": "uosᴉoԀ ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.regeneration": "uoᴉʇɐɹǝuǝᵷǝᴚ ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.slow_falling": "ᵷuᴉꞁꞁɐℲ ʍoꞁS ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.slowness": "ssǝuʍoꞁS ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.strength": "ɥʇᵷuǝɹʇS ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.swiftness": "ssǝuʇɟᴉʍS ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.thick": "uoᴉʇoԀ ɥsɐꞁdS ʞɔᴉɥ⟘",
  "item.minecraft.splash_potion.effect.turtle_master": "ɹǝʇsɐW ǝꞁʇɹn⟘ ǝɥʇ ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.water": "ǝꞁʇʇoᗺ ɹǝʇɐM ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.water_breathing": "ᵷuᴉɥʇɐǝɹᗺ ɹǝʇɐM ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.weakness": "ssǝuʞɐǝM ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.weaving": "ᵷuᴉʌɐǝM ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.splash_potion.effect.wind_charged": "ᵷuᴉᵷɹɐɥƆ puᴉM ɟo uoᴉʇoԀ ɥsɐꞁdS",
  "item.minecraft.spruce_boat": "ʇɐoᗺ ǝɔnɹdS",
  "item.minecraft.spruce_chest_boat": "ʇsǝɥƆ ɥʇᴉʍ ʇɐoᗺ ǝɔnɹdS",
  "item.minecraft.spyglass": "ssɐꞁᵷʎdS",
  "item.minecraft.squid_spawn_egg": "ᵷᵷƎ uʍɐdS pᴉnbS",
  "item.minecraft.stick": "ʞɔᴉʇS",
  "item.minecraft.stone_axe": "ǝxⱯ ǝuoʇS",
  "item.minecraft.stone_hoe": "ǝoH ǝuoʇS",
  "item.minecraft.stone_pickaxe": "ǝxɐʞɔᴉԀ ǝuoʇS",
  "item.minecraft.stone_shovel": "ꞁǝʌoɥS ǝuoʇS",
  "item.minecraft.stone_spear": "ɹɐǝdS ǝuoʇS",
  "item.minecraft.stone_sword": "pɹoʍS ǝuoʇS",
  "item.minecraft.stray_spawn_egg": "ᵷᵷƎ uʍɐdS ʎɐɹʇS",
  "item.minecraft.strider_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝpᴉɹʇS",
  "item.minecraft.string": "ᵷuᴉɹʇS",
  "item.minecraft.sugar": "ɹɐᵷnS",
  "item.minecraft.suspicious_stew": "ʍǝʇS snoᴉɔᴉdsnS",
  "item.minecraft.sweet_berries": "sǝᴉɹɹǝᗺ ʇǝǝʍS",
  "item.minecraft.tadpole_bucket": "ǝꞁodpɐ⟘ ɟo ʇǝʞɔnᗺ",
  "item.minecraft.tadpole_spawn_egg": "ᵷᵷƎ uʍɐdS ǝꞁodpɐ⟘",
  "item.minecraft.tide_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.tide_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ǝpᴉ⟘",
  "item.minecraft.tipped_arrow": "ʍoɹɹⱯ pǝddᴉ⟘",
  "item.minecraft.tipped_arrow.effect.awkward": "ʍoɹɹⱯ pǝddᴉ⟘",
  "item.minecraft.tipped_arrow.effect.empty": "ʍoɹɹⱯ pǝddᴉ⟘ ǝꞁqɐʇɟɐɹɔu∩",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "ǝɔuɐʇsᴉsǝᴚ ǝɹᴉℲ ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.harming": "ᵷuᴉɯɹɐH ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.healing": "ᵷuᴉꞁɐǝH ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.infested": "uoᴉʇɐʇsǝɟuI ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.invisibility": "ʎʇᴉꞁᴉqᴉsᴉʌuI ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.leaping": "ᵷuᴉdɐǝꞀ ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.levitation": "uoᴉʇɐʇᴉʌǝꞀ ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.luck": "ʞɔnꞀ ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.mundane": "ʍoɹɹⱯ pǝddᴉ⟘",
  "item.minecraft.tipped_arrow.effect.night_vision": "uoᴉsᴉɅ ʇɥᵷᴉN ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.oozing": "ᵷuᴉzoO ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.poison": "uosᴉoԀ ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.regeneration": "uoᴉʇɐɹǝuǝᵷǝᴚ ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.slow_falling": "ᵷuᴉꞁꞁɐℲ ʍoꞁS ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.slowness": "ssǝuʍoꞁS ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.strength": "ɥʇᵷuǝɹʇS ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.swiftness": "ssǝuʇɟᴉʍS ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.thick": "ʍoɹɹⱯ pǝddᴉ⟘",
  "item.minecraft.tipped_arrow.effect.turtle_master": "ɹǝʇsɐW ǝꞁʇɹn⟘ ǝɥʇ ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.water": "ᵷuᴉɥsɐꞁdS ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.water_breathing": "ᵷuᴉɥʇɐǝɹᗺ ɹǝʇɐM ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.weakness": "ssǝuʞɐǝM ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.weaving": "ᵷuᴉʌɐǝM ɟo ʍoɹɹⱯ",
  "item.minecraft.tipped_arrow.effect.wind_charged": "ᵷuᴉᵷɹɐɥƆ puᴉM ɟo ʍoɹɹⱯ",
  "item.minecraft.tnt_minecart": "⟘N⟘ ɥʇᴉʍ ʇɹɐɔǝuᴉW",
  "item.minecraft.torchflower_seeds": "spǝǝS ɹǝʍoꞁɟɥɔɹo⟘",
  "item.minecraft.totem_of_undying": "ᵷuᴉʎpu∩ ɟo ɯǝʇo⟘",
  "item.minecraft.trader_llama_spawn_egg": "ᵷᵷƎ uʍɐdS ɐɯɐꞁꞀ ɹǝpɐɹ⟘",
  "item.minecraft.trial_key": "ʎǝꞰ ꞁɐᴉɹ⟘",
  "item.minecraft.trident": "ʇuǝpᴉɹ⟘",
  "item.minecraft.tropical_fish": "ɥsᴉℲ ꞁɐɔᴉdoɹ⟘",
  "item.minecraft.tropical_fish_bucket": "ɥsᴉℲ ꞁɐɔᴉdoɹ⟘ ɟo ʇǝʞɔnᗺ",
  "item.minecraft.tropical_fish_spawn_egg": "ᵷᵷƎ uʍɐdS ɥsᴉℲ ꞁɐɔᴉdoɹ⟘",
  "item.minecraft.turtle_helmet": "ꞁꞁǝɥS ǝꞁʇɹn⟘",
  "item.minecraft.turtle_scute": "ǝʇnɔS ǝꞁʇɹn⟘",
  "item.minecraft.turtle_spawn_egg": "ᵷᵷƎ uʍɐdS ǝꞁʇɹn⟘",
  "item.minecraft.vex_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.vex_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ xǝɅ",
  "item.minecraft.vex_spawn_egg": "ᵷᵷƎ uʍɐdS xǝɅ",
  "item.minecraft.villager_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝᵷɐꞁꞁᴉɅ",
  "item.minecraft.vindicator_spawn_egg": "ᵷᵷƎ uʍɐdS ɹoʇɐɔᴉpuᴉɅ",
  "item.minecraft.wandering_trader_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝpɐɹ⟘ ᵷuᴉɹǝpuɐM",
  "item.minecraft.ward_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.ward_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ pɹɐM",
  "item.minecraft.warden_spawn_egg": "ᵷᵷƎ uʍɐdS uǝpɹɐM",
  "item.minecraft.warped_fungus_on_a_stick": "ʞɔᴉʇS ɐ uo snᵷunℲ pǝdɹɐM",
  "item.minecraft.water_bucket": "ʇǝʞɔnᗺ ɹǝʇɐM",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ ɹǝpuᴉɟʎɐM",
  "item.minecraft.wheat": "ʇɐǝɥM",
  "item.minecraft.wheat_seeds": "spǝǝS ʇɐǝɥM",
  "item.minecraft.white_bundle": "ǝꞁpunᗺ ǝʇᴉɥM",
  "item.minecraft.white_dye": "ǝʎᗡ ǝʇᴉɥM",
  "item.minecraft.white_harness": "ssǝuɹɐH ǝʇᴉɥM",
  "item.minecraft.wild_armor_trim_smithing_template": "ǝʇɐꞁdɯǝ⟘ ᵷuᴉɥʇᴉɯS",
  "item.minecraft.wild_armor_trim_smithing_template.new": "ɯᴉɹ⟘ ɹnoɯɹⱯ pꞁᴉM",
  "item.minecraft.wind_charge": "ǝᵷɹɐɥƆ puᴉM",
  "item.minecraft.witch_spawn_egg": "ᵷᵷƎ uʍɐdS ɥɔʇᴉM",
  "item.minecraft.wither_skeleton_spawn_egg": "ᵷᵷƎ uʍɐdS uoʇǝꞁǝʞS ɹǝɥʇᴉM",
  "item.minecraft.wither_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝɥʇᴉM",
  "item.minecraft.wolf_armor": "ɹnoɯɹⱯ ɟꞁoM",
  "item.minecraft.wolf_spawn_egg": "ᵷᵷƎ uʍɐdS ɟꞁoM",
  "item.minecraft.wooden_axe": "ǝxⱯ uǝpooM",
  "item.minecraft.wooden_hoe": "ǝoH uǝpooM",
  "item.minecraft.wooden_pickaxe": "ǝxɐʞɔᴉԀ uǝpooM",
  "item.minecraft.wooden_shovel": "ꞁǝʌoɥS uǝpooM",
  "item.minecraft.wooden_spear": "ɹɐǝdS uǝpooM",
  "item.minecraft.wooden_sword": "pɹoʍS uǝpooM",
  "item.minecraft.writable_book": "ꞁꞁᴉnꝹ puɐ ʞooᗺ",
  "item.minecraft.written_book": "ʞooᗺ uǝʇʇᴉɹM",
  "item.minecraft.yellow_bundle": "ǝꞁpunᗺ ʍoꞁꞁǝ⅄",
  "item.minecraft.yellow_dye": "ǝʎᗡ ʍoꞁꞁǝ⅄",
  "item.minecraft.yellow_harness": "ssǝuɹɐH ʍoꞁꞁǝ⅄",
  "item.minecraft.zoglin_spawn_egg": "ᵷᵷƎ uʍɐdS uᴉꞁᵷoZ",
  "item.minecraft.zombie_horse_spawn_egg": "ᵷᵷƎ uʍɐdS ǝsɹoH ǝᴉqɯoZ",
  "item.minecraft.zombie_nautilus_spawn_egg": "ᵷᵷƎ uʍɐdS snꞁᴉʇnɐN ǝᴉqɯoZ",
  "item.minecraft.zombie_spawn_egg": "ᵷᵷƎ uʍɐdS ǝᴉqɯoZ",
  "item.minecraft.zombie_villager_spawn_egg": "ᵷᵷƎ uʍɐdS ɹǝᵷɐꞁꞁᴉɅ ǝᴉqɯoZ",
  "item.minecraft.zombified_piglin_spawn_egg": "ᵷᵷƎ uʍɐdS uᴉꞁᵷᴉԀ pǝᴉɟᴉqɯoZ"
}
export const en_ud = items; 
